{
  "common": {
    "loading": "ஏற்றுகிறது...",
    "error": "பிழை",
    "retry": "மீண்டும் முயற்சிக்கவும்",
    "cancel": "ரத்து செய்",
    "save": "சேமி",
    "saving": "சேமிக்கிறது...",
    "close": "மூடு",
    "back": "பின்",
    "next": "அடுத்து",
    "search": "தேடு",
    "watchNow": "இப்போது பாருங்கள்",
    "playNow": "இப்போது இயக்கு",
    "play": "இயக்கு",
    "moreInfo": "மேலும் தகவல்",
    "seeAll": "அனைத்தையும் காண்",
    "new": "புதிய",
    "live": "நேரலை",
    "recommended": "பரிந்துரைக்கப்பட்டது",
    "edit": "திருத்து",
    "delete": "நீக்கு",
    "add": "சேர்",
    "enabled": "இயக்கப்பட்டது",
    "disabled": "முடக்கப்பட்டது",
    "invalidDate": "தவறான தேதி",
    "appName": "🏠 Bayit+",
    "appVersion": "🏠 Bayit+ v1.0.0",
    "slogan": "உங்கள் வீடு. எங்கும்.",
    "ok": "சரி",
    "success": "வெற்றி",
    "warning": "எச்சரிக்கை",
    "confirm": "உறுதிப்படுத்து",
    "yes": "ஆம்",
    "no": "இல்லை",
    "apply": "பயன்படுத்து",
    "errors": {
      "unexpected": "எதிர்பாராத பிழை ஏற்பட்டது"
    },
    "send": "அனுப்பு",
    "done": "முடிந்தது",
    "all": "அனைத்தும்",
    "reset": "மீட்டமை",
    "deleting": "நீக்குகிறது...",
    "noResults": "முடிவுகள் இல்லை",
    "tryDifferentSearch": "வேறு தேடல் சொல்லை முயற்சிக்கவும்",
    "previous": "முந்தைய",
    "actions": "செயல்கள்",
    "pageOf": "பக்கம் {{page}} / {{total}}",
    "noData": "தரவு இல்லை",
    "filters": "வடிகட்டிகள்",
    "clear": "அழி",
    "clearSelection": "[ta] Clear",
    "expand": "விரிவாக்கு",
    "collapse": "சுருக்கு",
    "upgrade": "பிரீமியத்திற்கு மேம்படுத்து",
    "skip": "தவிர்",
    "thisContent": "[ta] this content",
    "backToHome": "[ta] Back to Home",
    "dismiss": "[ta] Dismiss",
    "goBack": "[ta] Go Back",
    "pause": "[ta] Pause",
    "tryAgain": "[ta] Try Again",
    "refresh": "புதுப்பி"
  },
  "culturalContext": {
    "loading": "விளக்கம் ஏற்றுகிறது...",
    "loadError": "விளக்கம் ஏற்றுவதில் தோல்வி",
    "related": "தொடர்புடைய குறிப்புகள்"
  },
  "demo": {
    "banner": "டெமோ பயன்முறை",
    "bannerSubtext": "போலி தரவைப் பயன்படுத்துகிறது",
    "days": {
      "sunday": "ஞாயிறு",
      "monday": "திங்கள்",
      "tuesday": "செவ்வாய்",
      "wednesday": "புதன்",
      "thursday": "வியாழன்",
      "friday": "வெள்ளி",
      "saturday": "சனி"
    },
    "shabbat": "ஷப்பத்",
    "until_shabbat": "ஷப்பத் வரை",
    "search_interpretation": "[ta] Search for \"{{query}}\"",
    "suggestions": {
      "0": "[ta] Fauda",
      "1": "[ta] Shtisel",
      "2": "[ta] Tehran",
      "3": "[ta] The Arbitrator",
      "4": "[ta] Labour"
    },
    "premium_plan": "பிரீமியம்",
    "assistant_response": "[ta] I recommend Fauda - an excellent thriller series!",
    "morning_greeting": "[ta] Good morning! Today the weather is nice, there are some important news from Israel, and I've selected content especially for you."
  },
  "hero": {
    "watch": "பார்",
    "moreInfo": "மேலும் தகவல்",
    "addToList": "பட்டியலில் சேர்"
  },
  "login": {
    "title": "மீண்டும் வரவேற்கிறோம்",
    "subtitle": "Bayit+ தொடர உள்நுழையவும்",
    "tagline": "USA இல் உங்கள் வீடு",
    "email": "மின்னஞ்சல்",
    "emailPlaceholder": "உங்கள் மின்னஞ்சலை உள்ளிடவும்",
    "password": "கடவுச்சொல்",
    "passwordPlaceholder": "உங்கள் கடவுச்சொல்லை உள்ளிடவும்",
    "submit": "உள்நுழை",
    "loggingIn": "உள்நுழைகிறது...",
    "or": "அல்லது",
    "forgotPassword": "கடவுச்சொல் மறந்துவிட்டதா?",
    "continueWithGoogle": "Google உடன் தொடரவும்",
    "noAccount": "கணக்கு இல்லையா?",
    "signUp": "பதிவு செய்யவும்",
    "register": "பதிவு",
    "name": "பெயர்",
    "termsNotice": "[ta] By signing in, you agree to our Terms of Service and Privacy Policy",
    "errors": {
      "emailRequired": "மின்னஞ்சல் தேவை",
      "passwordRequired": "கடவுச்சொல் தேவை",
      "loginFailed": "உள்நுழைவு தோல்வி.",
      "googleFailed": "[ta] Google sign-in failed. Please try again.",
      "fillAllFields": "அனைத்து புலங்களையும் நிரப்பவும்"
    },
    "qrInstructions": "[ta] Scan the code with your phone for quick login",
    "methodQR": "[ta] QR Code",
    "methodVoice": "[ta] Voice",
    "methodTraditional": "[ta] Email",
    "qrTitle": "[ta] Scan to Login",
    "qrDescription": "[ta] Scan this QR code with your phone to login without typing",
    "expiresIn": "[ta] Expires in 5 minutes",
    "companionConnected": "[ta] Phone connected!",
    "authenticating": "[ta] Logging you in...",
    "sessionExpired": "[ta] Session expired",
    "refreshQR": "[ta] Generate New Code",
    "generatingQR": "[ta] Generating QR code...",
    "howItWorks": "[ta] How it works:",
    "step1": "[ta] Open camera on your phone",
    "step2": "[ta] Scan the QR code above",
    "step3": "[ta] Login on your phone",
    "step4": "[ta] TV logs in automatically!",
    "voicePlaceholder": "[ta] Type your response...",
    "send": "[ta] Send",
    "createAccount": "[ta] Create Account",
    "bayitThinking": "[ta] Bayit is thinking...",
    "unexpectedError": "[ta] An unexpected error occurred"
  },
  "tvLogin": {
    "invalidQR": "[ta] Invalid QR code. Please scan again from your TV.",
    "sessionInvalid": "[ta] This QR code has expired. Please generate a new one on your TV.",
    "verificationFailed": "[ta] Failed to verify session. Please try again.",
    "fillAllFields": "[ta] Please fill in all fields",
    "loginFailed": "[ta] Login failed. Please check your credentials.",
    "notLoggedIn": "[ta] You are not logged in on this device.",
    "enterCredentials": "[ta] Please enter your credentials to authorize your TV.",
    "authFailed": "[ta] Authorization failed.",
    "verifying": "[ta] Verifying...",
    "verifyingDescription": "[ta] Connecting to your TV...",
    "loginTitle": "[ta] Login to Your TV",
    "loginDescription": "[ta] Enter your credentials to authorize your TV",
    "authorizing": "[ta] Authorizing...",
    "authorizingDescription": "[ta] Logging you in on your TV...",
    "authorizeTV": "[ta] Authorize TV",
    "success": "[ta] Success!",
    "successDescription": "[ta] Your TV is now logged in. You can close this page.",
    "goToHome": "[ta] Go to Home",
    "error": "[ta] Something went wrong",
    "tryAgain": "[ta] Try Again",
    "securityNote": "[ta] Your credentials are sent securely and are never stored on the TV.",
    "footer": "[ta] Having trouble? Make sure you scanned a fresh QR code from your TV.",
    "almostThere": "[ta] Almost there!",
    "authenticating": "[ta] Authenticating...",
    "connected": "[ta] Connected",
    "expired": "[ta] Code Expired",
    "expiredMessage": "[ta] Your sign-in code has expired. Please request a new one.",
    "header": "[ta] Sign In to TV",
    "pleaseSignIn": "[ta] Please sign in on your phone or computer",
    "signInButton": "[ta] Sign In",
    "signInToTV": "[ta] Sign In to TV",
    "subtitle": "[ta] Enter the code shown on your TV screen",
    "tvSignedIn": "[ta] TV signed in successfully"
  },
  "googleLogin": {
    "cancelledError": "[ta] Google sign-in was cancelled",
    "missingCode": "[ta] Authentication code is missing",
    "loginError": "[ta] Error signing in with Google",
    "redirecting": "[ta] Redirecting to login page...",
    "connecting": "[ta] Connecting with Google..."
  },
  "register": {
    "title": "கணக்கை உருவாக்கு",
    "subtitle": "உங்கள் விருப்பமான உள்ளடக்கத்தைப் பார்க்க Bayit+ இல் சேரவும்",
    "name": "முழு பெயர்",
    "namePlaceholder": "குமார் முருகன்",
    "email": "மின்னஞ்சல்",
    "emailPlaceholder": "your@email.com",
    "password": "கடவுச்சொல்",
    "passwordPlaceholder": "குறைந்தது 8 எழுத்துகள்",
    "confirmPassword": "கடவுச்சொல்லை உறுதிப்படுத்து",
    "confirmPasswordPlaceholder": "கடவுச்சொல்லை மீண்டும் உள்ளிடவும்",
    "submit": "பதிவு செய்",
    "registering": "[ta] Signing up...",
    "acceptTerms": "நான் ஒப்புக்கொள்கிறேன்",
    "termsOfService": "சேவை விதிமுறைகள்",
    "and": "மற்றும்",
    "privacyPolicy": "தனியுரிமைக் கொள்கை",
    "continueWithGoogle": "[ta] Sign up with Google",
    "haveAccount": "ஏற்கனவே கணக்கு உள்ளதா?",
    "signIn": "உள்நுழையவும்",
    "fullName": "[ta] Full Name",
    "loginLink": "[ta] Login",
    "placeholders": {
      "fullName": "[ta] John Doe",
      "email": "[ta] your@email.com",
      "password": "[ta] At least 8 characters",
      "confirmPassword": "[ta] Enter password again"
    },
    "errors": {
      "nameRequired": "[ta] Name is required",
      "emailRequired": "[ta] Email is required",
      "passwordRequired": "[ta] Password is required",
      "passwordTooShort": "[ta] Password must be at least 8 characters",
      "passwordMismatch": "[ta] Passwords do not match",
      "acceptTerms": "[ta] You must accept the Terms of Service and Privacy Policy",
      "fillAllFields": "[ta] Please fill in all fields",
      "registrationFailed": "[ta] Registration failed. Please try again.",
      "googleFailed": "[ta] Sign up with Google failed. Please try again."
    }
  },
  "nav": {
    "home": "முகப்பு",
    "vod": "VOD",
    "liveTV": "நேரலை TV",
    "epg": "TV வழிகாட்டி",
    "radio": "வானொலி",
    "podcasts": "பாட்காஸ்ட்கள்",
    "flows": "ஃப்ளோக்கள்",
    "judaism": "யூதமதம்",
    "children": "குழந்தைகள்",
    "profile": "சுயவிவரம்",
    "search": "தேடு",
    "settings": "அமைப்புகள்",
    "favorites": "பிடித்தவை",
    "watchlist": "கண்காணிப்பு பட்டியல்",
    "downloads": "பதிவிறக்கங்கள்",
    "recordings": "என் பதிவுகள்",
    "widgets": "விட்ஜெட்கள்",
    "help": "உதவி",
    "discover": "[ta] Discover",
    "account": "கணக்கு",
    "subscribe": "சந்தா செலுத்து",
    "plans": "[ta] Plans",
    "admin": "நிர்வாகி",
    "games": "விளையாட்டுகள்",
    "friends": "நண்பர்கள்",
    "glossary": "சொற்களஞ்சியம்",
    "missions": "பணிகள்",
    "audiobooks": "ஒலிப்புத்தகங்கள்",
    "playlist": "பிளேலிஸ்ட்",
    "zehAniHub": "ஜே அனி",
    "support": "ஆதரவு",
    "discoverHub": "AI கண்டறி",
    "listen": "கேளுங்கள்",
    "byoc": "என் ஆதாரங்கள்",
    "household": "குடும்பம்",
    "messages": "செய்திகள்",
    "myContent": "என் உள்ளடக்கம்",
    "social": "சமூகம்"
  },
  "epg": {
    "title": "TV வழிகாட்டி",
    "subtitle": "நேரலை TV நிரல் அட்டவணை",
    "gridView": "கிரிட் பார்வை",
    "listView": "பட்டியல் பார்வை",
    "israelTime": "இஸ்ரேல் நேரம்",
    "localTime": "உள்ளூர் நேரம்",
    "il": "[ta] IL",
    "local": "[ta] Local",
    "jumpToNow": "இப்போதுக்கு செல்",
    "goBack": "[ta] ← {{hours}}h",
    "goForward": "[ta] {{hours}}h →",
    "toggleTimezone": "[ta] Toggle Timezone",
    "errorTitle": "TV வழிகாட்டி ஏற்ற முடியவில்லை",
    "errorLoading": "[ta] Could not load TV guide data",
    "noPrograms": "நிரல்கள் இல்லை",
    "noChannels": "சேனல்கள் இல்லை",
    "recordProgram": "[ta] Record Program",
    "channel": "[ta] Channel",
    "enableSubtitles": "[ta] Enable Subtitles",
    "subtitleLanguage": "[ta] Subtitle Language",
    "storageEstimate": "[ta] Storage Estimate",
    "availableSpace": "[ta] Available Space",
    "lowStorage": "[ta] Low Storage Warning",
    "lowStorageMessage": "[ta] You're running low on storage space. Consider deleting old recordings.",
    "scheduleRecording": "[ta] Schedule Recording",
    "scheduledRecordingNotSupported": "[ta] Scheduled recordings are not yet supported. Only immediate recordings are available.",
    "recordingFailed": "[ta] Failed to start/schedule recording",
    "smartSearch": "[ta] Smart Search",
    "smartSearchSubtitle": "[ta] Ask questions in natural language",
    "smartSearchPlaceholder": "[ta] e.g., Show me all shows with actress Tali Sharon tonight",
    "searchPlaceholder": "[ta] Search programs, channels, actors...",
    "premiumRequired": "[ta] Premium Feature",
    "premiumRequiredMessage": "[ta] Smart Search uses AI to understand your questions. Upgrade to Premium to access this feature.",
    "searchWithAI": "[ta] Search with AI",
    "searching": "[ta] Searching...",
    "tryThese": "[ta] Try these examples",
    "exampleQuery1": "[ta] Show me all shows with actress Tali Sharon tonight",
    "exampleQuery2": "[ta] What comedy shows are airing this week?",
    "exampleQuery3": "[ta] Find documentaries about history on Channel 11",
    "exampleQuery4": "[ta] Show me all news programs tomorrow morning",
    "aiDisclaimer": "[ta] Powered by Claude AI. Results may vary based on program data availability.",
    "interpretationTitle": "[ta] What I understood",
    "noResultsFound": "[ta] No programs found matching your query"
  },
  "home": {
    "continueWatching": "தொடர்ந்து பாருங்கள்",
    "featuredContent": "சிறப்பு",
    "liveTV": "நேரலை TV",
    "allChannels": "அனைத்து சேனல்கள்",
    "liveChannels": "நேரலை சேனல்கள்",
    "showOnlyWithSubtitles": "[ta] Show only with subtitles",
    "israeliMovies": "இஸ்ரேலி திரைப்படங்கள்",
    "israeli-movies": "[ta] Israeli Movies",
    "israeli-series": "[ta] Israeli Series",
    "action": "[ta] Action & Thriller",
    "comedy": "நகைச்சுவை",
    "drama": "நாடகம்",
    "documentaries": "ஆவணப்படங்கள்",
    "loadingContent": "உள்ளடக்கம் ஏற்றுகிறது...",
    "liveNow": "இப்போது நேரலை",
    "trendingInIsrael": "[ta] Trending in Israel",
    "jerusalemConnection": "[ta] Jerusalem Connection",
    "telAvivConnection": "[ta] Tel Aviv Connection",
    "categories": "வகைகள்",
    "nearYou": "அருகிலுள்ள இஸ்ரேலியர்கள்",
    "betaExclusive": "பீட்டா எக்ஸ்க்ளூசிவ்",
    "carousel": {
      "fauda": {
        "title": "[ta] Fauda",
        "subtitle": "[ta] Season 4 - Now Streaming",
        "description": "[ta] The hit Israeli series returns for a fourth season full of suspense and action"
      },
      "shtisel": {
        "title": "[ta] Shtisel",
        "subtitle": "[ta] All Seasons Available",
        "description": "[ta] Follow the Shtisel family in the ultra-Orthodox neighborhood of Jerusalem"
      },
      "tehran": {
        "title": "[ta] Tehran",
        "subtitle": "[ta] Season 2",
        "description": "[ta] A Mossad agent deep in Iran on a dangerous mission"
      },
      "live": {
        "title": "[ta] Live - Kan 11",
        "subtitle": "[ta] Watch Now",
        "description": "[ta] News, current affairs and quality content"
      }
    },
    "enableLocation": "[ta] Enable Location",
    "locationPermissionDeniedDescription": "[ta] Location access was denied. Enable it in Settings to see content near you.",
    "locationPermissionDescription": "[ta] Allow location access to discover content near you.",
    "openSettings": "[ta] Open Settings"
  },
  "search": {
    "title": "தேடு",
    "subtitle": "திரைப்படங்கள், தொடர்கள், சேனல்கள், வானொலி மற்றும் பாட்காஸ்ட்களைத் தேடுங்கள்",
    "placeholder": "உள்ளடக்கத்தைத் தேடு...",
    "voicePlaceholder": "[ta] Speak now...",
    "searching": "தேடுகிறது...",
    "listening": "கேட்கிறது...",
    "noResults": "முடிவுகள் இல்லை",
    "noResultsHint": "[ta] Try different keywords or change your filters",
    "tryDifferent": "[ta] Try different search terms",
    "resultsFor": "[ta] results for",
    "resultsFound": "[ta] {{count}} results found for \"{{query}}\"",
    "recentSearches": "சமீபத்திய தேடல்கள்",
    "clearAll": "அனைத்தையும் அழி",
    "trending": "[ta] Trending Searches",
    "promptTitle": "[ta] What are you looking for?",
    "promptDescription": "[ta] Search for your favorite content or use voice search",
    "filters": {
      "all": "அனைத்தும்",
      "vod": "திரைப்படங்கள் & தொடர்கள்",
      "live": "சேனல்கள்",
      "radio": "வானொலி",
      "podcast": "பாட்காஸ்ட்",
      "moviesAndSeries": "[ta] Movies & Series",
      "channels": "[ta] Channels",
      "podcasts": "[ta] Podcasts"
    },
    "suggestions": {
      "movies": "[ta] Movies",
      "series": "[ta] Series",
      "liveTV": "[ta] Live TV",
      "news": "[ta] News",
      "sports": "[ta] Sports",
      "kids": "[ta] Kids"
    }
  },
  "liveTV": {
    "title": "நேரலை TV",
    "channels": "சேனல்கள்",
    "nowPlaying": "இப்போது இயங்குகிறது",
    "loadError": "சேனல்களை ஏற்ற முடியவில்லை",
    "categories": {
      "all": "அனைத்தும்",
      "news": "செய்திகள்",
      "sports": "விளையாட்டு",
      "entertainment": "பொழுதுபோக்கு",
      "kids": "குழந்தைகள்",
      "documentary": "ஆவணப்படம்"
    }
  },
  "listen": {
    "title": "கேளுங்கள்",
    "subtitle": "வானொலி, பாட்காஸ்ட் மற்றும் ஆடியோ புத்தகங்கள்",
    "tab": {
      "radio": "வானொலி",
      "podcasts": "பாட்காஸ்ட்",
      "audiobooks": "ஆடியோ புத்தகங்கள்"
    }
  },
  "radio": {
    "title": "வானொலி",
    "categories": {
      "all": "அனைத்தும்",
      "music": "இசை",
      "news": "செய்திகள்",
      "talk": "பேச்சு",
      "jewish": "யூத"
    },
    "noStations": "வானொலி நிலையங்கள் இல்லை",
    "tryLater": "பின்னர் மீண்டும் முயற்சிக்கவும்",
    "playing": "இயங்குகிறது",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "பாட்காஸ்ட்கள்",
    "episodes": "அத்தியாயங்கள்",
    "categories": {
      "all": "அனைத்தும்",
      "general": "பொது",
      "news": "செய்திகள்",
      "politics": "அரசியல்",
      "tech": "தொழில்நுட்பம்",
      "business": "வணிகம்",
      "jewish": "யூத",
      "entertainment": "பொழுதுபோக்கு",
      "sports": "விளையாட்டு",
      "history": "வரலாறு",
      "educational": "கல்வி"
    },
    "noPodcasts": "பாட்காஸ்ட்கள் இல்லை",
    "tryLater": "[ta] Try again later",
    "playLatest": "[ta] Play Latest"
  },
  "vod": {
    "title": "திரைப்படங்கள் & தொடர்கள்",
    "movies": "திரைப்படங்கள்",
    "series": "தொடர்கள்",
    "searchPlaceholder": "திரைப்படங்கள் & தொடர்களைத் தேடு...",
    "noMovies": "திரைப்படங்கள் இல்லை",
    "noSeries": "தொடர்கள் இல்லை",
    "loadError": "உள்ளடக்கத்தை ஏற்ற முடியவில்லை",
    "showOnlyWithSubtitles": "[ta] Show only with subtitles",
    "categories": {
      "all": "அனைத்தும்",
      "drama": "நாடகம்",
      "comedy": "நகைச்சுவை",
      "action": "அதிரடி",
      "documentary": "ஆவணப்படம்",
      "kids": "குழந்தைகள்"
    },
    "allCategories": "[ta] All",
    "emptyTitle": "[ta] No Content Available",
    "emptyDescription": "[ta] Try selecting another category",
    "allContent": "[ta] All Content",
    "noContent": "[ta] No content available",
    "noContentInCategory": "[ta] No content found in this category"
  },
  "account": {
    "title": "என் கணக்கு",
    "profile": "சுயவிவரம்",
    "settings": "அமைப்புகள்",
    "subscription": "சந்தா",
    "manageSubscription": "[ta] Manage Subscription",
    "personalDetails": "[ta] Personal Details",
    "billing": "[ta] Billing & Payment",
    "logout": "வெளியேறு",
    "login": "உள்நுழை",
    "register": "[ta] Register",
    "email": "[ta] Email",
    "password": "[ta] Password",
    "name": "[ta] Name",
    "guest": "விருந்தினர்",
    "premium": "பிரீமியம்",
    "basic": "அடிப்படை"
  },
  "flows": {
    "title": "[ta] Flows",
    "subtitle": "[ta] Personalized content experiences for every moment",
    "activeNow": "[ta] Active Now",
    "start": "[ta] Start",
    "skipToday": "[ta] Skip Today",
    "systemFlows": "[ta] Ready-Made Flows",
    "customFlows": "[ta] My Flows",
    "system": "[ta] System",
    "noCustomFlows": "[ta] No custom flows yet",
    "createHint": "[ta] Create your first personalized flow",
    "createCustom": "[ta] Create Custom Flow",
    "createFlow": "[ta] Create Flow",
    "editFlow": "[ta] Edit Flow",
    "type": "[ta] Type",
    "systemFlow": "[ta] System Flow",
    "customFlow": "[ta] Custom Flow",
    "schedule": "[ta] Schedule",
    "content": "[ta] Content",
    "items": "[ta] items",
    "aiGenerated": "[ta] AI Generated",
    "autoPlay": "[ta] Auto Play",
    "aiEnabled": "[ta] AI Curation",
    "shabbatTrigger": "[ta] Shabbat Evening",
    "manual": "[ta] Manual",
    "flowName": "[ta] Flow Name",
    "flowNamePlaceholder": "[ta] e.g., My Morning Routine",
    "description": "[ta] Description",
    "descriptionPlaceholder": "[ta] What is this flow for?",
    "startTime": "[ta] Start Time",
    "endTime": "[ta] End Time",
    "actions": "[ta] Actions",
    "details": "[ta] Details",
    "createFlowDesc": "[ta] Design your personalized content experience",
    "editFlowDesc": "[ta] Update your flow settings and content",
    "basicInfo": "[ta] Basic Information",
    "options": "[ta] Options",
    "autoPlayDesc": "[ta] Automatically play next item when current one ends",
    "aiEnabledDesc": "[ta] Let AI curate content based on your preferences",
    "startFlow": "[ta] Start Flow",
    "deleteFlow": "[ta] Delete Flow",
    "custom": "[ta] Custom",
    "morning": "[ta] Morning",
    "evening": "[ta] Evening",
    "shabbat": "[ta] Shabbat",
    "addContent": "[ta] Add Content",
    "contentPicker": {
      "title": "[ta] Add Content to Flow",
      "tabs": {
        "live": "[ta] Live TV",
        "radio": "[ta] Radio",
        "vod": "[ta] On Demand",
        "podcast": "[ta] Podcasts"
      },
      "search": "[ta] Search content...",
      "selected": "[ta] {{count}} selected",
      "addSelected": "[ta] Add Selected",
      "noResults": "[ta] No content found",
      "alreadyAdded": "[ta] Already in flow",
      "loadMore": "[ta] Load More"
    },
    "flowItems": {
      "title": "[ta] Flow Content",
      "empty": "[ta] No content yet. Click Add Content to get started.",
      "count": "[ta] {{count}} items",
      "remove": "[ta] Remove",
      "moveUp": "[ta] Move Up",
      "moveDown": "[ta] Move Down",
      "order": "[ta] Order",
      "confirmRemove": "[ta] Click again to confirm removal",
      "maxReached": "[ta] Maximum {{max}} items reached",
      "more": "[ta] more items"
    },
    "days": {
      "sunday": "[ta] Sunday",
      "monday": "[ta] Monday",
      "tuesday": "[ta] Tuesday",
      "wednesday": "[ta] Wednesday",
      "thursday": "[ta] Thursday",
      "friday": "[ta] Friday",
      "saturday": "[ta] Saturday",
      "sundayShort": "[ta] Sun",
      "mondayShort": "[ta] Mon",
      "tuesdayShort": "[ta] Tue",
      "wednesdayShort": "[ta] Wed",
      "thursdayShort": "[ta] Thu",
      "fridayShort": "[ta] Fri",
      "saturdayShort": "[ta] Sat",
      "selectAll": "[ta] Select All",
      "deselectAll": "[ta] Deselect All",
      "title": "[ta] Active Days",
      "everyday": "[ta] Every day",
      "everyDay": "[ta] Every day",
      "weekdays": "[ta] Weekdays",
      "weekends": "[ta] Weekends",
      "noneSelected": "[ta] No days selected",
      "selectedCount": "[ta] {{count}} days selected"
    },
    "trigger": {
      "type": "[ta] Trigger Type",
      "time": "[ta] Time-based",
      "shabbat": "[ta] Shabbat Evening",
      "holiday": "[ta] Holiday",
      "skipShabbat": "[ta] Skip on Shabbat",
      "skipShabbatDesc": "[ta] Don't run this flow on Friday evening or Saturday",
      "shabbatOffset": "[ta] Minutes before candle lighting",
      "shabbatOffsetDesc": "[ta] How many minutes before Shabbat should this flow start?",
      "calculatedTime": "[ta] Calculated time",
      "thisWeek": "[ta] This week: {{day}} at {{time}}",
      "comingSoon": "[ta] Holiday triggers coming soon",
      "locationBased": "[ta] Times based on your location"
    },
    "examples": {
      "title": "[ta] Example Flows",
      "subtitle": "[ta] Tap to use as a template",
      "morningRoutine": {
        "name": "[ta] Morning Routine",
        "desc": "[ta] Start your day with news, weather, and uplifting content"
      },
      "eveningWindDown": {
        "name": "[ta] Evening Wind Down",
        "desc": "[ta] Relax with calming music and light entertainment"
      },
      "shabbatPrep": {
        "name": "[ta] Shabbat Preparation",
        "desc": "[ta] Set the mood for Shabbat with special content"
      },
      "coffeeBreak": {
        "name": "[ta] Coffee Break",
        "desc": "[ta] Quick entertainment for a short break"
      },
      "sunsetVibes": {
        "name": "[ta] Sunset Vibes",
        "desc": "[ta] Weekend relaxation with music and ambient content"
      }
    },
    "aiBrief": "[ta] AI Brief",
    "aiBriefDesc": "[ta] Get a personalized AI-generated summary before the flow starts",
    "aiBriefEnabled": "[ta] AI Brief Enabled",
    "validation": {
      "nameRequired": "[ta] Flow name is required",
      "startTimeRequired": "[ta] Start time is required",
      "endTimeRequired": "[ta] End time is required",
      "timeRange": "[ta] End time must be after start time",
      "daysRequired": "[ta] Select at least one day",
      "contentRequired": "[ta] Add content or enable AI"
    },
    "tv": {
      "useCompanion": "[ta] For full customization, use the Bayit+ app on your phone or visit bayit.plus on your computer."
    }
  },
  "profile": {
    "title": "என் சுயவிவரம்",
    "profileDetails": "[ta] Profile Details",
    "name": "பெயர்",
    "notSet": "அமைக்கப்படவில்லை",
    "email": "மின்னஞ்சல்",
    "editProfile": "சுயவிவரத்தை திருத்து",
    "notificationSettings": "[ta] Notification Settings",
    "security": "[ta] Security",
    "changePassword": "[ta] Change Password",
    "updatePassword": "[ta] Update your password",
    "connectedDevices": "[ta] Connected Devices",
    "manageDevices": "[ta] Manage devices connected to your account",
    "twoFactorAuth": "[ta] Two-Factor Authentication",
    "addExtraSecurity": "[ta] Add an extra layer of security",
    "address": {
      "line1": "[ta] 123 Main Street",
      "line2": "[ta] Tel Aviv, Israel 6100000"
    },
    "free": "[ta] Free",
    "premiumPrice": "[ta] $7.99/month",
    "familyPrice": "[ta] $12.99/month",
    "remaining": "[ta] remaining",
    "tabs": {
      "personal": "[ta] Personal",
      "overview": "[ta] Overview",
      "subscription": "[ta] Subscription",
      "notifications": "[ta] Notifications",
      "security": "[ta] Security",
      "ai": "[ta] AI & Voice",
      "voice": "[ta] Voice & Accessibility"
    },
    "subscription": {
      "currentPlan": "[ta] Current Plan",
      "renewsOn": "[ta] Renews on",
      "manageSubscription": "[ta] Manage Subscription",
      "cancelSubscription": "[ta] Cancel Subscription",
      "noActivePlan": "[ta] No active subscription",
      "selectPlan": "[ta] Select a Plan"
    },
    "notifications": "[ta] Notifications",
    "ai": {
      "title": "[ta] AI & Personalization",
      "description": "[ta] Configure AI-powered features",
      "assistant": "[ta] AI Assistant",
      "assistantDesc": "[ta] Personalized recommendations and help",
      "chatbot": "[ta] AI Assistant",
      "chatbotEnabled": "[ta] Enable AI Assistant",
      "chatbotEnabledDesc": "[ta] Get help navigating content",
      "saveHistory": "[ta] Save Conversation History",
      "saveHistoryDesc": "[ta] Remember previous conversations",
      "recommendations": "[ta] Recommendations",
      "personalizedRecs": "[ta] Personalized Recommendations",
      "personalizedRecsDesc": "[ta] Content suggestions based on history",
      "privacy": "[ta] Privacy & Data",
      "privacyDesc": "[ta] Your data is encrypted and secure",
      "dataConsent": "[ta] Usage Analytics",
      "dataConsentDesc": "[ta] Help improve AI features",
      "privacyNote": "[ta] Your data is encrypted and secure"
    },
    "voice": {
      "title": "[ta] Voice Control",
      "description": "[ta] Hands-free navigation",
      "enabled": "[ta] Voice Commands",
      "enabledDesc": "[ta] Control the app with your voice",
      "tts": "[ta] Text-to-Speech",
      "ttsDesc": "[ta] AI responses read aloud",
      "wakeWord": "[ta] Wake Word Detection",
      "wakeWordDesc": "[ta] Say \"Bayit\" to activate",
      "operationMode": "[ta] Operation Mode",
      "operationModeDesc": "[ta] Choose how you interact with the app",
      "voiceSearch": "[ta] Voice Search",
      "voiceSearchEnabled": "[ta] Enable voice search",
      "voiceSearchEnabledDesc": "[ta] Search for content using your voice",
      "constantListening": "[ta] Always Listening Mode",
      "constantListeningDesc": "[ta] Continuously listen for voice commands without pressing a button",
      "constantListeningPrivacy": "[ta] Audio is only sent to servers when speech is detected",
      "holdButtonMode": "[ta] Hold Button to Talk",
      "holdButtonModeDesc": "[ta] Press and hold the microphone button instead of always listening",
      "sensitivity": "[ta] Voice Detection Sensitivity",
      "sensitivityDesc": "[ta] Adjust how responsive the voice detection is",
      "sensitivityLow": "[ta] Low (fewer false triggers)",
      "sensitivityMedium": "[ta] Medium (balanced)",
      "sensitivityHigh": "[ta] High (most responsive)",
      "silenceThreshold": "[ta] Silence Detection",
      "silenceThresholdDesc": "[ta] How long to wait after speaking before processing",
      "language": "[ta] Voice language",
      "accessibility": "[ta] Accessibility",
      "autoSubtitle": "[ta] Auto-enable subtitles",
      "autoSubtitleDesc": "[ta] Automatically show subtitles when playing content",
      "highContrast": "[ta] High contrast mode",
      "highContrastDesc": "[ta] Increase contrast for better visibility",
      "textSize": "[ta] Text size",
      "textSizeSmall": "[ta] Small",
      "textSizeMedium": "[ta] Medium",
      "textSizeLarge": "[ta] Large",
      "voiceOnlyInfo": "[ta] Voice Only Mode",
      "voiceOnlyDetails": "[ta] Say \"Hi Bayit\" to activate. Remote control disabled. Navigate entirely with voice commands.",
      "hybridInfo": "[ta] Hybrid Mode",
      "hybridDetails": "[ta] Use voice or remote control. Voice feedback on non-voice actions.",
      "classicInfo": "[ta] Classic Mode",
      "classicDetails": "[ta] All voice features disabled. Remote control only.",
      "textToSpeech": "[ta] Voice Responses",
      "ttsEnabled": "[ta] Enable voice responses",
      "ttsEnabledDesc": "[ta] App will speak responses to your voice commands",
      "ttsVolume": "[ta] Voice Volume",
      "ttsSpeed": "[ta] Speaking Speed",
      "hybridFeedback": "[ta] Interactive Feedback",
      "voiceFeedback": "[ta] Voice feedback on actions",
      "voiceFeedbackDesc": "[ta] Get voice confirmation when you use the remote or click buttons",
      "feedbackExample": "[ta] Example: Click a movie → App says \"Playing [Movie Name]\""
    },
    "dropdown": {
      "myProfile": "[ta] My Profile",
      "subscription": "[ta] Subscription",
      "favorites": "[ta] Favorites",
      "downloads": "[ta] Downloads",
      "signOut": "[ta] Sign Out"
    },
    "guest": "[ta] Guest",
    "morningRitual": "[ta] Morning Ritual",
    "watchlist": "[ta] Watchlist",
    "favorites": "[ta] Favorites",
    "downloads": "[ta] Downloads",
    "settings": "[ta] Settings",
    "language": "[ta] Language",
    "admin": "[ta] Admin",
    "watchTime": "[ta] Watch Time",
    "minutes": "[ta] minutes",
    "hours": "[ta] hours",
    "logout": "வெளியேறு",
    "premium": "பிரீமியம்",
    "basic": "அடிப்படை",
    "upgrade": "பிரீமியத்திற்கு மேம்படுத்து",
    "memberSince": "[ta] Member since",
    "aiAssistant": "[ta] AI Assistant",
    "voiceSettings": "[ta] Voice",
    "subscriptionButton": "[ta] Subscription",
    "recentActivity": "[ta] Recent Activity",
    "justNow": "[ta] Just now",
    "hoursAgo": "[ta] {{hours}} hours ago",
    "yesterday": "[ta] Yesterday",
    "noRecentActivity": "[ta] No recent activity",
    "accountInfo": "[ta] Account Information",
    "role": "[ta] Role",
    "accountSecurity": "[ta] Account Security",
    "securityNote": "[ta] Your account is secured with encrypted authentication",
    "lastLogin": "[ta] Last login",
    "dangerZone": "[ta] Danger Zone",
    "invalidImageType": "[ta] Please select a valid image file (JPEG, PNG, WebP, or GIF)",
    "imageTooLarge": "[ta] Image is too large. Maximum size is 5MB.",
    "uploadSuccess": "[ta] Avatar updated successfully!",
    "uploadFailed": "[ta] Failed to upload avatar. Please try again.",
    "complimentaryPremium": "இலவச பிரீமியம் அணுகல்",
    "emailVerified": "மின்னஞ்சல் சரிபார்க்கப்பட்டது",
    "emailUnverified": "மின்னஞ்சல் சரிபார்க்கப்படவில்லை",
    "phoneVerified": "தொலைபேசி சரிபார்க்கப்பட்டது",
    "phoneUnverified": "தொலைபேசி சரிபார்க்கப்படவில்லை",
    "completeVerification": "அனைத்து அம்சங்களையும் திறக்க சரிபார்ப்பை நிறைவு செய்யுங்கள்",
    "unlockPremium": "பிரீமியம் அம்சங்களைத் திறக்கவும்",
    "unlockPremiumDescription": "பிரத்யேக உள்ளடக்கம் மற்றும் அம்சங்களை அனுபவிக்க மேம்படுத்தவும்"
  },
  "voiceMode": {
    "voiceOnly": "[ta] Voice Only",
    "voiceOnlyDesc": "[ta] No remote control - full voice navigation",
    "hybrid": "[ta] Hybrid",
    "hybridDesc": "[ta] Voice + Remote - voice feedback on actions",
    "classic": "[ta] Classic",
    "classicDesc": "[ta] No voice - remote control only"
  },
  "settings": {
    "title": "அமைப்புகள்",
    "language": "மொழி",
    "appLanguage": "பயன்பாட்டு மொழி",
    "selectLanguage": "மொழியைத் தேர்ந்தெடு",
    "languages": {
      "en": "ஆங்கிலம்",
      "he": "எபிரேயம்",
      "es": "ஸ்பானிஷ்",
      "zh": "中文",
      "fr": "பிரெஞ்சு",
      "it": "இத்தாலியன்",
      "hi": "இந்தி",
      "ta": "தமிழ்",
      "bn": "வங்காளம்",
      "ja": "日本語"
    },
    "chatTranslation": "[ta] Chat Translation",
    "autoTranslate": "[ta] Auto-translate messages",
    "autoTranslateDescription": "[ta] Automatically translate chat messages to your preferred language",
    "notifications": "அறிவிப்புகள்",
    "pushNotifications": "[ta] Push Notifications",
    "playback": "பின்னணி",
    "quality": "தரம்",
    "subtitles": "வசனங்கள்",
    "autoplay": "தானியங்கி",
    "appearance": "தோற்றம்",
    "darkMode": "இருள் பயன்முறை",
    "privacy": "தனியுரிமை",
    "privacyPolicy": "தனியுரிமைக் கொள்கை",
    "termsOfService": "சேவை விதிமுறைகள்",
    "about": "பற்றி",
    "display": "[ta] Display",
    "homePageSections": "[ta] Home Page Sections",
    "configureSections": "[ta] Configure which sections appear on your home page",
    "visibleSections": "[ta] Visible Sections",
    "hiddenSections": "[ta] Hidden Sections",
    "dragToReorder": "[ta] Drag to reorder",
    "tapToHide": "[ta] Tap to hide",
    "tapToShow": "[ta] Tap to show",
    "resetToDefault": "[ta] Reset to Default",
    "resetConfirmMessage": "[ta] Are you sure you want to reset home page sections to their default configuration?",
    "sectionHidden": "[ta] Section hidden",
    "sectionShown": "[ta] Section shown",
    "replayTour": "அம்சச் சுற்றுப் பயணத்தை மீண்டும் பார்க்கவும்"
  },
  "help": {
    "subtitle": "[ta] How can we help you?",
    "email": "[ta] Email Support",
    "phone": "[ta] Phone Support",
    "chat": "[ta] Live Chat",
    "chatAvailable": "[ta] Available 24/7",
    "openTooltip": "[ta] Open help tooltip",
    "openHelp": "[ta] Open help menu",
    "howTo": "[ta] How to use",
    "relatedArticles": "[ta] Related articles",
    "stillNeedHelp": "[ta] Still need help?",
    "contactSupport": "[ta] Contact Support",
    "previous": "[ta] Previous",
    "next": "[ta] Next",
    "getStarted": "[ta] Get Started",
    "skipTutorial": "[ta] Skip tutorial",
    "actions": {
      "search": "[ta] Search Help",
      "docs": "[ta] Documentation",
      "faq": "[ta] FAQ",
      "support": "[ta] Contact Support",
      "tutorial": "[ta] View Tutorial"
    },
    "search": {
      "placeholder": "[ta] Search help...",
      "noResults": "[ta] No results found for \"{{query}}\"",
      "noResultsHint": "[ta] Try different keywords or browse categories",
      "recent": "[ta] Recent",
      "popular": "[ta] Popular"
    },
    "categories": {
      "getting-started": "[ta] Getting Started",
      "features": "[ta] Features",
      "judaism": "[ta] Judaism",
      "platform-guides": "[ta] Platform Guides",
      "account": "[ta] Account",
      "troubleshooting": "[ta] Troubleshooting",
      "parents": "[ta] For Parents",
      "admin": "[ta] Admin Guide",
      "developer": "[ta] Developer API"
    },
    "faq": {
      "title": "[ta] Frequently Asked Questions",
      "q1": "[ta] How do I change my subscription plan?",
      "a1": "[ta] Go to Settings > Subscription to view and change your current plan. You can upgrade or downgrade at any time.",
      "q2": "[ta] How do I download content for offline viewing?",
      "a2": "[ta] Tap the download icon on any content to save it for offline viewing. Downloads are available on mobile devices only.",
      "q3": "[ta] Why isn't my video playing?",
      "a3": "[ta] Check your internet connection. If the problem persists, try clearing the app cache or restarting the app.",
      "q4": "[ta] How do I cancel my subscription?",
      "a4": "[ta] You can cancel your subscription anytime through Settings > Subscription > Cancel Plan. You'll continue to have access until the end of your billing period."
    },
    "onboarding": {
      "welcome": {
        "title": "[ta] Welcome to Bayit+",
        "description": "[ta] Your home for Israeli entertainment, anywhere in the world"
      },
      "liveTv": {
        "title": "[ta] Live TV",
        "description": "[ta] Watch Israeli channels live, including news, sports, and entertainment"
      },
      "vod": {
        "title": "[ta] On-Demand Content",
        "description": "[ta] Browse movies, series, and documentaries anytime"
      },
      "voice": {
        "title": "[ta] Voice Control",
        "description": "[ta] Say 'Bayit' to control the app with your voice"
      },
      "profiles": {
        "title": "[ta] Family Profiles",
        "description": "[ta] Create profiles for each family member with personalized recommendations"
      }
    }
  },
  "voice": {
    "panelTitle": "குரல் உதவியாளர்",
    "typeCommand": "ஒரு கட்டளையை தட்டச்சு செய்யுங்கள்...",
    "controlExecuted": "செயல்படுத்தப்பட்டது: {{action}}",
    "timerSet": "{{amount}} {{unit}} க்கு டைமர் அமைக்கப்பட்டது",
    "chatPending": "உங்கள் செய்தி செயலாக்கப்படுகிறது...",
    "suggestion": {
      "watchLive": "நேரடி தொலைக்காட்சி பாருங்கள்",
      "search": "உள்ளடக்கத்தை தேடுங்கள்",
      "listenRadio": "வானொலி கேளுங்கள்"
    },
    "error": {
      "micDenied": "மைக்ரோஃபோன் அணுகல் மறுக்கப்பட்டது",
      "notSupported": "இந்த உலாவியில் குரல் கட்டளைகள் ஆதரிக்கப்படவில்லை",
      "recognitionFailed": "புரிந்துகொள்ள முடியவில்லை. மீண்டும் முயற்சிக்கவும்."
    }
  },
  "errors": {
    "networkError": "நெட்வொர்க் பிழை",
    "loadingFailed": "ஏற்றுவது தோல்வி",
    "tryAgain": "மீண்டும் முயற்சிக்கவும்",
    "offline": {
      "title": "இணைய இணைப்பு இல்லை",
      "message": "நீங்கள் தற்போது ஆஃப்லைனில் உள்ளீர்கள்.",
      "ttsMessage": "[ta] No internet connection. You are now in offline mode."
    },
    "online": {
      "title": "இணைப்பு மீட்டமைக்கப்பட்டது",
      "message": "நீங்கள் மீண்டும் ஆன்லைனில் உள்ளீர்கள்.",
      "ttsMessage": "[ta] Internet connection restored."
    },
    "api": {
      "badRequest": "[ta] Something went wrong. Please try again.",
      "unauthorized": "[ta] Please log in to continue.",
      "forbidden": "[ta] You do not have permission to access this content.",
      "notFound": "[ta] The content you are looking for is not available.",
      "rateLimit": "[ta] You are making too many requests. Please wait a moment.",
      "serverError": "[ta] Our servers are having issues. Please try again later.",
      "unknown": "[ta] Something went wrong. Please try again.",
      "networkTimeout": "[ta] Unable to connect to our servers. Please check your connection.",
      "offlineMessage": "[ta] You are offline. Please check your internet connection.",
      "requestFailed": "[ta] Something went wrong. Please try again."
    },
    "voice": {
      "permissionDenied": "[ta] Microphone access is required for voice commands. Please enable it in Settings.",
      "recognitionFailed": "[ta] I didn't understand that. Please try again.",
      "commandFailed": "[ta] Voice command failed. Please try again."
    },
    "widget": {
      "loadFailed": "[ta] Unable to load widget. Please try again."
    },
    "buttons": {
      "ok": "[ta] OK",
      "retry": "[ta] Retry",
      "cancel": "[ta] Cancel"
    },
    "title": "[ta] Error",
    "networkUnavailable": "[ta] Network unavailable",
    "no_audio_url": "ஆடியோ URL கிடைக்கவில்லை",
    "connection_failed": "இணைப்பு தோல்வி",
    "quota_exceeded": "ஒதுக்கீடு மீறப்பட்டது",
    "server_error": "சேவையக பிழை"
  },
  "player": {
    "loading": "ஏற்றுகிறது...",
    "retry": "மீண்டும் முயற்சிக்கவும்",
    "error": "வீடியோ இயக்க பிழை",
    "back": "← பின்",
    "liveBadge": "நேரலை",
    "noStream": "ஸ்ட்ரீம் இல்லை",
    "loadError": "[ta] Failed to load stream",
    "settings": "அமைப்புகள்",
    "subtitles": "[ta] Subtitles",
    "playbackSpeed": "[ta] Playback Speed",
    "quality": "தரம்",
    "auto": "தானியங்கி",
    "previousChapter": "[ta] Previous chapter",
    "nextChapter": "[ta] Next chapter",
    "skipBackward": "[ta] Skip backward 30 seconds",
    "skipForward": "[ta] Skip forward 30 seconds",
    "restart": "[ta] Restart from beginning",
    "subtitlesOff": "அணைக்கவும்",
    "speed": "வேகம்",
    "subscription": {
      "requiredTitle": "[ta] Subscription Required",
      "requiredMessage": "[ta] requires a paid subscription",
      "upgradeInfo": "[ta] Upgrade your subscription to access premium content",
      "upgrade": "[ta] Upgrade Now"
    },
    "ai": {
      "dub": "Dub",
      "dubbing": "டப்பிங்",
      "featuresTitle": "AI அம்சங்கள்",
      "languagePrimary": "முதன்மை",
      "languageSecondary": "இரண்டாம்நிலை (விரும்பினால்)",
      "languageTitle": "AI மொழி",
      "liveTranslate": "நேரடி மொழிபெயர்ப்பு",
      "selectLanguage": "மொழியைத் தேர்ந்தெடு",
      "split": "பிரி",
      "togglePanel": "AI பேனலை நிலைமாற்று",
      "translate": "மொழிபெயர்",
      "trivia": "அறிவுத்திறன்",
      "triviaToggle": "[ta] Trivia"
    },
    "catchup": {
      "description": "தொடக்கத்தை தவறவிட்டீர்களா? இதுவரை என்ன நடந்தது என்பதன் AI சுருக்கத்தைப் பெறுங்கள்.",
      "generateSummary": "சுருக்கத்தை உருவாக்கு",
      "summaryTitle": "சுருக்கம்",
      "title": "பின்தொடர்",
      "keyPoints": "[ta] Key Points",
      "transcript": "[ta] Transcript"
    },
    "chat": {
      "title": "நேரடி அரட்டை",
      "messagePlaceholder": "ஒரு செய்தியைத் தட்டச்சு செய்..."
    },
    "companion": {
      "noContext": "இந்த உள்ளடக்கத்திற்கு இன்னும் கலாச்சார சூழல் கிடைக்கவில்லை.",
      "quizComplete": "வினாடி வினா முடிந்தது",
      "quizRetry": "மீண்டும் முயற்சி",
      "quizStart": "வினாடி வினா தொடங்கு",
      "quizTitle": "உங்கள் அறிவை சோதிக்க தயாரா?",
      "quizTryAgain": "மீண்டும் முயற்சி",
      "tabContext": "சூழல்",
      "tabQuiz": "வினாடி வினா",
      "tabVocabulary": "சொற்களஞ்சியம்",
      "tapWords": "இங்கே சேர்க்க வசனங்களில் உள்ள சொற்களைத் தட்டவும்",
      "title": "AI துணை",
      "loadError": "AI கற்றல் தரவை ஏற்றுவதில் தோல்வி"
    },
    "controls": {
      "audioTrack": "ஆடியோ ட்ராக்",
      "continueWatching": "தொடர்ந்து பார்",
      "dismiss": "நிராகரி",
      "goBack": "திரும்பிச் செல்",
      "navigateBack": "பின்செல்",
      "on": "ON",
      "pause": "இடைநிறுத்து",
      "play": "இயக்கு",
      "preview": "முன்னோட்டம்",
      "selected": "தேர்ந்தெடுக்கப்பட்டது",
      "send": "அனுப்பு",
      "skip": "தவிர்",
      "close": "[ta] Close",
      "exitFullscreen": "[ta] Exit Fullscreen",
      "fullscreen": "[ta] Fullscreen",
      "restart": "[ta] Restart",
      "skipBackward": "[ta] Skip Backward",
      "skipForward": "[ta] Skip Forward",
      "volume": "[ta] Volume"
    },
    "dubbing": {
      "notNow": "இப்போது வேண்டாம்",
      "premiumMessage": "நேரடி டப்பிங்கிற்கு Premium அல்லது Beta 500 சந்தா தேவை",
      "premiumTitle": "பிரீமியம் அம்சம்",
      "upgrade": "மேம்படுத்து",
      "voiceTitle": "டப்பிங் குரல்",
      "settings_title": "நேரடி டப்பிங் அமைப்புகள்",
      "target_language": "இலக்கு மொழி"
    },
    "errors": {
      "streamLimitMessage": "{{maxStreams}} ஒரே நேர ஸ்ட்ரீம்களின் அதிகபட்ச எண்ணிக்கையை அடைந்துவிட்டீர்கள். மற்றொரு ஸ்ட்ரீமை நிறுத்தவும் அல்லது உங்கள் திட்டத்தை மேம்படுத்தவும்.",
      "streamLimitTitle": "ஸ்ட்ரீம் வரம்பை அடைந்தது",
      "upgradePlan": "திட்டத்தை மேம்படுத்து"
    },
    "audio_description": "ஆடியோ விளக்கம்",
    "dismiss": "மூடு",
    "scene_search": "காட்சி தேடல்",
    "search_placeholder": "காட்சியைத் தேடு...",
    "language_ratio": "மொழி கற்றல் விகிதம்",
    "go_back": "திரும்பு",
    "sleepTimer": {
      "title": "தூக்க நேரமானி",
      "subtitle": "நிர்ணயிக்கப்பட்ட நேரத்திற்குப் பிறகு இயக்கத்தை தானாக நிறுத்து",
      "minutes": "{{count}} நிமி",
      "customPlaceholder": "தனிப்பயன் நிமிடங்கள்",
      "set": "நேரமானி அமை",
      "remaining": "{{time}} இல் தூக்கம்",
      "extend": "+15 நிமி",
      "cancel": "நேரமானி ரத்து",
      "off": "[ta] Off",
      "setTimer": "[ta] Set Sleep Timer"
    },
    "openSubs": {
      "title": "வசனங்களை தேடு",
      "searchPlaceholder": "தலைப்பு மூலம் தேடு...",
      "search": "தேடு",
      "searchFailed": "தேடல் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
      "downloads": "{{count}} பதிவிறக்கங்கள்",
      "noResults": "வசனங்கள் எதுவும் இல்லை"
    },
    "dialogue": {
      "cancel": "[ta] Cancel",
      "close": "[ta] Close",
      "placeholder": "[ta] Type your message...",
      "selectCharacter": "[ta] Select Character",
      "send": "[ta] Send",
      "sharedSession": "[ta] Shared Session",
      "waitingForTurn": "[ta] Waiting for your turn...",
      "yourAvatar": "[ta] Your Avatar"
    },
    "interaction": {
      "next": "[ta] Next",
      "previous": "[ta] Previous",
      "skip": "தவிர்",
      "start": "தொடர்பை தொடங்கு",
      "window": "தொடர்பு சாளரம்: {{duration}} வினாடிகள்"
    },
    "pauseAsk": {
      "askAgain": "[ta] Ask Again",
      "placeholder": "[ta] Ask about this scene...",
      "resume": "[ta] Resume",
      "resumeMovie": "[ta] Resume Movie",
      "selectCharacter": "[ta] Select Character",
      "title": "[ta] Pause & Ask"
    },
    "phraseBreakdown": {
      "literal": "நேரடி பொருள்",
      "meaning": "அர்த்தம்",
      "origin": "தோற்றம்",
      "funFact": "சுவாரஸ்யமான தகவல்",
      "usage": "பயன்பாடு: {{level}}"
    },
    "translation": {
      "example": "எடுத்துக்காட்டு:",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "வசன பயன்முறை",
      "modes": {
        "regular": {
          "name": "சாதாரண",
          "description": "உயிரெழுத்து குறிகள் இல்லாத நிலையான ஹீப்ரு வசனங்கள்"
        },
        "nikud": {
          "name": "நிகுட்",
          "description": "எளிதான வாசிப்புக்காக உயிரெழுத்து குறிகளுடன் ஹீப்ரு"
        },
        "shoresh": {
          "name": "ஷோரேஷ்",
          "description": "சொல் தோற்றங்கள் முன்னிலைப்படுத்தப்பட்ட மூல-அடிப்படையிலான கற்றல்"
        },
        "engrew": {
          "name": "என்க்ரூ",
          "description": "ஹீப்ரு சூழலுடன் ஆங்கில எழுத்துப்பெயர்ப்பு"
        },
        "heblish": {
          "name": "ஹெப்லிஷ்",
          "description": "ஹீப்ரு சொற்கள் மற்றும் கலாச்சார சூழலுடன் ஆங்கிலம்"
        },
        "grammarFlip": {
          "name": "இலக்கண மாற்றம்",
          "description": "ஆங்கில வார்த்தைகளுடன் ஹீப்ரு வாக்கிய அமைப்பு"
        },
        "slangSynthesis": {
          "name": "சாதாரண பேச்சு தொகுப்பு",
          "description": "கலாச்சார வழக்குச்சொற்கள் மற்றும் இடியங்கள் விளக்கம்"
        }
      }
    }
  },
  "empty": {
    "noContent": "[ta] No content available",
    "tryAnotherCategory": "[ta] Try selecting another category",
    "noPodcasts": "[ta] No podcasts available",
    "tryLater": "[ta] Try again later",
    "noResults": "[ta] No results found"
  },
  "content": {
    "play": "இயக்கு",
    "addToList": "பட்டியலில் சேர்",
    "inList": "பட்டியலில் உள்ளது",
    "details": "விவரங்கள்",
    "synopsis": "சுருக்கம்",
    "genre": "வகை",
    "genres": "[ta] Genres",
    "runtime": "கால அளவு",
    "released": "[ta] Released",
    "director": "இயக்குநர்",
    "starring": "[ta] Starring",
    "cast": "நடிகர்கள்",
    "season": "சீசன்",
    "seasons": "[ta] Seasons",
    "episode": "அத்தியாயம்",
    "episodes": "அத்தியாயங்கள்",
    "ep": "[ta] Ep",
    "selectSeason": "[ta] Select Season",
    "noEpisodes": "[ta] No episodes available",
    "noEpisodesAvailable": "[ta] No episodes available to play",
    "loadingSeries": "[ta] Loading series information...",
    "votes": "[ta] votes",
    "rating": "மதிப்பீடு",
    "imdbRating": "[ta] IMDB Rating",
    "preview": "[ta] Preview",
    "previewPlaying": "[ta] Preview playing",
    "trailerPlaying": "[ta] Trailer playing",
    "watchTrailer": "டிரெய்லர் பார்",
    "youMayAlsoLike": "[ta] You May Also Like",
    "relatedContent": "தொடர்புடைய உள்ளடக்கம்",
    "notFound": "உள்ளடக்கம் இல்லை",
    "availableSubtitles": "[ta] Available Subtitles",
    "subtitleSelected": "[ta] Selected: {{language}}"
  },
  "breadcrumbs": {
    "series": "[ta] Series",
    "movie": "[ta] Movie",
    "watching": "[ta] Watching",
    "channel": "[ta] Channel",
    "station": "[ta] Station",
    "podcast": "[ta] Podcast",
    "watchlist": "[ta] Watchlist",
    "downloads": "[ta] Downloads"
  },
  "favorites": {
    "title": "பிடித்தவை",
    "items": "உருப்படிகள்",
    "empty": "பிடித்தவை இல்லை",
    "emptyHint": "உங்கள் பிடித்தவைகளில் உருப்படிகளைச் சேர்க்கவும்"
  },
  "downloads": {
    "title": "பதிவிறக்கங்கள்",
    "items": "உருப்படிகள்",
    "storage": "[ta] Storage",
    "empty": "பதிவிறக்கங்கள் இல்லை",
    "emptyHint": "ஆஃப்லைன் பார்வைக்கு உள்ளடக்கத்தைப் பதிவிறக்கவும்",
    "paused": "[ta] Paused"
  },
  "watchlist": {
    "filters": {
      "all": "அனைத்தும்",
      "continue": "[ta] Continue Watching",
      "movies": "திரைப்படங்கள்",
      "series": "தொடர்கள்",
      "kids": "குழந்தைகள்",
      "judaism": "[ta] Judaism",
      "podcasts": "[ta] Podcasts",
      "radio": "[ta] Radio"
    },
    "title": "கண்காணிப்பு பட்டியல்",
    "items": "உருப்படிகள்",
    "watched": "[ta] watched",
    "empty": "உங்கள் கண்காணிப்பு பட்டியல் காலியாக உள்ளது",
    "emptyHint": "[ta] Start watching and items will appear here"
  },
  "widgets": {
    "empty": "[ta] No widgets yet",
    "emptyHint": "[ta] Your widgets will appear here",
    "emptyPersonal": "[ta] No personal widgets yet",
    "emptyPersonalHint": "[ta] Create your first personal widget or add system widgets above",
    "itemsTotal": "[ta] total widgets",
    "systemWidgets": "[ta] System Widgets",
    "systemWidgetsHint": "[ta] Browse and add widgets to your collection",
    "myWidgets": "[ta] My Personal Widgets",
    "myWidgetsHint": "[ta] Widgets you have created",
    "personalWidgets": "[ta] My Widgets",
    "noSystemWidgets": "[ta] No system widgets available",
    "added": "[ta] Added",
    "add": "[ta] Add",
    "remove": "[ta] Remove",
    "show": "[ta] Show",
    "hidden": "[ta] Hidden",
    "addToCollection": "[ta] Add to My Widgets",
    "removeFromCollection": "[ta] Remove from My Widgets",
    "contentTypes": {
      "liveChannel": "[ta] Live Channel",
      "iframe": "[ta] Web Content",
      "podcast": "[ta] Podcast",
      "radio": "[ta] Radio",
      "vod": "[ta] Video",
      "custom": "[ta] Custom",
      "widget": "[ta] Widget"
    },
    "form": {
      "title": "[ta] Create Widget",
      "basicInfo": "[ta] Basic Information",
      "titlePlaceholder": "[ta] Widget Title",
      "titleRequired": "[ta] Widget Title is required",
      "descriptionPlaceholder": "[ta] Description (optional)",
      "iconPlaceholder": "[ta] Icon emoji (e.g., 📺)",
      "content": "[ta] Content",
      "fromLibrary": "[ta] From Library",
      "iframe": "[ta] iFrame",
      "selectContent": "[ta] Select Content (Channels, Podcasts, Shows, etc.)",
      "iframeUrl": "[ta] iFrame URL",
      "iframeUrlRequired": "[ta] iFrame URL is required",
      "iframeTitle": "[ta] iFrame Title",
      "positionSize": "[ta] Position & Size",
      "behavior": "[ta] Behavior",
      "mutedByDefault": "[ta] Muted by Default",
      "closable": "[ta] Closable",
      "draggable": "[ta] Draggable",
      "widgetOrder": "[ta] Widget Order",
      "orderPlaceholder": "[ta] Order (0 = first)",
      "saveWidget": "[ta] Save Widget",
      "saving": "[ta] Saving...",
      "cancel": "[ta] Cancel",
      "change": "[ta] Change"
    }
  },
  "trending": {
    "title": "[ta] What's Trending in Israel",
    "noTopics": "[ta] No trending topics available",
    "topStory": "[ta] TOP STORY",
    "sources": "[ta] Sources",
    "categories": {
      "security": "[ta] Security",
      "politics": "[ta] Politics",
      "tech": "[ta] Tech",
      "culture": "[ta] Culture",
      "sports": "[ta] Sports",
      "economy": "[ta] Economy",
      "entertainment": "[ta] Entertainment",
      "weather": "[ta] Weather",
      "health": "[ta] Health",
      "general": "[ta] General"
    }
  },
  "cultures": {
    "title": "[ta] Select Your Culture",
    "select": "[ta] Select Culture",
    "selectCulture": "[ta] Choose Your Culture",
    "selectCultureDescription": "[ta] Select your cultural community to personalize your experience",
    "changeCulture": "[ta] Change Culture",
    "israeli": {
      "name": "[ta] Israeli",
      "description": "[ta] Israeli expat community content"
    },
    "chinese": {
      "name": "[ta] Chinese",
      "description": "[ta] Chinese community content"
    },
    "japanese": {
      "name": "[ta] Japanese",
      "description": "[ta] Japanese community content"
    },
    "korean": {
      "name": "[ta] Korean",
      "description": "[ta] Korean community content"
    },
    "indian": {
      "name": "[ta] Indian",
      "description": "[ta] Indian community content"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "[ta] What's Hot in {{location}}",
    "noTopics": "[ta] No trending topics available",
    "sources": "[ta] Sources",
    "categories": {
      "security": "[ta] Security",
      "politics": "[ta] Politics",
      "tech": "[ta] Tech",
      "technology": "[ta] Technology",
      "culture": "[ta] Culture",
      "sports": "[ta] Sports",
      "economy": "[ta] Economy",
      "finance": "[ta] Finance",
      "entertainment": "[ta] Entertainment",
      "weather": "[ta] Weather",
      "health": "[ta] Health",
      "food": "[ta] Food",
      "fashion": "[ta] Fashion",
      "travel": "[ta] Travel",
      "history": "[ta] History",
      "expat": "[ta] Expat Life",
      "general": "[ta] General"
    }
  },
  "cultureClock": {
    "timeIn": "{{location}} நேரம்",
    "shabbat": "ஷப்பத்",
    "weekend": "வார இறுதி"
  },
  "cultureCities": {
    "connectionTo": "[ta] {{city}} Connection",
    "explore": "[ta] Explore {{city}}",
    "noContent": "[ta] No content available for this city",
    "categories": {
      "all": "[ta] All",
      "history": "[ta] History",
      "culture": "[ta] Culture",
      "finance": "[ta] Finance",
      "tech": "[ta] Tech",
      "food": "[ta] Food",
      "expat": "[ta] Expat Life",
      "news": "[ta] News",
      "entertainment": "[ta] Entertainment"
    }
  },
  "clock": {
    "israel": "[ta] Israel",
    "local": "[ta] Local",
    "shabbatShalom": "[ta] Shabbat Shalom!",
    "erevShabbat": "[ta] Erev Shabbat",
    "candleLighting": "[ta] Candle Lighting",
    "parasha": "[ta] Parasha"
  },
  "ritual": {
    "title": "[ta] Morning Ritual",
    "greeting": "[ta] Good Morning!",
    "israelUpdate": "[ta] It's afternoon in Israel, news is reporting on ongoing developments",
    "recommendation": "[ta] We recommend starting with morning news then switching to radio",
    "preparingRitual": "[ta] Preparing your morning ritual...",
    "israelTime": "[ta] Israel Time",
    "day": "[ta] Day",
    "letsStart": "[ta] Let's Start",
    "skipToday": "[ta] Skip for Today",
    "finish": "[ta] Finish",
    "noContentNow": "[ta] No content available right now",
    "typeLive": "[ta] Live",
    "typeRadio": "[ta] Radio",
    "typeVideo": "[ta] Video"
  },
  "watchParty": {
    "title": "[ta] Watch Party",
    "create": "[ta] Create Party",
    "join": "[ta] Join Party",
    "active": "[ta] Party Active",
    "createTitle": "[ta] Create Watch Party",
    "joinTitle": "[ta] Join Party",
    "enterCode": "[ta] Enter Room Code",
    "roomCode": "[ta] Room Code",
    "copyCode": "[ta] Copy Code",
    "codeCopied": "[ta] Code Copied!",
    "participants": "[ta] Participants",
    "host": "[ta] Host",
    "you": "[ta] You",
    "leave": "[ta] Leave Party",
    "end": "[ta] End Party",
    "chat": "[ta] Chat",
    "sendMessage": "[ta] Send Message",
    "typeMessage": "[ta] Type a message...",
    "synced": "[ta] Synced",
    "syncing": "[ta] Syncing...",
    "hostPaused": "[ta] Host Paused",
    "userJoined": "[ta] {{name}} joined",
    "userLeft": "[ta] {{name}} left",
    "partyEnded": "[ta] The party has ended",
    "connecting": "[ta] Connecting...",
    "options": {
      "chatEnabled": "[ta] Enable Chat",
      "syncPlayback": "[ta] Sync Playback"
    },
    "errors": {
      "invalidCode": "[ta] Invalid code",
      "partyFull": "[ta] Party is full",
      "partyEnded": "[ta] Party has ended",
      "connectionError": "[ta] Connection error",
      "createFailed": "[ta] Failed to create party",
      "joinFailed": "[ta] Failed to join party"
    },
    "audio": {
      "mute": "[ta] Mute",
      "unmute": "[ta] Unmute",
      "speaking": "[ta] Speaking",
      "connecting": "[ta] Connecting to audio...",
      "noAudio": "[ta] Audio not available"
    },
    "textOnlyMode": "[ta] Text Chat Only",
    "endParty": "[ta] End Party"
  },
  "footer": {
    "brandDescription": "USA இல் உங்கள் வீடு. ஹீப்ரூவில் TV ஒளிபரப்புகள், VOD, வானொலி மற்றும் பாட்காஸ்ட்கள்.",
    "browse": "உலாவு",
    "account": "கணக்கு",
    "support": "ஆதரவு",
    "legal": "சட்ட",
    "location": "[ta] New York, USA",
    "links": {
      "home": "[ta] Home",
      "liveTV": "[ta] Live TV",
      "vod": "[ta] Movies & Series",
      "radio": "[ta] Radio",
      "podcasts": "[ta] Podcasts",
      "judaism": "[ta] Judaism",
      "profile": "[ta] My Profile",
      "favorites": "[ta] Favorites",
      "watchlist": "[ta] Watchlist",
      "subscribe": "[ta] Subscribe",
      "downloads": "[ta] Downloads",
      "help": "[ta] Help Center",
      "faq": "[ta] FAQ",
      "contact": "[ta] Contact Us",
      "feedback": "[ta] Feedback",
      "terms": "[ta] Terms of Service",
      "privacy": "[ta] Privacy Policy",
      "cookies": "[ta] Cookie Policy",
      "licenses": "[ta] Licenses"
    },
    "newsletter": {
      "title": "[ta] Stay Updated",
      "description": "[ta] Subscribe to our newsletter for the latest updates and exclusive content.",
      "placeholder": "[ta] Enter your email",
      "success": "[ta] Thanks for subscribing!"
    },
    "apps": {
      "title": "[ta] Get the App",
      "downloadOn": "[ta] Download on",
      "getItOn": "[ta] Get it on",
      "appStore": "[ta] App Store",
      "googlePlay": "[ta] Google Play"
    },
    "social": {
      "facebook": "[ta] Facebook",
      "twitter": "[ta] Twitter",
      "instagram": "[ta] Instagram",
      "youtube": "[ta] YouTube"
    },
    "copyright": "© {{year}} Bayit+. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    "poweredBy": "மூலம் இயக்கப்படுகிறது",
    "sitemap": "[ta] Sitemap",
    "accessibility": "[ta] Accessibility",
    "navigation": "[ta] Navigation",
    "liveTV": "[ta] Live TV",
    "moviesAndSeries": "[ta] Movies & Series",
    "radioStations": "[ta] Radio Stations",
    "myProfile": "[ta] My Profile",
    "subscriptions": "[ta] Subscriptions",
    "helpAndSupport": "[ta] Help & Support",
    "termsOfUse": "[ta] Terms of Use",
    "privacyPolicy": "[ta] Privacy Policy",
    "contactUs": "[ta] Contact Us"
  },
  "chapters": {
    "title": "[ta] Chapters",
    "noChapters": "[ta] No chapters available",
    "generating": "[ta] Generating chapters...",
    "jumpTo": "[ta] Jump to",
    "current": "[ta] Now",
    "categories": {
      "intro": "[ta] Introduction",
      "news": "[ta] News",
      "security": "[ta] Security",
      "politics": "[ta] Politics",
      "economy": "[ta] Economy",
      "sports": "[ta] Sports",
      "weather": "[ta] Weather",
      "culture": "[ta] Culture",
      "conclusion": "[ta] Conclusion"
    },
    "chapterLabel": "அத்தியாயம் {{number}}",
    "chapter_number": "அத்தியாயம் {{number}}"
  },
  "admin": {
    "brand": {
      "title": "Bayit+ நிர்வாகி",
      "subtitle": "அமைப்பு மேலாண்மை"
    },
    "backToApp": "பயன்பாட்டுக்குத் திரும்பு",
    "refunds": {
      "subtitle": "திரும்பப் பெறும் கோரிக்கைகளை நிர்வகி",
      "approveModal": {
        "title": "ஒப்புதல் உறுதிப்படுத்து",
        "message": "{{amount}} திரும்பப் பெறுதலை ஒப்புக்கொள்ளவா?"
      },
      "confirmApprove": "{{amount}} திரும்பப் பெறுதலை ஒப்புக்கொள்ளவா?",
      "confirmDelete": "திரும்பப் பெறும் கோரிக்கையை நீக்கவா?",
      "rejectModal": {
        "title": "திரும்பப் பெறும் கோரிக்கையை நிராகரி",
        "message": "{{amount}} திரும்பப் பெறுதலை நிராகரிக்கிறது",
        "reasonLabel": "நிராகரிப்பு காரணம்",
        "reasonPlaceholder": "நிராகரிப்புக்கான காரணத்தை உள்ளிடவும்...",
        "submitButton": "கோரிக்கையை நிராகரி"
      },
      "status": {
        "pending": "நிலுவையில்",
        "approved": "ஒப்புக்கொள்ளப்பட்டது",
        "rejected": "நிராகரிக்கப்பட்டது"
      },
      "columns": {
        "id": "ID",
        "user": "பயனர்",
        "amount": "தொகை",
        "reason": "காரணம்",
        "status": "நிலை",
        "requestDate": "கோரிக்கை தேதி"
      },
      "stats": {
        "pendingTitle": "ஒப்புதலுக்கு நிலுவையில்",
        "approvedTitle": "ஒப்புக்கொள்ளப்பட்டது",
        "rejectedTitle": "நிராகரிக்கப்பட்டது",
        "totalRefunded": "மொத்தம் திரும்பப் பெறப்பட்டது"
      },
      "emptyMessage": "திரும்பப் பெறும் கோரிக்கைகள் இல்லை",
      "errors": {
        "rejectReasonRequired": "நிராகரிப்புக்கான காரணத்தை உள்ளிடவும்"
      },
      "title": "திரும்பப் பெறுதல்கள்"
    },
    "plans": {
      "title": "திட்ட மேலாண்மை",
      "subtitle": "சந்தா திட்டங்களை உள்ளமைக்கவும் நிர்வகிக்கவும்",
      "createButton": "புதிய திட்டம்",
      "inactive": "செயலில் இல்லை",
      "subscribersLabel": "சந்தாதாரர்கள்:",
      "intervals": {
        "monthly": "மாதம்",
        "yearly": "வருடம்"
      },
      "trialDays": "{{days}} நாள் சோதனை",
      "modal": {
        "editTitle": "திட்டத்தைத் திருத்து",
        "createTitle": "புதிய திட்டம்"
      },
      "form": {
        "nameEn": "பெயர் (ஆங்கிலம்)",
        "nameHe": "பெயர் (எபிரேயம்)",
        "price": "விலை ($)",
        "interval": "கட்டண காலம்",
        "trialDays": "சோதனை நாட்கள்",
        "features": "அம்சங்கள் (ஒரு வரிக்கு ஒன்று)",
        "active": "செயலில் திட்டம்"
      },
      "errors": {
        "requiredFields": "பெயர் மற்றும் விலை தேவை"
      },
      "confirmDelete": "\"{{name}}\" திட்டத்தை நீக்கவா?"
    },
    "emailCampaigns": {
      "subtitle": "மின்னஞ்சல் பிரச்சாரங்களை உருவாக்கி நிர்வகிக்கவும்",
      "createButton": "புதிய பிரச்சாரம்",
      "searchPlaceholder": "பிரச்சாரம் தேடு...",
      "emptyMessage": "பிரச்சாரங்கள் இல்லை",
      "status": {
        "draft": "வரைவு",
        "active": "செயலில்",
        "scheduled": "திட்டமிடப்பட்டது",
        "completed": "முடிந்தது"
      },
      "columns": {
        "name": "பிரச்சாரம் பெயர்",
        "status": "நிலை",
        "sent": "அனுப்பப்பட்டது",
        "opened": "திறக்கப்பட்டது",
        "clicked": "கிளிக் செய்யப்பட்டது",
        "created": "உருவாக்கப்பட்டது",
        "actions": "செயல்கள்"
      },
      "editModal": {
        "title": "பிரச்சாரத்தைத் திருத்து"
      },
      "sendTestEmail": "சோதனை அனுப்பு",
      "confirmSend": "\"{{name}}\" பிரச்சாரத்தை அனுப்பவா?",
      "confirmDelete": "\"{{name}}\" பிரச்சாரத்தை நீக்கவா?",
      "testEmailSent": "சோதனை மின்னஞ்சல் அனுப்பப்பட்டது!",
      "createModal": {
        "title": "புதிய மின்னஞ்சல் பிரச்சாரம்"
      },
      "form": {
        "name": "பிரச்சாரம் பெயர்",
        "namePlaceholder": "எ.கா., ஆண்டு இறுதி விற்பனை",
        "subject": "மின்னஞ்சல் பொருள்",
        "subjectPlaceholder": "பெறுநர்களுக்குக் காட்டப்படும் பொருள்",
        "body": "உள்ளடக்கம்",
        "bodyPlaceholder": "மின்னஞ்சல் உள்ளடக்கம்...",
        "submitButton": "பிரச்சாரம் உருவாக்கு",
        "requiredFields": "பெயர் மற்றும் பொருள் தேவை"
      },
      "testModal": {
        "title": "சோதனை மின்னஞ்சல் அனுப்பு",
        "emailLabel": "மின்னஞ்சல் முகவரி",
        "emailPlaceholder": "test@example.com",
        "submitButton": "சோதனை அனுப்பு"
      },
      "errors": {
        "requiredFields": "பெயர் மற்றும் பொருள் தேவை"
      }
    },
    "dashboard": {
      "subtitle": "அமைப்பு கண்ணோட்டம்",
      "refresh": "புதுப்பி",
      "timeAgo": {
        "minutes": "{{count}} நிமிடங்களுக்கு முன்",
        "hours": "{{count}} மணி நேரத்திற்கு முன்"
      },
      "title": "டாஷ்போர்டு",
      "users": "பயனர்கள்",
      "revenue": "வருவாய்",
      "subscriptions": "சந்தாக்கள்",
      "recentActivity": "சமீபத்திய செயல்பாடு",
      "quickActions": "விரைவு செயல்கள்"
    },
    "common": {
      "all": "அனைத்தும்",
      "cancel": "ரத்து செய்",
      "save": "சேமி",
      "active": "செயலில்",
      "back": "பின்",
      "filterAction": "செயல்",
      "filterResource": "வளம்",
      "filterUser": "பயனர்",
      "filterDateRange": "தேதி வரம்பு"
    },
    "stats": {
      "totalUsers": "மொத்த பயனர்கள்",
      "activeUsers": "செயலில் உள்ள பயனர்கள்",
      "newToday": "இன்று புதிய",
      "newThisWeek": "இந்த வாரம் புதிய",
      "totalRevenue": "மொத்த வருவாய்",
      "revenueToday": "இன்றைய வருவாய்",
      "revenueMonth": "இந்த மாத வருவாய்",
      "arpu": "பயனர் ஒருவருக்கான சராசரி வருவாய்",
      "activeSubscriptions": "செயலில் சந்தாக்கள்",
      "churnRate": "விலகல் விகிதம்"
    },
    "actions": {
      "new": "புதிய",
      "addUser": "பயனர் சேர்",
      "newCampaign": "புதிய பிரச்சாரம்",
      "sendEmail": "மின்னஞ்சல் அனுப்பு",
      "viewReports": "அறிக்கைகளைக் காண்"
    },
    "auditActions": {
      "user_created": "பயனர் உருவாக்கப்பட்டார்",
      "user_updated": "பயனர் புதுப்பிக்கப்பட்டார்",
      "user_deleted": "பயனர் நீக்கப்பட்டார்",
      "user_role_changed": "பயனர் பங்கு மாற்றப்பட்டது",
      "campaign_created": "பிரச்சாரம் உருவாக்கப்பட்டது",
      "campaign_updated": "பிரச்சாரம் புதுப்பிக்கப்பட்டது",
      "campaign_deleted": "பிரச்சாரம் நீக்கப்பட்டது",
      "campaign_activated": "பிரச்சாரம் செயல்படுத்தப்பட்டது",
      "subscription_created": "சந்தா உருவாக்கப்பட்டது",
      "subscription_updated": "சந்தா புதுப்பிக்கப்பட்டது",
      "subscription_canceled": "சந்தா ரத்து செய்யப்பட்டது",
      "subscription_deleted": "சந்தா நீக்கப்பட்டது",
      "refund_processed": "திரும்பப் பெறுதல் செயலாக்கப்பட்டது",
      "payment_received": "கட்டணம் பெறப்பட்டது",
      "settings_updated": "அமைப்புகள் புதுப்பிக்கப்பட்டன",
      "login": "உள்நுழைவு",
      "logout": "வெளியேறு",
      "content_created": "உள்ளடக்கம் உருவாக்கப்பட்டது",
      "content_updated": "உள்ளடக்கம் புதுப்பிக்கப்பட்டது",
      "content_deleted": "உள்ளடக்கம் நீக்கப்பட்டது",
      "content_published": "உள்ளடக்கம் வெளியிடப்பட்டது",
      "content_unpublished": "உள்ளடக்கம் வெளியிடப்படவில்லை",
      "category_created": "வகை உருவாக்கப்பட்டது",
      "category_updated": "வகை புதுப்பிக்கப்பட்டது",
      "category_deleted": "வகை நீக்கப்பட்டது",
      "live_channel_created": "நேரலை சேனல் உருவாக்கப்பட்டது",
      "live_channel_updated": "நேரலை சேனல் புதுப்பிக்கப்பட்டது",
      "live_channel_deleted": "நேரலை சேனல் நீக்கப்பட்டது",
      "radio_station_created": "வானொலி நிலையம் உருவாக்கப்பட்டது",
      "radio_station_updated": "வானொலி நிலையம் புதுப்பிக்கப்பட்டது",
      "radio_station_deleted": "வானொலி நிலையம் நீக்கப்பட்டது",
      "podcast_created": "பாட்காஸ்ட் உருவாக்கப்பட்டது",
      "podcast_updated": "பாட்காஸ்ட் புதுப்பிக்கப்பட்டது",
      "podcast_deleted": "பாட்காஸ்ட் நீக்கப்பட்டது",
      "podcast_episode_created": "பாட்காஸ்ட் அத்தியாயம் உருவாக்கப்பட்டது",
      "podcast_episode_updated": "பாட்காஸ்ட் அத்தியாயம் புதுப்பிக்கப்பட்டது",
      "podcast_episode_deleted": "பாட்காஸ்ட் அத்தியாயம் நீக்கப்பட்டது",
      "content_imported": "உள்ளடக்கம் இறக்குமதி செய்யப்பட்டது",
      "widget_created": "விட்ஜெட் உருவாக்கப்பட்டது",
      "widget_updated": "விட்ஜெட் புதுப்பிக்கப்பட்டது",
      "widget_deleted": "விட்ஜெட் நீக்கப்பட்டது",
      "widget_published": "விட்ஜெட் வெளியிடப்பட்டது",
      "widget_unpublished": "விட்ஜெட் வெளியிடப்படவில்லை"
    },
    "placeholder": {
      "userId": "பயனர் ID ஐ உள்ளிடவும்",
      "discount": "0"
    },
    "titles": {
      "users": "பயனர்கள்",
      "transactions": "பரிவர்த்தனைகள்",
      "subscriptions": "சந்தாக்கள்",
      "refunds": "திரும்பப் பெறுதல்கள்",
      "plans": "திட்டங்கள்",
      "campaigns": "பிரச்சாரங்கள்",
      "auditLogs": "தணிக்கை பதிவுகள்",
      "pushNotifications": "புஷ் அறிவிப்புகள்",
      "billing": "கட்டணம்",
      "marketing": "சந்தைப்படுத்தல்",
      "content": "உள்ளடக்க நூலகம்",
      "categories": "வகைகள்",
      "liveChannels": "நேரலை சேனல்கள்",
      "radioStations": "வானொலி நிலையங்கள்",
      "podcasts": "பாட்காஸ்ட்கள்",
      "settings": "அமைப்புகள்"
    },
    "nav": {
      "dashboard": "டாஷ்போர்டு",
      "users": "பயனர்கள்",
      "campaigns": "பிரச்சாரங்கள்",
      "billing": "கட்டணம்",
      "billingOverview": "கண்ணோட்டம்",
      "transactions": "பரிவர்த்தனைகள்",
      "refunds": "திரும்பப் பெறுதல்கள்",
      "subscriptions": "சந்தாக்கள்",
      "subscriptionsList": "சந்தாதாரர்கள்",
      "plans": "திட்டங்கள்",
      "marketing": "சந்தைப்படுத்தல்",
      "marketingDashboard": "கண்ணோட்டம்",
      "emailCampaigns": "மின்னஞ்சல் பிரச்சாரங்கள்",
      "pushNotifications": "புஷ் அறிவிப்புகள்",
      "content": "உள்ளடக்கம்",
      "contentLibrary": "உள்ளடக்க நூலகம்",
      "categories": "வகைகள்",
      "liveChannels": "நேரலை சேனல்கள்",
      "radioStations": "வானொலி நிலையங்கள்",
      "podcasts": "பாட்காஸ்ட்கள்",
      "widgets": "விட்ஜெட்கள்",
      "recordings": "பதிவுகள்",
      "uploads": "பதிவேற்றங்கள்",
      "settings": "அமைப்புகள்",
      "auditLogs": "தணிக்கை பதிவுகள்",
      "librarian": "நூலகர் ஏஜெண்ட்",
      "featured": "சிறப்பு"
    },
    "featured": {
      "title": "சிறப்பு உள்ளடக்கம்",
      "subtitle": "முகப்பு கரவுசல்களுக்கான சிறப்பு உள்ளடக்கத்தை நிர்வகிக்கவும்",
      "empty": "சிறப்பு உள்ளடக்கம் இல்லை",
      "emptyHint": "சிறப்பு உருப்படிகள் முகப்பில் அந்தந்த கரவுசல்களில் தோன்றும்",
      "count": "{{count}} உருப்படிகள்",
      "confirmUnfeature": "சிறப்பிலிருந்து அகற்றவா?",
      "remove": "அகற்று",
      "unsavedChanges": "சேமிக்காத மாற்றங்கள் உள்ளன",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}} உருப்படி",
        "itemCount_plural": "{{count}} உருப்படிகள்",
        "empty": "சிறப்பு உருப்படிகள் இல்லை",
        "emptyHint": "சிறப்பு உருப்படிகள் முகப்பில் {{name}} கரவுசலில் தோன்றும்"
      },
      "saveButton": "{{count}} பகுதியைச் சேமி",
      "saveButton_plural": "{{count}} பகுதிகளைச் சேமி",
      "saving": "சேமிக்கிறது...",
      "saveSuccess": "சிறப்பு உள்ளடக்கம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
      "saveFailed": "சிறப்பு உள்ளடக்கத்தை சேமிக்க முடியவில்லை",
      "removeConfirm": "{{section}} இலிருந்து அகற்றவா?",
      "removeSuccess": "{{section}} இலிருந்து அகற்றப்பட்டது"
    },
    "recordings": {
      "title": "பதிவுகள் மேலாண்மை",
      "subtitle": "தளம் முழுவதும் பயனர் பதிவுகளை நிர்வகிக்கவும்",
      "totalRecordings": "மொத்த பதிவுகள்",
      "totalStorage": "மொத்த சேமிப்பகம்",
      "totalUsers": "பதிவுகளுடன் பயனர்கள்",
      "activeSessions": "செயலில் அமர்வுகள்",
      "searchPlaceholder": "தலைப்பு, பயனர் அல்லது சேனல் மூலம் தேடு...",
      "user": "பயனர்",
      "confirmDelete": "'{{title}}' பதிவை நீக்கவா? இந்த செயலை மீட்க முடியாது.",
      "deleteRecording": "பதிவை நீக்கு",
      "deleteSuccess": "பதிவு வெற்றிகரமாக நீக்கப்பட்டது",
      "deleteFailed": "பதிவை நீக்க முடியவில்லை",
      "loadFailed": "பதிவுகளை ஏற்ற முடியவில்லை",
      "noRecordings": "பதிவுகள் இல்லை",
      "noRecordingsHint": "இன்னும் அமைப்பில் பயனர் பதிவுகள் இல்லை."
    },
    "uploads": {
      "title": "பதிவேற்றங்கள் மேலாண்மை",
      "subtitle": "உள்ளடக்க பதிவேற்றங்கள் மற்றும் தானியங்கி கோப்புறை கண்காணிப்பை நிர்வகிக்கவும்",
      "activeUploads": "செயலில் பதிவேற்றங்கள்",
      "noActiveUploads": "செயலில் பதிவேற்றங்கள் இல்லை",
      "queuedUploads": "வரிசையில் பதிவேற்றங்கள்",
      "queued": "வரிசையில்",
      "andMore": "மேலும் {{count}}",
      "monitoredFolders": "கண்காணிக்கப்பட்ட கோப்புறைகள்",
      "noMonitoredFolders": "கண்காணிக்கப்பட்ட கோப்புறைகள் உள்ளமைக்கப்படவில்லை",
      "configureFoldersHelp": "தானியங்கி பதிவேற்றங்களுக்கு கண்காணிக்கப்பட்ட கோப்புறைகளை உள்ளமைக்க 'கோப்புறை சேர்' கிளிக் செய்யவும்",
      "addFolder": "கோப்புறை சேர்",
      "editFolder": "கோப்புறையைத் திருத்து",
      "deleteFolder": "கோப்புறையை நீக்கு",
      "confirmDelete": "இந்த கோப்புறையை நீக்கவா?",
      "triggerUpload": "பதிவேற்றத்தைத் தூண்டு",
      "triggerUploadSuccess": "பதிவேற்ற {{files_found}} புதிய கோப்புகள் கண்டுபிடிக்கப்பட்டன",
      "triggerUploadFailed": "பதிவேற்ற ஸ்கேனைத் தூண்ட முடியவில்லை",
      "noFilesFound": "கண்காணிக்கப்பட்ட கோப்புறைகளில் புதிய கோப்புகள் இல்லை",
      "sessionIssue": "[ta] Session Issue",
      "sessionIssueHelp": "[ta] Your session may have expired. Please refresh the page to restore connection.",
      "sessionExpired": "[ta] Session expired. Please refresh the page or log in again.",
      "unauthorized": "[ta] Session invalid. Please refresh the page.",
      "endpointNotFound": "[ta] Upload service not available. Check server configuration.",
      "timeout": "[ta] Upload scan timed out. Try again or check monitored folders.",
      "wsDisconnected": "[ta] Real-time Updates Disabled",
      "wsDisconnectedHelp": "[ta] WebSocket connection failed. Queue status may be outdated. Page will auto-retry.",
      "wsReconnecting": "[ta] Reconnecting to real-time updates...",
      "uploadAlreadyRunning": "[ta] Upload scan already in progress. Please wait for current uploads to complete.",
      "uploadsActiveNotice": "[ta] Uploads in progress ({{processing}} active, {{queued}} queued). New scan disabled until current batch completes.",
      "clearQueue": "[ta] Clear Queue",
      "clearQueueConfirmTitle": "[ta] Clear Upload Queue?",
      "clearQueueConfirmMessage": "[ta] This will cancel {{count}} active job(s). This action cannot be undone.",
      "clearQueueSuccess": "[ta] Queue cleared successfully",
      "clearQueueFailed": "[ta] Failed to clear queue",
      "cancelUpload": "[ta] Cancel",
      "cancelUploadConfirm": "[ta] Cancel this upload?",
      "cancelUploadSuccess": "[ta] Upload cancelled",
      "cancelUploadFailed": "[ta] Failed to cancel upload",
      "resetCache": "[ta] Reset Cache",
      "cacheResetSuccess": "[ta] Cache cleared: {{count}} files will be rescanned on next scan",
      "cacheResetFailed": "[ta] Failed to reset cache",
      "contentTypeFilters": "[ta] Content Type Filters",
      "contentTypeFiltersHelp": "[ta] Optional - Leave all unchecked to process all content types",
      "moviesOnly": "[ta] Movies Only",
      "seriesOnly": "[ta] Series Only",
      "audiobooksOnly": "[ta] Audiobooks Only",
      "type": "வகை",
      "lastScan": "கடைசி ஸ்கேன்",
      "systemInfo": "[ta] Upload System Information",
      "systemInfoText": "[ta] Automatically extracts subtitles from local video files during upload for faster processing",
      "languagesInfo": "[ta] Supported subtitle languages: English (en), Hebrew (he), Spanish (es)",
      "queueStatus": "பதிவேற்ற வரிசை",
      "totalJobs": "மொத்தம்",
      "processing": "செயலில்",
      "completed": "முடிந்தது",
      "skipped": "தவிர்க்கப்பட்டது",
      "failed": "தோல்வி",
      "queuePaused": "[ta] Queue Paused",
      "resumeQueue": "[ta] Resume",
      "activeUpload": "[ta] Active Upload",
      "queuedItems": "[ta] Queued",
      "noQueuedItems": "[ta] No items in queue",
      "addedAt": "[ta] Added",
      "recentCompleted": "[ta] Recently Completed",
      "stages": {
        "browserUpload": "சர்வருக்கு பதிவேற்றுகிறது",
        "hashCalculation": "ஹாஷ் கணக்கிடுகிறது",
        "duplicateCheck": "நகல்களைச் சரிபார்க்கிறது",
        "metadataExtraction": "மெட்டாடேட்டா பிரித்தெடுக்கிறது",
        "gcsUpload": "கிளவுட்க்கு பதிவேற்றுகிறது",
        "databaseInsert": "தரவுத்தளத்தில் சேமிக்கிறது",
        "imdbLookup": "IMDB தகவலைப் பெறுகிறது",
        "subtitleExtraction": "வசனங்களைப் பிரித்தெடுக்கிறது",
        "completed": "முடிந்தது",
        "failed": "தோல்வி",
        "skipped": "தவிர்க்கப்பட்டது"
      },
      "form": {
        "name": "கோப்புறை பெயர்",
        "namePlaceholder": "என் திரைப்படங்கள் கோப்புறை",
        "path": "கோப்புறை பாதை",
        "pathHelp": "சர்வர் பாதையை உள்ளிடவும் (எ.கா., /Volumes/USB Drive/Movies)",
        "contentType": "உள்ளடக்க வகை",
        "enabled": "இயக்கப்பட்டது",
        "autoUpload": "தானியங்கி பதிவேற்றம்"
      },
      "contentTypes": {
        "movie": "திரைப்படங்கள்",
        "series": "தொடர்கள்",
        "audiobook": "ஆடியோபுக்கள்"
      },
      "errors": {
        "pathRequired": "கோப்புறை பாதை தேவை"
      },
      "manualUpload": {
        "title": "[ta] Manual Upload",
        "subtitle": "[ta] Drag and drop files or select a folder",
        "dropHere": "[ta] Drop files here or click to browse",
        "dropHereActive": "[ta] Drop files to add them",
        "selectFolder": "[ta] Select Folder",
        "supportedFormats": "[ta] Supports video files (mp4, mkv, avi, mov, webm)",
        "selectedFiles": "[ta] Selected Files",
        "noFilesSelected": "[ta] No files selected",
        "clearAll": "[ta] Clear All",
        "uploadSelected": "[ta] Upload Selected",
        "selectContentType": "[ta] Select content type for upload",
        "uploadingFiles": "[ta] Adding {{count}} file(s) to queue...",
        "uploadSuccess": "[ta] Successfully added {{count}} file(s) to queue",
        "uploadFailed": "[ta] Failed to add files to queue",
        "fileSize": "[ta] Size",
        "removeFile": "[ta] Remove",
        "invalidFileType": "[ta] Invalid file type. Only video files are supported.",
        "filesCount": "[ta] {{count}} file(s) selected",
        "pendingRestore": "[ta] {{count}} file(s) pending from previous session",
        "pendingRestoreHint": "[ta] Drop or select the same files to restore your upload queue"
      }
    },
    "librarian": {
      "title": "நூலகர் ஏஜெண்ட்",
      "subtitle": "சுயாதீன AI-இயக்கப்படும் உள்ளடக்க நூலக மேலாண்மை",
      "loading": "நூலகர் ஏஜெண்ட் ஏற்றுகிறது...",
      "loadingConfig": "உள்ளமைவை ஏற்றுகிறது...",
      "refresh": "புதுப்பி",
      "errors": {
        "configError": "உள்ளமைவு பிழை",
        "configNotLoaded": "உள்ளமைவு ஏற்றப்படவில்லை",
        "failedToLoad": "நூலகர் தரவை ஏற்ற முடியவில்லை",
        "failedToLoadConfig": "நூலகர் உள்ளமைவை ஏற்ற முடியவில்லை",
        "failedToTrigger": "தணிக்கையைத் தூண்ட முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
        "failedToLoadDetails": "அறிக்கை விவரங்களை ஏற்ற முடியவில்லை.",
        "failedToRollback": "செயலை மீட்க முடியவில்லை.",
        "failedToClearReports": "[ta] Failed to clear audit reports. Please try again.",
        "failedToPause": "[ta] Failed to pause audit",
        "failedToResume": "[ta] Failed to resume audit",
        "failedToCancel": "[ta] Failed to cancel audit",
        "failedToInterject": "[ta] Failed to send message to AI agent",
        "auditAlreadyRunning": "ஒரு தணிக்கை ஏற்கனவே இயங்குகிறது. புதியதைத் தொடங்குவதற்கு முன் அது முடியும் வரை காத்திருக்கவும் அல்லது ரத்து செய்யவும்.",
        "budgetExceeded": "[ta] Monthly budget limit exceeded. Cannot run audit.",
        "contactAdmin": "[ta] The Librarian page cannot load without proper configuration.\nPlease contact your administrator."
      },
      "stats": {
        "systemHealth": "அமைப்பு நலம்",
        "totalAudits": "மொத்த தணிக்கைகள் (30 நாள்)",
        "last30Days": "கடந்த 30 நாட்கள்",
        "issuesFixed": "சரிசெய்யப்பட்ட சிக்கல்கள்",
        "lastAudit": "கடைசி தணிக்கை",
        "never": "ஒருபோதும்",
        "unknown": "தெரியாது"
      },
      "health": {
        "excellent": "சிறப்பானது",
        "good": "நல்லது",
        "fair": "சராசரி",
        "poor": "மோசமானது",
        "unknown": "தெரியாது"
      },
      "quickActions": {
        "title": "இயக்க உள்ளமைவு",
        "subtitle": "தணிக்கைகளை உள்ளமைத்து தூண்டவும்",
        "auditMode": "தணிக்கை முறை",
        "auditModeHelp": "என்ன சரிபார்க்க வேண்டும் என்பதைத் தேர்ந்தெடுக்கவும்",
        "dryRun": "முன்னோட்ட முறை",
        "dryRunHelp": "மாற்றங்கள் செய்யாமல் என்ன மாறும் என்பதைக் காட்டு",
        "scopeFilters": "[ta] Audit Capabilities",
        "scopeFiltersHelp": "[ta] Select capabilities to enable (multiple can be combined)",
        "last24Hours": "[ta] Recent Content Only",
        "last24HoursHelp": "[ta] Limit audit to content added in the last 24 hours",
        "cybTitlesOnly": "[ta] Clean Dirty Titles",
        "cybTitlesOnlyHelp": "[ta] Remove file extensions, quality markers, and release tags from titles",
        "tmdbPostersOnly": "[ta] TMDB Posters & Metadata",
        "tmdbPostersOnlyHelp": "[ta] Fetch missing posters, descriptions, and metadata from TMDB",
        "openSubtitlesEnabled": "[ta] Acquire Subtitles",
        "openSubtitlesEnabledHelp": "[ta] Download missing subtitles from OpenSubtitles (HE/EN/ES)",
        "classifyOnly": "[ta] Verify Classification",
        "classifyOnlyHelp": "[ta] Check and fix movie vs series classification errors",
        "purgeDuplicates": "[ta] Remove Duplicates",
        "purgeDuplicatesHelp": "[ta] Find and remove duplicate content items",
        "auditType": "[ta] Audit Type",
        "auditTypeHelp": "[ta] Choose between rule-based or AI-powered audit",
        "dailyAudit": "[ta] Daily Audit",
        "dailyBadge": "[ta] Rule-Based • Fast • Free",
        "dailyDescription": "[ta] Runs predefined checks on content modified in the last 7 days. Fast and predictable, no AI costs.",
        "aiAgentAudit": "[ta] AI Agent Audit",
        "aiAgentBadge": "[ta] AI-Powered • Intelligent • Uses Budget",
        "aiAgentDescription": "[ta] Autonomous AI agent (Claude) makes intelligent decisions about what to check and fix. More comprehensive but uses API budget.",
        "triggerDaily": "தினசரி தணிக்கையை இயக்கு",
        "triggerAI": "AI ஏஜெண்ட் தணிக்கையை இயக்கு",
        "auditRunningNotice": "[ta] An audit is currently running. Buttons will be enabled when it completes.",
        "budgetLabel": "[ta] AI Agent Budget Limit: ${{budget}}",
        "budgetPerAudit": "[ta] Budget per Audit",
        "monthlyBudgetUsed": "[ta] Budget Used (30d)",
        "monthlyBudgetLimit": "[ta] / ${{limit}} monthly",
        "budgetWarning": "[ta] Running this audit would exceed monthly budget limit",
        "aiAuditSuccess": "[ta] AI Agent audit triggered successfully. {{dryRun}}",
        "dailyAuditSuccess": "[ta] Daily audit triggered successfully. {{dryRun}}",
        "dryRunMode": "[ta] (Dry run mode)",
        "rollbackSuccess": "[ta] Action rolled back successfully."
      },
      "voice": {
        "title": "[ta] Voice Control",
        "description": "[ta] Use your voice to give commands to the librarian. Just press the button and speak naturally.",
        "pressToSpeak": "[ta] Press to Speak",
        "listening": "[ta] Listening...",
        "transcript": "[ta] Transcript",
        "processing": "[ta] Processing your command...",
        "speaking": "[ta] Librarian is responding...",
        "examples": "[ta] Example Commands",
        "example1": "[ta] Check for missing posters in the last 24 hours",
        "example2": "[ta] Fix metadata for CYB titles",
        "example3": "[ta] Scan for broken streaming URLs",
        "example4": "[ta] Extract subtitles from movies",
        "notSupported": "[ta] Voice recognition is not supported in your browser. Please use Chrome, Edge, or Safari.",
        "notAvailable": "[ta] Voice control is not available",
        "noSpeech": "[ta] No speech detected. Please try again.",
        "noMicrophone": "[ta] No microphone detected. Please check your device.",
        "microphoneBlocked": "[ta] Microphone access was blocked. Please enable it in your browser settings.",
        "error": "[ta] Speech recognition error: {{error}}",
        "startFailed": "[ta] Failed to start voice recognition. Please try again.",
        "commandFailed": "[ta] Failed to execute command. Please try again."
      },
      "schedules": {
        "title": "[ta] Scheduled Audits",
        "subtitle": "[ta] Configure daily and weekly audit schedules",
        "dailyTitle": "[ta] Daily Audit",
        "weeklyTitle": "[ta] Weekly AI Audit",
        "schedule": "[ta] Schedule",
        "time": "[ta] Time",
        "mode": "[ta] Mode",
        "cost": "[ta] Est. Cost",
        "status": "[ta] Status",
        "description": "[ta] Description",
        "viewInConsole": "[ta] View in Cloud Console",
        "modifyNote": "[ta] To modify schedules, use Google Cloud Console",
        "editTitle": "[ta] Edit Schedule",
        "editNotAvailable": "[ta] Schedule Editing Not Available",
        "editNotAvailableMessage": "[ta] Schedule modifications require Cloud Scheduler API integration. Please use the 'View in Cloud Console' button to modify schedules directly in Google Cloud Console.",
        "cronExpression": "[ta] Cron Expression",
        "cronHint": "[ta] Format: minute hour day month weekday (e.g., 0 2 * * * = daily at 2:00 AM)",
        "patterns": {
          "daily": "[ta] Daily at {{hour}}:{{minute}}",
          "weekly": "[ta] Every {{day}} at {{hour}}:{{minute}}"
        },
        "days": {
          "sunday": "[ta] Sunday",
          "monday": "[ta] Monday",
          "tuesday": "[ta] Tuesday",
          "wednesday": "[ta] Wednesday",
          "thursday": "[ta] Thursday",
          "friday": "[ta] Friday",
          "saturday": "[ta] Saturday"
        }
      },
      "reports": {
        "title": "சமீபத்திய தணிக்கை அறிக்கைகள்",
        "emptyMessage": "இன்னும் தணிக்கை அறிக்கைகள் இல்லை",
        "totalReports": "{{count}} அறிக்கை(கள்)",
        "clearAll": "அனைத்தையும் அழி",
        "confirmClearAll": "[ta] Are you sure you want to clear all audit reports? This action cannot be undone.",
        "clearedSuccessfully": "[ta] All audit reports cleared successfully",
        "viewLogs": "[ta] View Logs",
        "viewDetails": "விவரங்களைக் காண்",
        "columns": {
          "date": "தேதி",
          "type": "வகை",
          "duration": "கால அளவு",
          "status": "நிலை",
          "issues": "சிக்கல்கள்",
          "fixes": "திருத்தங்கள்",
          "actions": "செயல்கள்"
        },
        "detailModal": {
          "title": "[ta] Audit Report: {{id}}",
          "summary": "[ta] Summary",
          "status": "[ta] Status",
          "executionTime": "[ta] Execution Time",
          "totalItems": "[ta] Total Items",
          "healthyItems": "[ta] Healthy Items",
          "issuesFound": "[ta] Issues Found",
          "totalIssues": "[ta] Total Issues Found",
          "seeInsightsBelow": "[ta] See AI Insights below for details",
          "brokenStreams": "[ta] Broken Streams",
          "missingMetadata": "[ta] Missing Metadata",
          "misclassifications": "[ta] Misclassifications",
          "orphanedItems": "[ta] Orphaned Items",
          "fixesApplied": "[ta] Fixes Applied",
          "totalFixes": "[ta] {{count}} total fixes",
          "aiInsights": "[ta] AI Insights"
        }
      },
      "logs": {
        "title": "[ta] Execution Logs",
        "liveAuditLog": "[ta] Live Audit Log",
        "executionLog": "[ta] Audit Execution Log",
        "searchPlaceholder": "[ta] Search logs...",
        "noLogs": "[ta] No logs to display",
        "noActiveAudit": "[ta] No Active Audit",
        "triggerAuditToSee": "[ta] Trigger an audit to see live execution logs here",
        "auditType": "[ta] Audit Type",
        "started": "[ta] Started",
        "completed": "[ta] Completed",
        "lastLog": "[ta] Last log",
        "staleWarning": "[ta] No new logs for {{seconds}}s - job may be processing or stuck",
        "pollingStatus": "[ta] Polling active • Last checked",
        "connecting": "[ta] Connecting to live audit log...",
        "aiInsightPrefix": "[ta] AI Insight",
        "source": {
          "librarian": "[ta] Librarian",
          "aiAgent": "[ta] AI Agent"
        },
        "levels": {
          "debug": "[ta] DEBUG",
          "info": "[ta] INFO",
          "warn": "[ta] WARN",
          "error": "[ta] ERROR",
          "success": "[ta] SUCCESS",
          "trace": "[ta] TRACE"
        },
        "auditStarted": "[ta] Audit started",
        "brokenStreamsFound": "[ta] Found {{count}} broken stream(s)",
        "missingMetadataFound": "[ta] Found {{count}} item(s) with missing metadata",
        "misclassificationsFound": "[ta] Found {{count}} misclassified item(s)",
        "orphanedItemsFound": "[ta] Found {{count}} orphaned item(s)",
        "fixesApplied": "[ta] Applied {{count}} fix(es)",
        "auditCompleted": "[ta] Audit {{status}} in {{duration}}s",
        "auditInitializing": "[ta] 🚀 Initializing {{auditType}} audit...",
        "dryRunMode": "[ta] ⚠️ Running in DRY RUN mode - no changes will be made",
        "liveMode": "[ta] ✅ Running in LIVE mode - changes will be applied",
        "budgetSet": "[ta] 💰 Budget limit: ${{budget}}",
        "connectingToAgent": "[ta] 🔗 Connecting to Claude AI Agent..."
      },
      "audit": {
        "types": {
          "aiAgent": "[ta] AI Agent",
          "dailyIncremental": "[ta] Daily Incremental"
        },
        "pause": "[ta] Pause",
        "resume": "[ta] Resume",
        "cancel": "[ta] Cancel",
        "interject": "[ta] Interject",
        "interjectTitle": "[ta] Send Message to AI Agent",
        "interjectHint": "[ta] This message will be injected into the AI agent conversation at the next iteration. Use it to provide additional context, redirect focus, or give specific instructions.",
        "interjectPlaceholder": "[ta] e.g., Focus only on movies, skip series for now...",
        "sendInterject": "[ta] Send",
        "interjectSuccess": "[ta] Message sent to AI agent successfully",
        "pauseSuccess": "[ta] Audit paused successfully",
        "resumeSuccess": "[ta] Audit resumed successfully",
        "cancelSuccess": "[ta] Audit cancelled successfully"
      },
      "progress": {
        "batch": "[ta] Batch {{current}} of {{total}}",
        "items": "[ta] {{processed}} of {{total}} items",
        "finishing": "[ta] Finishing up...",
        "finalizing": "[ta] Generating report and applying fixes"
      },
      "activityLog": {
        "title": "[ta] Activity Log",
        "subtitle": "[ta] {{count}} actions recorded",
        "filterByType": "[ta] Filter by type",
        "allActions": "[ta] All Actions",
        "content": "[ta] Content",
        "noDescription": "[ta] No description available",
        "updatedFields": "[ta] Updated {{fields}}",
        "pagination": "[ta] Page {{page}} of {{totalPages}}",
        "issueType": "[ta] Issue Type",
        "confidence": "[ta] Confidence",
        "autoApproved": "[ta] Auto-approved",
        "changes": "[ta] Changes",
        "actionTypes": {
          "addPoster": "[ta] Add Poster",
          "updateMetadata": "[ta] Update Metadata",
          "recategorize": "[ta] Recategorize",
          "fixUrl": "[ta] Fix URL",
          "cleanTitle": "[ta] Clean Title",
          "classify": "[ta] Classify"
        },
        "rollback": "[ta] Rollback",
        "rolledBack": "[ta] Rolled Back",
        "confirmRollback": {
          "title": "[ta] Confirm Rollback",
          "message": "[ta] Are you sure you want to rollback this action? This will restore the previous state."
        },
        "emptyMessage": "[ta] No actions found"
      },
      "modal": {
        "confirmAI": {
          "title": "[ta] Trigger AI Agent Audit?",
          "message": "[ta] This will trigger an autonomous AI agent audit with a budget limit of ${{budget}}. The agent will make decisions about what to check and fix. {{dryRun}}",
          "dryRunNote": "[ta] Running in DRY RUN mode (no changes will be made)."
        },
        "cancel": "[ta] Cancel",
        "confirm": "[ta] Confirm",
        "close": "[ta] Close",
        "retry": "[ta] Retry"
      },
      "status": {
        "enabled": "இயக்கப்பட்டது",
        "disabled": "முடக்கப்பட்டது",
        "completed": "தணிக்கை முடிந்தது",
        "failed": "தணிக்கை தோல்வி",
        "in_progress": "செயலில்",
        "partial": "[ta] Partially Complete",
        "pending": "நிலுவையில்",
        "running": "இயங்குகிறது"
      },
      "auditTypes": {
        "daily_incremental": "[ta] daily incremental",
        "ai_agent": "[ta] AI Agent"
      }
    },
    "widgets": {
      "title": "விட்ஜெட்கள்",
      "subtitle": "நேரலை ஸ்ட்ரீம்கள் மற்றும் எம்பெட்களுக்கான மிதக்கும் மேலடுக்கு விட்ஜெட்களை நிர்வகிக்கவும்",
      "newWidget": "புதிய விட்ஜெட்",
      "editWidget": "விட்ஜெட்டைத் திருத்து",
      "columns": {
        "title": "தலைப்பு",
        "contentType": "உள்ளடக்க வகை",
        "targetRoles": "இலக்கு பங்குகள்",
        "targetPages": "இலக்கு பக்கங்கள்",
        "status": "நிலை",
        "order": "வரிசை"
      },
      "contentTypes": {
        "liveChannel": "நேரலை சேனல்",
        "live": "நேரலை",
        "vod": "வீடியோ ஆன் டிமாண்ட்",
        "podcast": "பாட்காஸ்ட்",
        "radio": "வானொலி",
        "iframe": "Iframe"
      },
      "status": {
        "active": "செயலில்",
        "inactive": "செயலில் இல்லை"
      },
      "form": {
        "title": "விட்ஜெட் தலைப்பு",
        "description": "விளக்கம் (விருப்பத்தேர்வு)",
        "icon": "ஐகான் எமோஜி (விருப்பத்தேர்வு)",
        "contentType": "உள்ளடக்க வகை",
        "selectChannel": "நேரலை சேனலைத் தேர்ந்தெடுக்கவும்",
        "channelPlaceholder": "-- சேனலைத் தேர்ந்தெடுக்கவும் --",
        "iframeUrl": "Iframe URL",
        "iframeTitle": "Iframe தலைப்பு (அணுகல்தன்மைக்காக)",
        "position": "இயல்பு நிலை",
        "behavior": "நடத்தை",
        "mutedByDefault": "இயல்பாக ஒலியடக்கப்பட்டது",
        "closable": "மூடக்கூடியது",
        "draggable": "இழுக்கக்கூடியது",
        "targetPages": "இலக்கு பக்கங்கள் (கமாவால் பிரிக்கப்பட்டது, காலி = அனைத்தும்)",
        "targetPagesPlaceholder": "/, /live, /vod",
        "order": "வரிசை"
      },
      "actions": {
        "save": "சேமி",
        "cancel": "ரத்து செய்"
      },
      "confirmDelete": "இந்த விட்ஜெட்டை நீக்க விரும்புகிறீர்களா?",
      "emptyMessage": "விட்ஜெட்கள் இல்லை. தொடங்க ஒன்றை உருவாக்கவும்.",
      "allPages": "அனைத்து பக்கங்கள்",
      "allRoles": "அனைத்தும்",
      "errors": {
        "titleRequired": "தலைப்பு தேவை",
        "selectChannel": "நேரலை சேனலைத் தேர்ந்தெடுக்கவும்",
        "iframeUrlRequired": "Iframe URL தேவை"
      }
    },
    "billing": {
      "subtitle": "வருவாய் மற்றும் கட்டணங்களைக் கண்காணிக்கவும்",
      "revenue": "வருவாய்",
      "today": "இன்று",
      "thisWeek": "இந்த வாரம்",
      "thisMonth": "இந்த மாதம்",
      "thisYear": "இந்த வருடம்",
      "metrics": "முக்கிய அளவீடுகள்",
      "totalTransactions": "மொத்த பரிவர்த்தனைகள்",
      "avgTransaction": "சராசரி பரிவர்த்தனை",
      "pendingRefunds": "நிலுவையில் திரும்பப் பெறுதல்கள்",
      "refundRate": "திரும்பப் பெறுதல் விகிதம்",
      "retention": "தக்கவைப்பு",
      "retentionRate": "தக்கவைப்பு விகிதம்",
      "churnRate": "விலகல் விகிதம்",
      "atRiskUsers": "ஆபத்தில் உள்ள பயனர்கள்",
      "churnedUsers": "விலகிய பயனர்கள்",
      "quickLinks": "விரைவு இணைப்புகள்"
    },
    "marketing": {
      "recentCampaigns": "சமீபத்திய பிரச்சாரங்கள்",
      "audienceSegments": "பார்வையாளர் பிரிவுகள்",
      "emailMetrics": "மின்னஞ்சல் அளவீடுகள்",
      "pushMetrics": "புஷ் அளவீடுகள்",
      "quickActions": "விரைவு செயல்கள்"
    },
    "push": {
      "titlePlaceholder": "அறிவிப்பு தலைப்பு",
      "bodyPlaceholder": "அறிவிப்பு செய்தி"
    },
    "auditLogs": {
      "subtitle": "அனைத்து அமைப்பு செயல்களையும் கண்காணிக்கவும்",
      "filter": "வடிகட்டு",
      "export": "ஏற்றுமதி",
      "all": "அனைத்தும்",
      "advancedFiltering": "மேம்பட்ட வடிகட்டுதல்",
      "actionType": "செயல் வகை",
      "clear": "அழி",
      "apply": "பயன்படுத்து",
      "noRecords": "பதிவுகள் இல்லை",
      "columns": {
        "action": "செயல்",
        "user": "பயனர்",
        "resource": "வளம்",
        "details": "விவரங்கள்",
        "date": "தேதி",
        "ip": "IP"
      },
      "changed": "மாற்றப்பட்டது",
      "actionFilters": {
        "user": "பயனர்",
        "subscription": "சந்தா",
        "payment": "கட்டணம்",
        "settings": "அமைப்புகள்",
        "campaign": "பிரச்சாரம்",
        "content": "உள்ளடக்கம்"
      }
    },
    "settings": {
      "subtitle": "அமைப்பு அளவுருக்களை உள்ளமைக்கவும்",
      "saveChanges": "மாற்றங்களைச் சேமி",
      "generalSettings": "பொது அமைப்புகள்",
      "supportEmail": "ஆதரவு மின்னஞ்சல்",
      "defaultPlan": "இயல்பு திட்டம்",
      "termsUrl": "சேவை விதிமுறைகள் URL",
      "privacyUrl": "தனியுரிமைக் கொள்கை URL",
      "userSettings": "பயனர் அமைப்புகள்",
      "maxDevices": "கணக்கிற்கு அதிகபட்ச சாதனங்கள்",
      "trialDays": "சோதனைக் காலம் நாட்கள்",
      "maintenanceMode": "பராமரிப்பு பயன்முறை",
      "maintenanceModeDesc": "இயக்கப்பட்டால், பயனர்கள் அமைப்பை அணுக முடியாது",
      "featureFlags": "அம்ச கொடிகள்",
      "systemActions": "அமைப்பு செயல்கள்",
      "clearCache": "கேச் அழி",
      "resetAnalytics": "பகுப்பாய்வு மீட்டமை",
      "actionsWarning": "இந்த செயல்கள் அமைப்பு செயல்திறனை பாதிக்கலாம். கவனமாகப் பயன்படுத்தவும்.",
      "savingSuccess": "அமைப்புகள் வெற்றிகரமாக சேமிக்கப்பட்டன",
      "confirmClearCache": "கேச் அழிக்கவா? இது செயல்திறனை தற்காலிகமாக பாதிக்கலாம்.",
      "cacheCleared": "கேச் வெற்றிகரமாக அழிக்கப்பட்டது",
      "confirmResetAnalytics": "பகுப்பாய்வு தரவை மீட்டமைக்கவா? இந்த செயலை மீட்க முடியாது!",
      "analyticsReset": "பகுப்பாய்வு தரவு மீட்டமைக்கப்பட்டது",
      "featureFlagLabels": {
        "new_player": "புதிய பிளேயர்",
        "live_chat": "நேரடி அரட்டை",
        "downloads": "பதிவிறக்கங்கள்",
        "watch_party": "வாட்ச் பார்ட்டி",
        "voice_search": "குரல் தேடல்",
        "ai_recommendations": "AI பரிந்துரைகள்"
      }
    },
    "content": {
      "title": "[ta] Content Library",
      "subtitle": "[ta] Manage movies, series, and video content",
      "importFree": "[ta] Import Free Content",
      "searchPlaceholder": "[ta] Search content...",
      "emptyMessage": "[ta] No content found",
      "confirmDelete": "[ta] Delete this content?",
      "confirmBatchDelete": "[ta] Are you sure you want to delete {{count}} item(s)?",
      "selectedItems": "[ta] {{count}} item(s) selected",
      "batchFeature": "[ta] Feature",
      "batchUnfeature": "[ta] Unfeature",
      "import": {
        "pageTitle": "[ta] Import Free Content",
        "subtitle": "[ta] Browse and import public content from free sources",
        "selectCategory": "[ta] Select category for imported movies:",
        "categoryPlaceholder": "[ta] Select a category...",
        "loading": "[ta] Loading sources...",
        "sourceTypes": {
          "vod": "[ta] Movies & VOD",
          "live_tv": "[ta] Live TV",
          "radio": "[ta] Radio",
          "podcasts": "[ta] Podcasts"
        },
        "items": "[ta] item",
        "itemsPlural": "[ta] items",
        "selectItems": "[ta] Please select at least one item to import",
        "selectCategory_vod": "[ta] Please select a category for VOD imports",
        "importing": "[ta] Importing {{count}}... {{percent}}%",
        "importButton": "[ta] Import {{count}} {{item}}",
        "noSources": "[ta] No Sources Available",
        "noSourcesDescription": "[ta] No free content sources are currently available for {{type}}"
      },
      "filters": {
        "title": "வடிப்பான்கள்",
        "contentType": "உள்ளடக்க வகை",
        "all": "அனைத்தும்",
        "allContent": "அனைத்தும்",
        "series": "தொடர்கள்",
        "movies": "திரைப்படங்கள்",
        "podcasts": "பாட்காஸ்ட்கள்",
        "radioStations": "வானொலி நிலையங்கள்",
        "status": "நிலை",
        "allStatus": "அனைத்து நிலைகள்",
        "subtitles": "வசன வரிகள்"
      },
      "podcastsComingSoon": "பாட்காஸ்ட் மேலாண்மை விரைவில் வருகிறது. பாட்காஸ்ட் பகுதியைப் பயன்படுத்தவும்.",
      "radioComingSoon": "வானொலி நிலைய மேலாண்மை விரைவில் வருகிறது. வானொலி நிலையங்கள் பகுதியைப் பயன்படுத்தவும்.",
      "showOnlyWithSubtitles": "[ta] Show only with subtitles",
      "status": {
        "published": "[ta] Published",
        "draft": "[ta] Draft"
      },
      "columns": {
        "title": "[ta] Title",
        "category": "[ta] Category",
        "year": "[ta] Year",
        "status": "[ta] Status",
        "views": "[ta] Views",
        "rating": "[ta] Rating",
        "streamUrl": "[ta] Stream URL",
        "epgSource": "[ta] EPG Source",
        "genre": "[ta] Genre",
        "episodeNumber": "[ta] Episode #",
        "description": "[ta] Description",
        "duration": "[ta] Duration",
        "publishedDate": "[ta] Published",
        "episodes": "[ta] Episodes",
        "order": "[ta] Order",
        "name": "[ta] Name",
        "slug": "[ta] Slug",
        "subtitles": "[ta] Subtitles"
      },
      "validation": {
        "titleRequired": "[ta] Title is required",
        "nameRequired": "[ta] Name is required",
        "streamUrlRequired": "[ta] Stream URL is required",
        "audioUrlRequired": "[ta] Audio URL is required"
      },
      "episodes_one": "[ta] episode",
      "episodes_other": "[ta] episodes",
      "noEpisodes": "[ta] No episodes found",
      "type": {
        "series": "[ta] Series",
        "movie": "[ta] Movie"
      },
      "toggleCarousel": "[ta] Toggle carousel",
      "editor": {
        "pageTitle": "[ta] Edit Content",
        "pageTitleNew": "[ta] Add Content",
        "sections": {
          "basicInfo": "[ta] Basic Information",
          "media": "[ta] Media",
          "streaming": "[ta] Streaming",
          "details": "[ta] Content Details",
          "publishing": "[ta] Publishing",
          "accessControl": "[ta] Access Control",
          "podcastDetails": "[ta] Podcast Details",
          "episodeDetails": "[ta] Episode Details",
          "stationDetails": "[ta] Station Details",
          "channelDetails": "[ta] Channel Details"
        },
        "fields": {
          "title": "[ta] Title",
          "titlePlaceholder": "[ta] Content title",
          "titleRequired": "[ta] Title is required",
          "year": "[ta] Year",
          "yearPlaceholder": "[ta] 2024",
          "description": "[ta] Description",
          "descriptionPlaceholder": "[ta] Content description",
          "thumbnail": "[ta] Thumbnail (3:4 aspect ratio)",
          "thumbnailUrl": "[ta] Thumbnail URL",
          "thumbnailUrlPlaceholder": "[ta] https://example.com/thumbnail.jpg",
          "backdrop": "[ta] Backdrop (16:9 aspect ratio)",
          "backdropUrl": "[ta] Backdrop URL",
          "posterCover": "[ta] Podcast Cover",
          "logo": "[ta] Logo",
          "channelLogo": "[ta] Channel Logo",
          "stationLogo": "[ta] Station Logo",
          "streamUrl": "[ta] Stream URL",
          "streamUrlRequired": "[ta] Stream URL is required",
          "streamType": "[ta] Stream Type",
          "drmProtected": "[ta] DRM Protected",
          "drmProtectedLabel": "[ta] This content requires DRM protection",
          "category": "[ta] Category",
          "categoryRequired": "[ta] Category is required",
          "duration": "[ta] Duration",
          "durationPlaceholder": "[ta] 1:30:00",
          "rating": "[ta] Rating",
          "ratingPlaceholder": "[ta] PG-13",
          "genre": "[ta] Genre",
          "genrePlaceholder": "[ta] Drama",
          "director": "[ta] Director",
          "directorPlaceholder": "[ta] Director name",
          "isSeries": "[ta] Series",
          "isSeriesLabel": "[ta] This is a series/multi-part content",
          "season": "[ta] Season",
          "episode": "[ta] Episode",
          "seriesId": "[ta] Series ID",
          "seriesIdPlaceholder": "[ta] series-identifier",
          "isPublished": "[ta] Publish",
          "isPublishedLabel": "[ta] Publish this content immediately",
          "isFeatured": "[ta] Feature",
          "isFeaturedLabel": "[ta] Feature this content on homepage",
          "requiresSubscription": "[ta] Required Subscription",
          "isKidsContent": "[ta] Kids Content",
          "isKidsContentLabel": "[ta] This is kids-friendly content",
          "author": "[ta] Author",
          "authorPlaceholder": "[ta] Podcast author",
          "podcastCategory": "[ta] Category",
          "podcastCategoryPlaceholder": "[ta] News, Science, etc.",
          "rssFeed": "[ta] RSS Feed URL",
          "rssFeedPlaceholder": "[ta] https://example.com/feed.xml",
          "website": "[ta] Website URL",
          "websitePlaceholder": "[ta] https://example.com",
          "episodeNumber": "[ta] Episode #",
          "seasonNumber": "[ta] Season #",
          "audioUrl": "[ta] Audio URL",
          "audioUrlRequired": "[ta] Audio URL is required",
          "audioUrlPlaceholder": "[ta] https://example.com/episode.mp3",
          "publishedAt": "[ta] Published Date",
          "epgSource": "[ta] EPG Source URL",
          "epgSourcePlaceholder": "[ta] https://example.com/epg.xml",
          "currentShow": "[ta] Current Show",
          "currentShowPlaceholder": "[ta] Show name",
          "nextShow": "[ta] Next Show",
          "nextShowPlaceholder": "[ta] Show name",
          "currentSong": "[ta] Current Song",
          "currentSongPlaceholder": "[ta] Song title",
          "isActive": "[ta] Active",
          "isActiveLabel": "[ta] Channel is active",
          "requiredSubscription": "[ta] Required Subscription",
          "publishedDate": "[ta] Published Date"
        },
        "subscriptionTiers": {
          "basic": "[ta] Basic",
          "premium": "[ta] Premium",
          "family": "[ta] Family"
        },
        "actions": {
          "save": "[ta] Save",
          "saving": "[ta] Saving...",
          "cancel": "[ta] Cancel"
        },
        "imageUpload": {
          "dropHere": "[ta] Drop image here or click to upload",
          "formats": "[ta] PNG, JPG, WebP up to {{maxSize}}MB",
          "uploading": "[ta] Uploading...",
          "success": "[ta] Image uploaded successfully",
          "orPasteUrl": "[ta] Or paste image URL",
          "urlPlaceholder": "[ta] https://example.com/image.jpg",
          "validateButton": "[ta] Add",
          "validating": "[ta] Validating...",
          "clear": "[ta] Remove image",
          "errors": {
            "imageOnly": "[ta] Please select an image file",
            "tooLarge": "[ta] File size must be less than {{maxSize}}MB",
            "uploadFailed": "[ta] Upload failed",
            "invalidUrl": "[ta] Invalid URL"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "[ta] Select category...",
        "searchPlaceholder": "[ta] Search categories...",
        "loading": "[ta] Loading categories...",
        "noResults": "[ta] No categories found",
        "noCategories": "[ta] No categories available",
        "createNew": "[ta] Create new category",
        "errors": {
          "loadFailed": "[ta] Failed to load categories",
          "createFailed": "[ta] Failed to create category"
        },
        "modal": {
          "title": "[ta] Create New Category",
          "placeholder": "[ta] Category name (e.g., Movies, Series)",
          "creating": "[ta] Creating...",
          "create": "[ta] Create"
        }
      },
      "streamUrlInput": {
        "copyUrl": "[ta] Copy URL",
        "copied": "[ta] URL copied to clipboard",
        "streamType": "[ta] Stream Type",
        "validUrl": "[ta] URL is valid - detected as {{type}}",
        "errors": {
          "required": "[ta] Stream URL is required",
          "invalidFormat": "[ta] Invalid URL format"
        },
        "supportedFormats": {
          "title": "[ta] Supported formats:",
          "hls": "[ta] HLS: .m3u8 streams",
          "dash": "[ta] DASH: .mpd streams",
          "audio": "[ta] Audio: .mp3, .aac, or audio streams"
        }
      }
    },
    "categories": {
      "subtitle": "உள்ளடக்க வகைகளை நிர்வகிக்கவும்",
      "emptyMessage": "வகைகள் இல்லை",
      "status": {
        "active": "செயலில்",
        "inactive": "செயலில் இல்லை"
      },
      "form": {
        "nameHebrew": "வகை பெயர் (எபிரேயம்)",
        "nameEnglish": "வகை பெயர் (ஆங்கிலம்)",
        "slug": "ஸ்லக்"
      }
    },
    "liveChannels": {
      "subtitle": "நேரலை TV சேனல்களை நிர்வகிக்கவும்",
      "emptyMessage": "நேரலை சேனல்கள் இல்லை",
      "subtitleSettings": "நேரலை வசன அமைப்புகள்",
      "form": {
        "name": "சேனல் பெயர்",
        "streamUrl": "ஸ்ட்ரீம் URL",
        "epgSource": "EPG மூல URL (விருப்பத்தேர்வு)",
        "currentShow": "தற்போதைய நிகழ்ச்சி",
        "order": "வரிசை",
        "supportsSubtitles": "நேரலை வசனங்களை இயக்கு",
        "primaryLanguage": "முதன்மை மொழி (மூலம்)",
        "targetLanguages": "கிடைக்கும் மொழிபெயர்ப்பு மொழிகள்",
        "targetLanguagesHelp": "பயனர்கள் நிகழ்நேரத்தில் மொழிபெயர்க்கக்கூடிய மொழிகளைத் தேர்ந்தெடுக்கவும்"
      }
    },
    "radioStations": {
      "subtitle": "வானொலி நிலையங்களை நிர்வகிக்கவும்",
      "emptyMessage": "வானொலி நிலையங்கள் இல்லை",
      "form": {
        "name": "நிலையம் பெயர்",
        "genre": "வகை",
        "streamUrl": "ஸ்ட்ரீம் URL",
        "currentShow": "தற்போதைய நிகழ்ச்சி (விருப்பத்தேர்வு)",
        "currentSong": "தற்போதைய பாடல் (விருப்பத்தேர்வு)",
        "order": "வரிசை"
      }
    },
    "podcasts": {
      "subtitle": "பாட்காஸ்ட்கள் மற்றும் அத்தியாயங்களை நிர்வகிக்கவும்",
      "episodesSubtitle": "அத்தியாயங்களை நிர்வகிக்கவும்",
      "emptyMessage": "பாட்காஸ்ட்கள் இல்லை",
      "noEpisodes": "அத்தியாயங்கள் இல்லை",
      "form": {
        "title": "பாட்காஸ்ட் தலைப்பு",
        "author": "ஆசிரியர்",
        "description": "விளக்கம்",
        "category": "வகை",
        "rssFeed": "RSS ஊட்ட URL",
        "website": "வலைத்தள URL (விருப்பத்தேர்வு)"
      },
      "episodes": {
        "form": {
          "title": "அத்தியாயம் தலைப்பு",
          "description": "விளக்கம்",
          "episodeNumber": "அத்தியாயம் எண்",
          "seasonNumber": "சீசன் எண் (விருப்பத்தேர்வு)",
          "duration": "கால அளவு",
          "audioUrl": "ஆடியோ URL (தேவை)",
          "publishedDate": "வெளியிடப்பட்ட தேதி (YYYY-MM-DD)"
        }
      }
    },
    "users": {
      "subtitle": "பயனர்கள் மற்றும் கணக்குகளை நிர்வகிக்கவும்",
      "addUser": "பயனர் சேர்",
      "status": {
        "active": "செயலில்",
        "inactive": "செயலில் இல்லை",
        "blocked": "தடுக்கப்பட்டது"
      },
      "filters": {
        "all": "அனைத்தும்",
        "active": "செயலில்",
        "inactive": "செயலில் இல்லை",
        "blocked": "தடுக்கப்பட்டது"
      },
      "columns": {
        "name": "பெயர்",
        "role": "பங்கு",
        "subscription": "சந்தா",
        "noSubscription": "சந்தா இல்லை",
        "status": "நிலை",
        "created": "உருவாக்கப்பட்டது",
        "actions": "செயல்கள்"
      },
      "confirmDelete": "பயனரை நீக்கு",
      "confirmDeleteMessage": "{{name}} ஐ நீக்க விரும்புகிறீர்களா? இந்த செயலை மீட்க முடியாது.",
      "resetPassword": "கடவுச்சொல்லை மீட்டமை",
      "block": "தடு",
      "unban": "தடையை நீக்கு",
      "confirmResetPassword": "{{email}} க்கு கடவுச்சொல் மீட்டமை மின்னஞ்சல் அனுப்பவா?",
      "resetPasswordSent": "கடவுச்சொல் மீட்டமை மின்னஞ்சல் அனுப்பப்பட்டது",
      "recentActivity": "சமீபத்திய செயல்பாடு",
      "noActivity": "செயல்பாடு இல்லை",
      "notFound": "பயனர் இல்லை",
      "backToList": "பட்டியலுக்குத் திரும்பு",
      "banReason": "தடைக்கான காரணம்",
      "banReasonPrompt": "தடைக்கான காரணம்:",
      "confirmUnban": "பயனர் தடையை நீக்கவா?",
      "userDetails": "பயனர் விவரங்கள்",
      "id": "ID",
      "registered": "பதிவுசெய்யப்பட்டது",
      "billingHistory": "கட்டண வரலாறு",
      "noPayments": "கட்டணங்கள் இல்லை"
    },
    "campaigns": {
      "subtitle": "கூப்பன் குறியீடுகள் மற்றும் தள்ளுபடிகளை நிர்வகிக்கவும்",
      "expired": "காலாவதியானது",
      "status": {
        "active": "செயலில்",
        "inactive": "செயலில் இல்லை"
      },
      "columns": {
        "name": "பெயர்",
        "discount": "தள்ளுபடி",
        "usage": "பயன்பாடுகள்",
        "validUntil": "செல்லுபடியாகும் வரை",
        "status": "நிலை",
        "actions": "செயல்கள்"
      },
      "confirmDelete": "பிரச்சாரத்தை நீக்கு",
      "confirmDeleteMessage": "\"{{name}}\" ஐ நீக்க விரும்புகிறீர்களா? இந்த செயலை மீட்க முடியாது.",
      "searchPlaceholder": "பிரச்சாரங்கள் தேடு...",
      "emptyMessage": "பிரச்சாரங்கள் இல்லை",
      "deactivate": "செயலிழக்கச் செய்",
      "activate": "செயல்படுத்து",
      "createTitle": "புதிய பிரச்சாரம்",
      "editTitle": "பிரச்சாரத்தைத் திருத்து",
      "formSubtitle": "கூப்பன் குறியீடு அல்லது தள்ளுபடியை அமைக்கவும்",
      "form": {
        "name": "பிரச்சாரம் பெயர்",
        "namePlaceholder": "எ.கா., கோடை விற்பனை 2024",
        "code": "கூப்பன் குறியீடு",
        "generate": "உருவாக்கு",
        "discountType": "தள்ளுபடி வகை",
        "discountValue": "தள்ளுபடி மதிப்பு",
        "maxUses": "அதிகபட்ச பயன்பாடுகள்",
        "unlimited": "வரம்பற்ற",
        "validUntil": "செல்லுபடியாகும் வரை",
        "active": "பிரச்சாரம் செயலில்"
      }
    },
    "subscriptions": {
      "subtitle": "அமைப்பு சந்தாதாரர்களைக் காணவும் நிர்வகிக்கவும்",
      "status": {
        "active": "செயலில்",
        "paused": "இடைநிறுத்தப்பட்டது",
        "cancelled": "ரத்து செய்யப்பட்டது",
        "expired": "காலாவதியானது"
      },
      "columns": {
        "user": "பயனர்",
        "plan": "திட்டம்",
        "price": "விலை",
        "nextBilling": "அடுத்த கட்டணம்",
        "status": "நிலை"
      },
      "perMonth": "/மாதம்",
      "searchPlaceholder": "சந்தா தேடு...",
      "emptyMessage": "சந்தாக்கள் இல்லை",
      "actions": {
        "changePlan": "திட்டத்தை மாற்று",
        "pause": "இடைநிறுத்து",
        "resume": "மீண்டும் தொடங்கு",
        "cancel": "ரத்து செய்",
        "delete": "நீக்கு"
      },
      "editPlan": {
        "title": "சந்தா திட்டத்தை மாற்று",
        "user": "பயனர்",
        "currentPlan": "தற்போதைய திட்டம்",
        "newPlan": "புதிய திட்டத்தைத் தேர்ந்தெடு"
      },
      "addSubscription": {
        "title": "சந்தா சேர்",
        "userEmail": "பயனர் மின்னஞ்சல்",
        "emailPlaceholder": "பயனர் மின்னஞ்சலை உள்ளிடவும்",
        "duration": "கால அளவு (நாட்கள்)",
        "selectPlan": "திட்டத்தைத் தேர்ந்தெடு"
      },
      "fillAllFields": "அனைத்து புலங்களையும் நிரப்பவும்",
      "userNotFound": "பயனர் இல்லை",
      "selectOneToEdit": "திருத்த ஒரு சந்தாவைத் தேர்ந்தெடுக்கவும்",
      "selectToDelete": "நீக்க சந்தாக்களைத் தேர்ந்தெடுக்கவும்",
      "confirmDeleteMultiple": "{{count}} சந்தா(க்)களை நீக்கவா?",
      "selected": "தேர்ந்தெடுக்கப்பட்டது",
      "confirmDelete": "{{user}} க்கான சந்தாவை நீக்க விரும்புகிறீர்களா? இந்த செயலை மீட்க முடியாது."
    },
    "marketingDashboard": {
      "subtitle": "சந்தைப்படுத்தல் கண்ணோட்டம்",
      "refresh": "புதுப்பி",
      "totalSubscribers": "மொத்த சந்தாதாரர்கள்",
      "emailOpenRate": "மின்னஞ்சல் திறப்பு விகிதம்",
      "pushClickRate": "புஷ் கிளிக் விகிதம்",
      "activeSegments": "செயலில் பிரிவுகள்",
      "campaignStatus": {
        "active": "செயலில்",
        "completed": "முடிந்தது",
        "scheduled": "திட்டமிடப்பட்டது",
        "draft": "வரைவு"
      }
    },
    "transactions": {
      "subtitle": "கட்டண வரலாற்றைக் காண்க",
      "exportCsv": "CSV ஏற்றுமதி",
      "status": {
        "completed": "முடிந்தது",
        "pending": "நிலுவையில்",
        "failed": "தோல்வி",
        "refunded": "திரும்பப் பெறப்பட்டது"
      },
      "columns": {
        "id": "ID",
        "user": "பயனர்",
        "amount": "தொகை",
        "type": "வகை",
        "status": "நிலை",
        "date": "தேதி"
      },
      "filters": {
        "all": "அனைத்தும்"
      },
      "searchPlaceholder": "பரிவர்த்தனை தேடு...",
      "emptyMessage": "பரிவர்த்தனைகள் இல்லை",
      "details": "பரிவர்த்தனை விவரங்கள்",
      "email": "மின்னஞ்சல்"
    },
    "pushNotifications": {
      "subtitle": "பயனர்களுக்கு அறிவிப்புகளை உருவாக்கி அனுப்பவும்",
      "newNotification": "புதிய அறிவிப்பு",
      "status": {
        "draft": "வரைவு",
        "sent": "அனுப்பப்பட்டது",
        "scheduled": "திட்டமிடப்பட்டது"
      },
      "columns": {
        "title": "தலைப்பு",
        "status": "நிலை",
        "sent": "அனுப்பப்பட்டது",
        "opened": "திறக்கப்பட்டது",
        "scheduledAt": "திட்டமிடப்பட்ட நேரம்",
        "created": "உருவாக்கப்பட்டது",
        "actions": "செயல்கள்"
      },
      "filters": {
        "all": "அனைத்தும்"
      },
      "searchPlaceholder": "அறிவிப்பு தேடு...",
      "emptyMessage": "அறிவிப்புகள் இல்லை",
      "createModal": "புதிய புஷ் அறிவிப்பு",
      "editModal": "அறிவிப்பைத் திருத்து",
      "scheduleModal": "அறிவிப்பை திட்டமிடு",
      "titleLabel": "தலைப்பு",
      "bodyLabel": "உடல்",
      "dateTimeLabel": "தேதி மற்றும் நேரம்",
      "cancel": "ரத்து செய்",
      "create": "அறிவிப்பை உருவாக்கு",
      "schedule": "திட்டமிடு",
      "send": "இப்போது அனுப்பு",
      "confirmSend": "\"{{title}}\" அறிவிப்பை அனுப்பவா?",
      "confirmDelete": "\"{{title}}\" அறிவிப்பை நீக்கவா?",
      "fillRequired": "தலைப்பு மற்றும் உடலை நிரப்பவும்"
    }
  },
  "placeholder": {
    "email": "[ta] your@email.com",
    "password": "[ta] ••••••••",
    "pin": "[ta] ••••",
    "dateRange": {
      "from": "[ta] From (YYYY-MM-DD)",
      "to": "[ta] To (YYYY-MM-DD)"
    },
    "amount": {
      "min": "[ta] Min",
      "max": "[ta] Max",
      "price": "[ta] 0.00"
    },
    "chatMessage": "[ta] Type here...",
    "deepLink": "[ta] bayitplus://content/123",
    "scheduleDateTime": "[ta] YYYY-MM-DDTHH:mm",
    "roomCode": "[ta] ABCD1234",
    "time": {
      "start": "[ta] 08:00",
      "end": "[ta] 10:00"
    },
    "filter": {
      "userId": "[ta] Enter user ID"
    },
    "datetime": "[ta] YYYY-MM-DDTHH:mm",
    "number": "[ta] 0",
    "chat": "[ta] Type your message..."
  },
  "components": {
    "select": {
      "default": "[ta] Select..."
    }
  },
  "plans": {
    "basic": {
      "name": "அடிப்படை",
      "features": [
        "அனைத்து VOD உள்ளடக்கம்",
        "வானொலி & பாட்காஸ்ட்கள்",
        "1 சாதனத்தில் பார்",
        "SD தரம்"
      ],
      "notIncluded": "[ta] ['Live channels', 'AI Assistant', 'Offline viewing']"
    },
    "premium": {
      "name": "பிரீமியம்",
      "features": [
        "அனைத்து VOD உள்ளடக்கம்",
        "நேரலை சேனல்கள்",
        "வானொலி & பாட்காஸ்ட்கள்",
        "ஸ்மார்ட் AI உதவியாளர்",
        "2 சாதனங்களில் பார்",
        "HD தரம்"
      ],
      "notIncluded": "[ta] ['Offline viewing', 'Family profiles']"
    },
    "family": {
      "name": "குடும்பம்",
      "features": [
        "அனைத்து VOD உள்ளடக்கம்",
        "நேரலை சேனல்கள்",
        "4 சாதனங்களில் பார்",
        "4K தரம்",
        "5 குடும்ப சுயவிவரங்கள்"
      ],
      "notIncluded": "[ta] []"
    },
    "batchActions": {
      "selectedCount": "[ta] {{count}} selected",
      "selectedCount_one": "[ta] {{count}} selected",
      "selectedCount_other": "[ta] {{count}} selected",
      "clear": "[ta] Clear"
    },
    "costDashboard": {
      "title": "[ta] Cost Dashboard",
      "costBreakdown": "[ta] Cost Breakdown",
      "loadingBreakdown": "[ta] Loading breakdown...",
      "aiCosts": "[ta] AI Costs",
      "infrastructure": "[ta] Infrastructure",
      "thirdParty": "[ta] Third-party",
      "thirdPartyApis": "[ta] Third-party APIs",
      "translation": "[ta] Translation",
      "search": "[ta] Search",
      "percentOfTotal": "[ta] % of total",
      "components": "[ta] Components",
      "topSpenders": {
        "title": "[ta] Top 20 Spenders (Monthly)",
        "loading": "[ta] Loading top spenders...",
        "rank": "[ta] Rank",
        "userId": "[ta] User ID",
        "costRange": "[ta] Cost Range",
        "privacyNote": "[ta] User IDs are hashed and costs are aggregated into ranges for privacy protection."
      },
      "categories": {
        "permanent": "[ta] Permanent",
        "transient": "[ta] Transient",
        "permanentVsTransient": "[ta] Permanent vs Transient",
        "permanentFixed": "[ta] Permanent (Fixed)",
        "transientVariable": "[ta] Transient (Variable)",
        "permanentDesc": "[ta] Infrastructure costs that occur monthly regardless of usage",
        "transientDesc": "[ta] Usage-based costs that fluctuate with platform activity",
        "detailedBreakdown": "[ta] Detailed Breakdown",
        "costItem": "[ta] Cost Item",
        "category": "[ta] Category",
        "amount": "[ta] Amount"
      },
      "timeline": {
        "title": "[ta] Cost Timeline",
        "loading": "[ta] Loading timeline...",
        "amountLabel": "[ta] Amount ($)",
        "revenue": "[ta] Revenue",
        "totalCost": "[ta] Total Cost",
        "netProfit": "[ta] Net Profit",
        "showingData": "[ta] Showing data from {{start}} to {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "[ta] Net Profit/Loss",
        "margin": "[ta] margin",
        "revenue": "[ta] REVENUE",
        "totalCosts": "[ta] TOTAL COSTS"
      }
    }
  },
  "subscribe": {
    "title": "உங்கள் திட்டத்தைத் தேர்ந்தெடுக்கவும்",
    "subtitle": "எந்த திட்டத்திற்கும் 7 நாள் இலவச சோதனை. எப்போது வேண்டுமானாலும் ரத்து செய்யலாம்.",
    "monthly": "மாதாந்திர",
    "yearly": "வருடாந்திர",
    "save2Months": "[ta] Save 2 months",
    "popular": "மிகவும் பிரபலமான",
    "period": "/மாதம்",
    "perYear": "[ta] /year",
    "select": "திட்டத்தைத் தேர்ந்தெடு",
    "selected": "[ta] Selected",
    "processing": "[ta] Processing...",
    "startTrial": "இலவச சோதனையைத் தொடங்கு",
    "noCharge": "[ta] Your credit card won't be charged during the trial period"
  },
  "notFound": {
    "title": "பக்கம் கிடைக்கவில்லை",
    "description": "நீங்கள் தேடும் பக்கம் இல்லை.",
    "homeButton": "முகப்புக்கு செல்",
    "searchButton": "தேடு",
    "orTry": "[ta] Or try:",
    "liveChannel": "[ta] Live",
    "vodLabel": "[ta] Movies",
    "podcastsLabel": "[ta] Podcasts"
  },
  "profiles": {
    "addProfile": "[ta] Add Profile",
    "enterPin": "[ta] Enter PIN",
    "selectError": "[ta] Error selecting profile",
    "wrongPin": "[ta] Incorrect PIN",
    "loading": "[ta] Loading profiles...",
    "manage": "[ta] Manage Profiles",
    "whoIsWatching": "[ta] Who's Watching?",
    "manageProfiles": "[ta] Manage Profiles",
    "kids": "குழந்தைகள்",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "[ta] Content not found",
    "backToHome": "[ta] Back to Home",
    "episodes": "[ta] Episodes",
    "addToList": "[ta] Add to List",
    "like": "[ta] Like",
    "share": "[ta] Share",
    "cast": "[ta] Cast",
    "episodesList": "[ta] Episodes",
    "schedule": "[ta] Schedule",
    "now": "[ta] Now",
    "related": "[ta] Related Content",
    "deleteEpisode": "[ta] Delete Episode",
    "confirmDeleteEpisode": "[ta] Delete this episode?"
  },
  "live": {
    "title": "[ta] Live TV",
    "next": "[ta] Next:",
    "noChannels": "[ta] No channels available",
    "tryLater": "[ta] Try again later",
    "categories": {
      "all": "[ta] All",
      "news": "[ta] News",
      "entertainment": "[ta] Entertainment",
      "sports": "[ta] Sports",
      "kids": "[ta] Kids",
      "music": "[ta] Music"
    }
  },
  "judaism": {
    "title": "யூதமதம்",
    "items": "உருப்படிகள்",
    "empty": "உள்ளடக்கம் இல்லை",
    "emptyHint": "[ta] Try selecting another category",
    "dashboard": "[ta] Your Jewish Dashboard",
    "categories": {
      "news": "[ta] Jewish News",
      "community": "[ta] Community"
    },
    "shabbat": {
      "title": "ஷப்பத் நேரங்கள்",
      "shabbatShalom": "ஷப்பத் ஷாலோம்!",
      "shabbatMode": "[ta] Shabbat Mode",
      "endsIn": "[ta] Shabbat ends in",
      "candleLighting": "மெழுகுவர்த்தி ஏற்றுதல்",
      "havdalah": "ஹவ்தலா",
      "parashat": "[ta] Parashat",
      "friday": "[ta] Friday",
      "saturday": "[ta] Saturday",
      "noData": "[ta] Unable to load Shabbat times"
    },
    "erevShabbat": {
      "title": "[ta] Erev Shabbat",
      "prepareFor": "[ta] Prepare for Shabbat",
      "inTime": "[ta] in {{time}}",
      "featuredContent": "[ta] Shabbat Content",
      "noContent": "[ta] Shabbat content coming soon!",
      "shabbatShalom": "[ta] Shabbat Shalom!",
      "timeUntil": "[ta] Time until Shabbat",
      "shabbatSongs": "[ta] Shabbat Songs",
      "parashaStudy": "[ta] Parasha",
      "shabbatRecipes": "[ta] Recipes",
      "prayers": "[ta] Prayers"
    }
  },
  "children": {
    "title": "குழந்தைகள்",
    "items": "உருப்படிகள்",
    "empty": "உள்ளடக்கம் இல்லை",
    "emptyHint": "[ta] Try another category",
    "exitKidsMode": "குழந்தைகள் பயன்முறையிலிருந்து வெளியேறு",
    "exitDescription": "[ta] Enter parent code to exit",
    "parentCode": "[ta] Parent code",
    "confirm": "[ta] Confirm",
    "wrongCode": "[ta] Incorrect code",
    "noContent": "[ta] No content available",
    "tryAnotherCategory": "[ta] Try selecting another category",
    "categories": {
      "all": "அனைத்தும்",
      "cartoons": "கார்ட்டூன்கள்",
      "educational": "கல்வி",
      "music": "இசை",
      "hebrew": "[ta] Hebrew",
      "stories": "கதைகள்",
      "jewish": "யூத"
    },
    "ageRatings": {
      "3": "[ta] Ages 3+",
      "5": "[ta] Ages 5+",
      "7": "[ta] Ages 7+",
      "10": "[ta] Ages 10+",
      "12": "[ta] Ages 12+"
    },
    "moderation": {
      "pending": "[ta] Pending Review",
      "approved": "[ta] Approved",
      "rejected": "[ta] Rejected"
    },
    "admin": {
      "stats": "[ta] Kids Content Manager",
      "seedContent": "[ta] Seed Content",
      "importArchive": "[ta] Import Archive.org",
      "syncPodcasts": "[ta] Sync Podcasts",
      "syncYouTube": "[ta] Sync YouTube",
      "tagVod": "[ta] Tag VOD",
      "pendingModeration": "[ta] Pending Moderation"
    }
  },
  "youngsters": {
    "title": "[ta] Youngsters",
    "items": "[ta] items",
    "empty": "[ta] No content available",
    "emptyHint": "[ta] Try another category",
    "exitYoungstersMode": "[ta] Exit Youngsters Mode",
    "exitDescription": "[ta] Enter parent code to exit",
    "parentCode": "[ta] Parent code",
    "confirm": "[ta] Confirm",
    "wrongCode": "[ta] Incorrect code",
    "noContent": "[ta] No content available",
    "tryAnotherCategory": "[ta] Try selecting another category",
    "categories": {
      "all": "[ta] All",
      "trending": "[ta] Trending",
      "news": "[ta] News",
      "culture": "[ta] Culture",
      "educational": "[ta] Educational",
      "music": "[ta] Music",
      "entertainment": "[ta] Entertainment",
      "sports": "[ta] Sports",
      "tech": "[ta] Technology",
      "judaism": "[ta] Judaism"
    },
    "ageGroups": {
      "middle-school": "[ta] Middle School (12-14)",
      "high-school": "[ta] High School (15-17)"
    },
    "moderation": {
      "pending": "[ta] Pending Review",
      "approved": "[ta] Approved",
      "rejected": "[ta] Rejected"
    },
    "admin": {
      "stats": "[ta] Youngsters Content Manager",
      "seedContent": "[ta] Seed Content",
      "importArchive": "[ta] Import Archive.org",
      "syncPodcasts": "[ta] Sync Podcasts",
      "syncYouTube": "[ta] Sync YouTube",
      "tagVod": "[ta] Tag VOD",
      "pendingModeration": "[ta] Pending Moderation"
    }
  },
  "chatbot": {
    "title": "Bayit+ உதவியாளர்",
    "greeting": "வணக்கம்! நான் Bayit+ ஸ்மார்ட் உதவியாளர். இன்று நான் உங்களுக்கு எப்படி உதவ முடியும்?",
    "openChat": "[ta] Open chat",
    "welcome": "[ta] Hello! I'm the Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message.",
    "placeholder": "இங்கே தட்டச்சு செய்யவும்...",
    "recording": "[ta] Recording... click again to stop",
    "transcribing": "[ta] Transcribing...",
    "stopRecording": "[ta] Stop recording",
    "startRecording": "[ta] Start voice recording",
    "recommendations": "[ta] Here are some recommendations:",
    "showMultipleSuccess": "[ta] Showing {{count}} content items in widgets",
    "showMultipleNotFound": "[ta] Could not find the requested content. Please try different names.",
    "resolvingContent": "[ta] Finding your content...",
    "errors": {
      "micPermission": "[ta] Could not access microphone. Please check microphone permissions in your browser.",
      "transcribeFailed": "[ta] Could not transcribe the recording. Please try again.",
      "general": "[ta] Sorry, something went wrong. Please try again."
    },
    "suggestions": {
      "whatToWatch": "[ta] What to watch today?",
      "israeliMovies": "[ta] Recommended Israeli movies",
      "whatsOnNow": "[ta] What's on now?",
      "popularPodcasts": "[ta] Popular podcasts"
    },
    "voiceCommands": {
      "showChannels": "[ta] Show me channels...",
      "playChess": "[ta] Start a chess game with...",
      "multiContent": "[ta] Show side by side..."
    }
  },
  "chat": {
    "title": "[ta] Bayit+ Assistant",
    "greeting": "[ta] Hello! I'm Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message."
  },
  "subtitles": {
    "nikud": "நிக்குட்",
    "selection": "தேர்வு",
    "translation": "மொழிபெயர்ப்பு",
    "translating": "மொழிபெயர்க்கிறது...",
    "close": "மூடு",
    "unavailable": "மொழிபெயர்ப்பு கிடைக்கவில்லை",
    "off": "அணைக்கவும்",
    "none": "எதுவும் இல்லை",
    "autoGenerated": "தானியங்கி உருவாக்கம்",
    "selectLanguage": "வசன மொழியைத் தேர்ந்தெடுக்கவும்",
    "liveTranslate": "நேரடி மொழிபெயர்ப்பு",
    "translateTo": "மொழிபெயர்க்க",
    "downloadMore": "மேலும் வசனங்களைப் பதிவிறக்கவும்...",
    "downloading": "OpenSubtitles இல் தேடுகிறது...",
    "opensubtitlesSource": "OpenSubtitles.com இலிருந்து",
    "downloadSuccess": "{{count}} வசன(ங்)கள் பதிவிறக்கப்பட்டன",
    "noSubtitlesFound": "இந்த உள்ளடக்கத்திற்கு வசனங்கள் இல்லை",
    "smartSubs": "ஸ்மார்ட் சப்ஸ்",
    "smartSubsDescription": "இரட்டை காட்சி: எளிமைப்படுத்தப்பட்ட எபிரேயம் + வேர் சிறப்பம்சத்துடன் ஆங்கிலம்",
    "smartSubsDualView": "இரட்டை காட்சி",
    "shoreshToggle": "வேர் சிறப்பம்சம்",
    "shoreshOn": "Shoresh சிறப்பம்சம் இயக்கப்பட்டது",
    "shoreshOff": "Shoresh சிறப்பம்சம் முடக்கப்பட்டது",
    "nikudLive": "Nikud உடன் எபிரேயம்",
    "nikudLiveDescription": "எளிதாக படிக்க உயிரெழுத்து குறிகளுடன் எபிரேய வசனங்கள்",
    "nikudEnabled": "Nikud வசனங்கள் இயக்கப்பட்டன",
    "nikudDisabled": "Nikud வசனங்கள் முடக்கப்பட்டன",
    "nikudSubtitleLabel": "Nikud உடன் எபிரேயம்: {{text}}",
    "available": "வசனங்கள்",
    "clickToEnable": "நேரடி மொழிபெயர்ப்பை இயக்க கிளிக் செய்யவும்",
    "connectionError": "நேரடி மொழிபெயர்ப்பு பிழை",
    "inputLanguageTooltip": "உள்ளீட்டு மொழியைச் சரிபார்க்கவும்",
    "premiumRequired": "பிரீமியம் சந்தா தேவை",
    "selectInputLanguage": "உள்ளீட்டு மொழியைத் தேர்ந்தெடுக்கவும்",
    "translateActive": "நேரடி மொழிபெயர்ப்பு செயலில் உள்ளது",
    "noEnglishSubtitles": "இந்த உள்ளடக்கத்திற்கு ஆங்கில வசனங்கள் இல்லை.",
    "hebrewMode": {
      "title": "எபிரேய காட்சி முறை",
      "unavailable": "கிடைக்கவில்லை",
      "generate": "உருவாக்கு",
      "regular": {
        "title": "நிலையான எபிரேயம்",
        "description": "உயிரெழுத்து குறிகள் இல்லாத நிலையான எபிரேய உரை"
      },
      "nikud": {
        "title": "Nikud உடன் எபிரேயம்",
        "description": "எளிதாக படிக்க உயிரெழுத்து குறிகளுடன் எபிரேயம்",
        "unavailableReason": "இந்த உள்ளடக்கத்திற்கு AI செயலாக்கம் கிடைக்கவில்லை"
      },
      "shoresh": {
        "title": "Shoresh (வேர் சொற்கள்)",
        "description": "வேர் பகுப்பாய்வுடன் எபிரேய சொற்கள்: சொல் [வேர்]",
        "unavailableReason": "இந்த உள்ளடக்கத்திற்கு வேர் சொல் பகுப்பாய்வு கிடைக்கவில்லை"
      }
    },
    "englishMode": {
      "title": "ஆங்கில காட்சி முறை",
      "unavailable": "கிடைக்கவில்லை",
      "generate": "உருவாக்கு",
      "firstTimeHint": "இந்த AI-இயக்கப்படும் முறைகள் ஆங்கில வாக்கிய அமைப்பைக் கற்கும்போது எபிரேயத்தைப் பராமரிக்க உதவுகின்றன. ஒவ்வொரு முறையும் தனித்துவமான கற்றல் அனுபவத்தை வழங்குகிறது.",
      "regular": {
        "title": "நிலையான ஆங்கிலம்",
        "description": "நிலையான ஆங்கில வசனங்கள்"
      },
      "heblish": {
        "title": "ஹெப்லிஷ்",
        "description": "உள்ளடக்கிய கற்றலுக்கு எபிரேய சொல் செலுத்துதலுடன் ஆங்கிலம்",
        "unavailableReason": "இந்த உள்ளடக்கத்திற்கு Heblish செயலாக்கம் கிடைக்கவில்லை"
      },
      "grammarFlip": {
        "title": "இலக்கண-புரட்டு",
        "description": "ஆங்கில வாக்கிய அமைப்புடன் எபிரேய சொற்கள் (எழுவாய்-வினை-செயப்படுபொருள்)",
        "unavailableReason": "இந்த உள்ளடக்கத்திற்கு இலக்கண-புரட்டு செயலாக்கம் கிடைக்கவில்லை"
      },
      "slangSynthesis": {
        "title": "ஸ்லாங் ஒருங்கிணைப்பு",
        "description": "ஈர்க்கும் உள்ளடக்கத்திற்கு நவீன இஸ்ரேலிய மற்றும் அமெரிக்க ஸ்லாங் கலவை",
        "unavailableReason": "இந்த உள்ளடக்கத்திற்கு ஸ்லாங் ஒருங்கிணைப்பு செயலாக்கம் கிடைக்கவில்லை"
      }
    },
    "loading": "வசனங்களை ஏற்றுகிறது...",
    "error": {
      "title": "வசன பிழை",
      "retry": "மீண்டும் முயற்சிக்கவும்",
      "loadFailed": "வசனங்களை ஏற்றுவது தோல்வியடைந்தது",
      "cuesFailed": "வசன உரையை ஏற்றுவது தோல்வியடைந்தது",
      "networkError": "நெட்வொர்க் பிழை - உங்கள் இணைப்பைச் சரிபார்க்கவும்",
      "serverError": "சர்வர் பிழை - பின்னர் மீண்டும் முயற்சிக்கவும்"
    },
    "aiModesAvailable": "கிடைக்கும் AI முறைகள்",
    "aiModesTitle": "AI வசன முறைகள்",
    "fetchSubtitles": "வசனங்களைப் பெறு",
    "fontSize": "எழுத்துரு அளவு",
    "mode": {
      "engrew": "எங்ரூ",
      "heblish": "ஹெப்லிஷ்",
      "shoresh": "ஷோரேஷ்",
      "standard": "நிலையான"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "வெளிப்புற வசனங்களைத் தேடு",
    "settingsTitle": "வசன அமைப்புகள்",
    "showBackground": "பின்னணியைக் காட்டு",
    "singleMode": "ஒற்றை பயன்முறை",
    "splitMode": "பிரிப்பு பயன்முறை",
    "primary_language": "முதன்மை மொழி",
    "secondary_language": "இரண்டாம் நிலை மொழி",
    "layout_mode": "தளவமைப்பு பயன்முறை",
    "interactive_title": "ஊடாடும் துணைப்பாடல்கள்"
  },
  "video": {
    "watchTrailer": "[ta] Watch Trailer",
    "closeTrailer": "[ta] Close Trailer",
    "deleteConfirm": "[ta] Delete this episode?"
  },
  "recordings": {
    "title": "என் பதிவுகள்",
    "subtitle": "உங்கள் பதிவுசெய்த நேரலை ஸ்ட்ரீம்களைப் பார்க்கவும் நிர்வகிக்கவும்",
    "record": "பதிவு",
    "recording": "பதிவு செய்கிறது",
    "storageUsed": "[ta] Storage Used",
    "totalRecordings": "[ta] Total Recordings",
    "maxDuration": "[ta] Max Duration",
    "noRecordings": "பதிவுகள் இல்லை",
    "noRecordingsHint": "[ta] Start recording from any live channel!",
    "confirmDelete": "[ta] Are you sure you want to delete this recording? This action cannot be undone.",
    "deleteRecording": "[ta] Delete Recording",
    "deleteFailed": "[ta] Failed to delete recording",
    "expires": "[ta] Expires",
    "subtitlesAvailable": "[ta] Subtitles Available",
    "recordingSaved": "[ta] Recording Saved!",
    "savedSuccess": "[ta] Recording saved successfully! Duration: {{duration}}",
    "viewInMyRecordings": "[ta] View in My Recordings",
    "error": "[ta] Recording Error",
    "startFailed": "[ta] Failed to start recording. Please try again.",
    "stopFailed": "[ta] Failed to stop recording. Please try again.",
    "page": "[ta] Page"
  },
  "chess": {
    "title": "[ta] Chess",
    "welcome": "[ta] Welcome to Chess",
    "subtitle": "[ta] Play chess with friends and family around the world",
    "createGame": "[ta] Create New Game",
    "joinGame": "[ta] Join Game",
    "gameCode": "[ta] Game Code",
    "enterGameCode": "[ta] Enter Game Code",
    "invalidGameCode": "[ta] Invalid game code. Must be 6 characters.",
    "joinFailed": "[ta] Failed to join game",
    "join": "[ta] Join",
    "create": "[ta] Create",
    "chooseColor": "[ta] Choose Your Color",
    "white": "[ta] White",
    "black": "[ta] Black",
    "chatPlaceholder": "[ta] Type a message... (@bot for advice)",
    "botHint": "[ta] Tag @bot in your message to get chess advice from our AI assistant",
    "bot": "[ta] Chess Assistant",
    "mute": "[ta] Mute",
    "unmute": "[ta] Unmute",
    "speaking": "[ta] participants",
    "resign": "[ta] Resign",
    "offerDraw": "[ta] Offer Draw",
    "newGame": "[ta] New Game",
    "checkmate": "[ta] Checkmate!",
    "stalemate": "[ta] Stalemate",
    "draw": "[ta] Draw",
    "resigned": "[ta] Game Resigned",
    "reconnecting": "[ta] Reconnecting...",
    "moveHistory": "[ta] Move History",
    "noMoves": "[ta] No moves yet",
    "showHints": "[ta] Show Guide Hints",
    "yourTurn": "[ta] Your Turn",
    "opponentTurn": "[ta] Opponent's Turn",
    "waitingForOpponent": "[ta] Waiting for opponent...",
    "gameOver": "[ta] Game Over",
    "sendingInvite": "[ta] Sending game invite to {{name}}...",
    "inviteSent": "[ta] Game invite sent to {{name}}! Game code: {{code}}",
    "inviteFailed": "[ta] Could not find that user. Please check the name and try again.",
    "inviteReceived": "[ta] {{name}} invited you to a chess game!",
    "joinInvite": "[ta] Join Game",
    "challenge": "[ta] Challenge",
    "playedAsWhite": "[ta] Played as White",
    "playedAsBlack": "[ta] Played as Black",
    "gameMode": "[ta] Game Mode",
    "playVsFriend": "[ta] Play vs Friend",
    "playVsBot": "[ta] Play vs Bot",
    "difficulty": "[ta] Difficulty",
    "easy": "[ta] Easy",
    "medium": "[ta] Medium",
    "hard": "[ta] Hard",
    "chessBot": "[ta] Chess Bot",
    "chat": {
      "title": "[ta] Chat",
      "inputPlaceholder": "[ta] Type a message..."
    },
    "acceptDraw": "[ta] Accept Draw",
    "acceptInvite": "[ta] Accept Invite",
    "blackCaptured": "[ta] Black Captured",
    "blackTurn": "[ta] Black's Turn",
    "challengeFriend": "[ta] Challenge Friend",
    "challengeViaWhatsApp": "[ta] Challenge via WhatsApp",
    "copyCode": "[ta] Copy Code",
    "declineDraw": "[ta] Decline Draw",
    "declineInvite": "[ta] Decline Invite",
    "drawOffered": "[ta] Draw Offered",
    "joinByGameCode": "[ta] Join by Game Code",
    "noFriendsYet": "[ta] No friends yet",
    "offline": "[ta] Offline",
    "online": "[ta] Online",
    "opponent": "[ta] Opponent",
    "whiteCaptured": "[ta] White Captured",
    "whiteTurn": "[ta] White's Turn",
    "you": "[ta] You"
  },
  "friends": {
    "title": "[ta] Friends & Opponents",
    "subtitle": "[ta] Connect with players and challenge friends",
    "myFriends": "[ta] My Friends",
    "requests": "[ta] Requests",
    "findPlayers": "[ta] Find Players",
    "friendsLabel": "[ta] Friends",
    "pendingLabel": "[ta] Pending",
    "add": "[ta] Add Friend",
    "remove": "[ta] Remove",
    "accept": "[ta] Accept",
    "reject": "[ta] Reject",
    "cancel": "[ta] Cancel",
    "noFriends": "[ta] No friends yet",
    "noFriendsDesc": "[ta] Search for players and send friend requests",
    "lastGame": "[ta] Last game: {{time}}",
    "friendsSince": "[ta] Friends since {{date}}",
    "incomingRequests": "[ta] Incoming Requests",
    "outgoingRequests": "[ta] Outgoing Requests",
    "noIncoming": "[ta] No incoming requests",
    "noOutgoing": "[ta] No outgoing requests",
    "sentAt": "[ta] Sent {{time}}",
    "searchPlaceholder": "[ta] Search by name...",
    "noResults": "[ta] No players found",
    "noResultsDesc": "[ta] Try searching with a different name",
    "requestSent": "[ta] Friend request sent!",
    "requestAccepted": "[ta] Friend request accepted!",
    "requestRejected": "[ta] Friend request rejected",
    "requestCancelled": "[ta] Friend request cancelled",
    "friendRemoved": "[ta] Friend removed",
    "searchFailed": "[ta] Failed to search users",
    "requestFailed": "[ta] Failed to send request",
    "acceptFailed": "[ta] Failed to accept request",
    "rejectFailed": "[ta] Failed to reject request",
    "cancelFailed": "[ta] Failed to cancel request",
    "removeFailed": "[ta] Failed to remove friend",
    "friendsCount": "[ta] {{count}} friends",
    "gamesCount": "[ta] {{count}} games",
    "alreadyFriends": "[ta] Friends"
  },
  "stats": {
    "statistics": "[ta] Statistics",
    "matchHistory": "[ta] Match History",
    "headToHead": "[ta] Head to Head",
    "gamesPlayed": "[ta] Games Played",
    "wins": "[ta] Wins",
    "losses": "[ta] Losses",
    "draws": "[ta] Draws",
    "winRate": "[ta] Win Rate",
    "rating": "[ta] Rating",
    "peakRating": "[ta] Peak Rating",
    "peak": "[ta] Peak",
    "winStreak": "[ta] Win Streak",
    "currentStreak": "[ta] Current Streak",
    "bestStreak": "[ta] Best Streak",
    "performance": "[ta] Performance",
    "achievements": "[ta] Achievements",
    "currentRating": "[ta] Current Rating",
    "totalGames": "[ta] Total Games",
    "noGames": "[ta] No games played yet",
    "moves": "[ta] moves",
    "won": "[ta] Won",
    "lost": "[ta] Lost",
    "draw": "[ta] Draw",
    "overall": "[ta] Overall Record",
    "yourWins": "[ta] Your Wins",
    "theirWins": "[ta] Their Wins",
    "totalGamesPlayed": "[ta] Total: {{count}} games",
    "recentGames": "[ta] Recent Games"
  },
  "support": {
    "title": "ஆதரவு மையம்",
    "subtitle": "இன்று நாங்கள் உங்களுக்கு எப்படி உதவ முடியும்?",
    "tabs": {
      "docs": "ஆவணங்கள்",
      "faq": "FAQ",
      "contact": "தொடர்பு",
      "tickets": "என் டிக்கெட்கள்"
    },
    "categories": {
      "title": "[ta] Browse Documentation",
      "loading": "[ta] Loading documentation...",
      "loadError": "[ta] Failed to load categories",
      "articleCount": "[ta] {{count}} articles",
      "gettingStarted": "[ta] Getting Started",
      "features": "[ta] Features",
      "troubleshooting": "[ta] Troubleshooting",
      "account": "[ta] Account"
    },
    "docs": {
      "loading": "[ta] Loading document...",
      "loadError": "[ta] Failed to load document",
      "backToList": "[ta] Back to documentation"
    },
    "search": {
      "placeholder": "[ta] Search documentation...",
      "noResults": "[ta] No results found"
    },
    "faq": {
      "title": "[ta] Frequently Asked Questions",
      "loading": "[ta] Loading FAQ...",
      "loadError": "[ta] Failed to load FAQ",
      "empty": "[ta] No FAQ items in this category",
      "categories": {
        "all": "[ta] All Topics",
        "general": "[ta] General",
        "billing": "[ta] Billing",
        "technical": "[ta] Technical",
        "features": "[ta] Features"
      }
    },
    "contact": {
      "voiceTitle": "[ta] Voice Support",
      "voiceDescription": "[ta] Click the avatar button or say \"Jarvis\" to start a voice conversation with our AI assistant.",
      "ticketTitle": "[ta] Create Support Ticket",
      "ticketDescription": "[ta] Need human assistance? Create a support ticket and our team will respond within 24 hours.",
      "createTicket": "[ta] Create Ticket",
      "emailTitle": "[ta] Email Support",
      "emailDescription": "[ta] Prefer email? Reach us at support@bayit.tv for any questions or concerns."
    },
    "ticket": {
      "title": "[ta] Create Support Ticket",
      "subject": "[ta] Subject",
      "subjectPlaceholder": "[ta] Brief description of your issue",
      "message": "[ta] Message",
      "messagePlaceholder": "[ta] Describe your issue in detail...",
      "categoryLabel": "[ta] Category",
      "priorityLabel": "[ta] Priority",
      "submit": "[ta] Submit Ticket",
      "category": {
        "billing": "[ta] Billing",
        "technical": "[ta] Technical",
        "feature": "[ta] Feature Request",
        "general": "[ta] General"
      },
      "priority": {
        "low": "[ta] Low",
        "medium": "[ta] Medium",
        "high": "[ta] High",
        "urgent": "[ta] Urgent"
      },
      "status": {
        "open": "[ta] Open",
        "in_progress": "[ta] In Progress",
        "resolved": "[ta] Resolved",
        "closed": "[ta] Closed"
      },
      "created": "[ta] Created",
      "error": {
        "required": "[ta] Please fill in all required fields",
        "submit": "[ta] Failed to create ticket. Please try again."
      }
    },
    "tickets": {
      "title": "[ta] My Support Tickets",
      "loading": "[ta] Loading tickets...",
      "loadError": "[ta] Failed to load tickets",
      "empty": "[ta] No support tickets yet",
      "emptyFilter": "[ta] No tickets with this status",
      "create": "[ta] New Ticket",
      "createFirst": "[ta] Create Your First Ticket",
      "filter": {
        "all": "[ta] All",
        "open": "[ta] Open",
        "inProgress": "[ta] In Progress",
        "resolved": "[ta] Resolved"
      }
    },
    "voice": {
      "title": "[ta] Voice Assistant",
      "listening": "[ta] I'm listening...",
      "thinking": "[ta] Let me think about that...",
      "speaking": "[ta] Speaking...",
      "error": "[ta] Sorry, I didn't catch that. Try again?",
      "ready": "[ta] What would you like to know?",
      "listeningNow": "[ta] Listening...",
      "wakeWordHint": "[ta] Say \"Jarvis\" to speak"
    },
    "wizard": {
      "role": "[ta] Your Guide"
    }
  },
  "jerusalem": {
    "title": "[ta] Jerusalem Connection",
    "subtitle": "[ta] Stay connected to the heart of Israel",
    "noContent": "[ta] No Jerusalem content available",
    "sources": "[ta] Sources",
    "kotelLive": "[ta] Western Wall Live",
    "categories": {
      "kotel": "[ta] Western Wall",
      "idf-ceremony": "[ta] IDF Ceremonies",
      "diaspora-connection": "[ta] Diaspora Connection",
      "holy-sites": "[ta] Holy Sites",
      "jerusalem-events": "[ta] Jerusalem Events",
      "general": "[ta] Jerusalem"
    }
  },
  "telAviv": {
    "title": "[ta] Tel Aviv Connection",
    "subtitle": "[ta] The city that never stops",
    "noContent": "[ta] No Tel Aviv content available",
    "sources": "[ta] Sources",
    "beachLive": "[ta] Beach Webcam",
    "categories": {
      "beaches": "[ta] Beaches",
      "nightlife": "[ta] Nightlife",
      "culture": "[ta] Culture & Art",
      "music": "[ta] Music Scene",
      "food": "[ta] Food & Dining",
      "tech": "[ta] Tech & Startups",
      "events": "[ta] Events",
      "general": "[ta] Tel Aviv"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "[ta] Welcome to Voice Control",
      "description": "[ta] Control Bayit+ with your voice for a hands-free experience."
    },
    "features": {
      "voiceCommands": "குரல் கட்டளைகள்",
      "voiceCommandsDesc": "இயற்கையான பேச்சுடன் வழிசெலுத்தவும், தேடவும், பின்னணியை கட்டுப்படுத்தவும்",
      "tts": "உரை-இருந்து-பேச்சு",
      "ttsDesc": "பதில்களையும் உள்ளடக்க விவரங்களையும் சத்தமாகக் கேளுங்கள்",
      "wakeWord": "எழுப்பு வார்த்தை",
      "wakeWordDesc": "எப்போது வேண்டுமானாலும் குரல் கட்டுப்பாட்டை செயல்படுத்த 'Bayit' என்று சொல்லுங்கள்"
    },
    "getStarted": "தொடங்குங்கள்",
    "permissions": {
      "title": "மைக்ரோஃபோன் அணுகல்",
      "description": "உங்கள் கட்டளைகளைக் கேட்க குரல் கட்டுப்பாட்டிற்கு மைக்ரோஃபோன் அணுகல் தேவை",
      "privacy": "உங்கள் குரல் தரவு பாதுகாப்பாக செயலாக்கப்பட்டு ஒருபோதும் சேமிக்கப்படாது"
    },
    "permissionsGranted": "மைக்ரோஃபோன் அணுகல் வழங்கப்பட்டது",
    "permissionRequired": {
      "title": "அனுமதி தேவை",
      "message": "குரல் கட்டுப்பாட்டைப் பயன்படுத்த உங்கள் சாதன அமைப்புகளில் மைக்ரோஃபோன் அணுகலை இயக்கவும்"
    },
    "grantPermissions": "அனுமதிகளை வழங்கு",
    "testWakeWord": {
      "title": "எழுப்பு வார்த்தையை சோதியுங்கள்",
      "description": "குரல் செயல்படுத்தலை சோதிக்க 'Bayit' என்று சொல்லுங்கள்",
      "success": "அருமை! குரல் செயல்படுத்தல் வேலை செய்கிறது"
    },
    "startTest": "சோதனையைத் தொடங்கு",
    "complete": {
      "title": "எல்லாம் தயார்!",
      "description": "குரல் கட்டுப்பாடு இப்போது இயக்கப்பட்டது. இந்த கட்டளைகளை முயற்சிக்கவும்:",
      "tryCommands": "இந்த கட்டளைகளை முயற்சிக்கவும்",
      "examples": {
        "search": "\"Fauda தேடு\"",
        "play": "\"செய்திகளை இயக்கு\"",
        "navigate": "\"நேரடி டிவிக்கு செல்\"",
        "control": "\"இடைநிறுத்து\" அல்லது \"ஒலியை அதிகரி\""
      },
      "startUsing": "குரல் கட்டுப்பாட்டைப் பயன்படுத்தத் தொடங்குங்கள்"
    },
    "skip": "இப்போது தவிர்",
    "buttons": {
      "back": "[ta] Back"
    },
    "completion": {
      "message": "[ta] Voice features are ready to use.",
      "title": "[ta] Voice Setup Complete"
    },
    "title": "[ta] Voice Setup",
    "training": {
      "message": "[ta] Read the phrases aloud to train voice recognition.",
      "title": "[ta] Voice Training"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "[ta] Movies",
      "series": "[ta] Series",
      "kids": "[ta] Kids",
      "youngsters": "[ta] Youngsters",
      "music": "[ta] Music",
      "documentaries": "[ta] Documentaries",
      "podcasts": "[ta] Podcasts",
      "live": "[ta] Live TV"
    },
    "subcategories": {
      "learning-hebrew": "[ta] Learning Hebrew",
      "young-science": "[ta] Young Science",
      "math-fun": "[ta] Fun Math",
      "nature-animals": "[ta] Nature & Animals",
      "interactive": "[ta] Interactive",
      "hebrew-songs": "[ta] Hebrew Songs",
      "nursery-rhymes": "[ta] Nursery Rhymes",
      "kids-movies": "[ta] Kids Movies",
      "kids-series": "[ta] Kids Series",
      "jewish-holidays": "[ta] Jewish Holidays",
      "torah-stories": "[ta] Torah Stories",
      "bedtime-stories": "[ta] Bedtime Stories",
      "tiktok-trends": "[ta] TikTok Trends",
      "viral-videos": "[ta] Viral Videos",
      "memes": "[ta] Memes",
      "israel-news": "[ta] Israel News",
      "world-news": "[ta] World News",
      "science-news": "[ta] Science News",
      "sports-news": "[ta] Sports News",
      "music-culture": "[ta] Music Culture",
      "film-culture": "[ta] Film Culture",
      "art-culture": "[ta] Art Culture",
      "food-culture": "[ta] Food Culture",
      "study-help": "[ta] Study Help",
      "career-prep": "[ta] Career Prep",
      "life-skills": "[ta] Life Skills",
      "teen-movies": "[ta] Teen Movies",
      "teen-series": "[ta] Teen Series",
      "gaming": "[ta] Gaming",
      "coding": "[ta] Coding",
      "gadgets": "[ta] Gadgets",
      "bar-bat-mitzvah": "[ta] Bar/Bat Mitzvah",
      "teen-torah": "[ta] Teen Torah",
      "jewish-history": "[ta] Jewish History",
      "learning-hebrew.description": "குழந்தைகளுக்கான எபிரேய மொழியில் படிக்க, எழுத மற்றும் சொற்களஞ்சியம் கற்றல்",
      "young-science.description": "குழந்தைகளுக்கு ஏற்ற சோதனைகள் மற்றும் அறிவியல் விளக்கங்கள்",
      "math-fun.description": "வேடிக்கையாகவும் விளையாட்டாகவும் எண்கள் மற்றும் கணிதம் கற்றல்",
      "nature-animals.description": "ஆர்வமுள்ள குழந்தைகளுக்கான விலங்குகள் மற்றும் இயற்கை உலகம்",
      "interactive.description": "குழந்தைகளுக்கான ஊடாடும் மற்றும் பங்கேற்பு உள்ளடக்கம்",
      "hebrew-songs.description": "பாரம்பரிய மற்றும் புதிய இஸ்ரேலிய குழந்தைகள் பாடல்கள்",
      "nursery-rhymes.description": "குட்டிக் குழந்தைகள் மற்றும் சிசுக்களுக்கான பாடல்கள் மற்றும் இசைகள்",
      "kids-movies.description": "குழந்தைகளுக்கு ஏற்ற முழு நீள திரைப்படங்கள்",
      "kids-series.description": "குழந்தைகளுக்கான அனிமேஷன் தொடர்கள் மற்றும் தொலைக்காட்சி நிகழ்ச்சிகள்",
      "jewish-holidays.description": "குழந்தைகளுக்கான யூத பண்டிகைகள் மற்றும் மரபுகள் பற்றிய உள்ளடக்கம்",
      "torah-stories.description": "தோராவிலிருந்தும் யூத மரபிலிருந்தும் கதைகள்",
      "bedtime-stories.description": "தூங்கும் நேரத்திற்கான அமைதியான கதைகள்",
      "tiktok-trends.description": "TikTok-ல் பிரபலமான போக்குகள் மற்றும் சவால்கள்",
      "viral-videos.description": "சமூக ஊடகங்களில் பிரபலமான வைரல் வீடியோக்கள்",
      "memes.description": "வேடிக்கையான மீம்கள் மற்றும் இணைய கலாச்சாரம்",
      "israel-news.description": "இளைஞர்களுக்கு ஏற்ற இஸ்ரேல் செய்திகள்",
      "world-news.description": "இளைஞர்களுக்கான சர்வதேச செய்திகள்",
      "science-news.description": "அறிவியல் கண்டுபிடிப்புகள் மற்றும் தொழில்நுட்ப கண்டுபிடிப்புகள்",
      "sports-news.description": "விளையாட்டு புதுப்பிப்புகள் மற்றும் போட்டி முடிவுகள்",
      "music-culture.description": "இசை உலகம், கலைஞர்கள் மற்றும் திருவிழாக்கள்",
      "film-culture.description": "சினிமா, தொடர்கள் மற்றும் விமர்சனங்கள்",
      "art-culture.description": "கலை, கேலரிகள் மற்றும் படைப்பாற்றல்",
      "food-culture.description": "சமையல், சமையல் குறிப்புகள் மற்றும் உணவு கலாச்சாரம்",
      "study-help.description": "தேர்வுகள், சுருக்கங்கள் மற்றும் தேர்வுத் தயாரிப்பில் உதவி",
      "career-prep.description": "பல்கலைக்கழகம் மற்றும் தொழில் தயாரிப்பு",
      "life-skills.description": "வாழ்க்கைத் திறன்கள், பண மேலாண்மை மற்றும் சுதந்திரம்",
      "teen-movies.description": "இளைஞர்களுக்கு பரிந்துரைக்கப்பட்ட திரைப்படங்கள்",
      "teen-series.description": "இளைஞர்களுக்கான பிரபலமான தொடர்கள்",
      "gaming.description": "வீடியோ விளையாட்டுகள், ஈ-ஸ்போர்ட்ஸ் மற்றும் கேமிங்",
      "coding.description": "நிரலாக்கம், குறியீட்டு மற்றும் மென்பொருள் உருவாக்கம்",
      "gadgets.description": "கேஜெட்கள், தொழில்நுட்பம் மற்றும் விமர்சனங்கள்",
      "bar-bat-mitzvah.description": "பார்/பாட் மிட்ஸ்வா தயாரிப்பு மற்றும் கொண்டாட்டங்கள்",
      "teen-torah.description": "இளைஞர்களுக்கான தோரா வகுப்புகள் மற்றும் வாராந்திர பராஷா",
      "jewish-history.description": "யூத மக்களின் வரலாறு"
    }
  },
  "passkey": {
    "manager": {
      "title": "[ta] Passkeys",
      "subtitle": "[ta] Manage your passkeys for secure content access"
    },
    "unsupported": "[ta] Passkeys are not supported on this device",
    "fetchError": "[ta] Failed to load passkeys",
    "registerError": "[ta] Failed to register passkey",
    "deleteError": "[ta] Failed to delete passkey",
    "cancelled": "[ta] Passkey operation was cancelled",
    "noPasskeys": "[ta] No passkeys registered yet. Add one to unlock private content.",
    "unknownDevice": "[ta] Unknown Device",
    "created": "[ta] Created",
    "lastUsed": "[ta] Last used",
    "never": "[ta] Never",
    "addPasskey": "[ta] Add Passkey",
    "deleteConfirmTitle": "[ta] Delete Passkey?",
    "deleteConfirmText": "[ta] This passkey will no longer be able to unlock content. You can always add it again later.",
    "unlock": "[ta] Unlock",
    "unlockContent": "[ta] Unlock Private Content",
    "unlockDescription": "[ta] Use your passkey to access private movies and series",
    "auth": {
      "title": "[ta] Unlock Content",
      "description": "[ta] Use your fingerprint, face, or device PIN to unlock private movies and series.",
      "unlock": "[ta] Unlock with Passkey",
      "authenticating": "[ta] Authenticating...",
      "success": "[ta] Content Unlocked!",
      "cancelled": "[ta] Authentication was cancelled",
      "error": "[ta] Authentication failed. Please try again."
    },
    "qr": {
      "useQR": "[ta] Use Phone to Unlock",
      "scanWithPhone": "[ta] Scan with your phone",
      "instruction": "[ta] Open the camera on your phone and scan the QR code to authenticate",
      "error": "[ta] Failed to generate QR code",
      "expired": "[ta] QR code expired. Please try again."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "[ta] Session not found",
      "session_different_partner": "[ta] Session belongs to different partner",
      "session_invalid_status": "[ta] Session is {status}, cannot add transcript",
      "max_sessions_reached": "[ta] Maximum concurrent sessions ({limit}) reached",
      "invalid_api_key": "[ta] Invalid API key",
      "missing_api_key": "[ta] Missing {header} header",
      "capability_disabled": "[ta] Capability '{capability}' is currently disabled",
      "capability_not_enabled": "[ta] Capability '{capability}' not enabled for this partner",
      "source_language_not_supported": "[ta] Source language '{language}' not supported. Supported: {supported}",
      "target_language_not_supported": "[ta] Target language '{language}' not supported. Supported: {supported}",
      "partner_not_found": "[ta] Partner not found",
      "partner_registration_failed": "[ta] Failed to register partner",
      "no_updates_provided": "[ta] No updates provided",
      "webhook_config_failed": "[ta] Failed to configure webhook",
      "webhook_url_not_configured": "[ta] Webhook URL not configured",
      "webhook_secret_not_configured": "[ta] Webhook secret not configured",
      "search_failed": "[ta] Search failed",
      "indexing_failed": "[ta] Indexing failed",
      "detection_failed": "[ta] Detection failed",
      "explanation_failed": "[ta] Failed to get explanation",
      "reference_not_found": "[ta] Reference '{reference_id}' not found",
      "enrichment_failed": "[ta] Enrichment failed",
      "get_references_failed": "[ta] Failed to get references",
      "create_session_failed": "[ta] Failed to create session",
      "add_transcript_failed": "[ta] Failed to add transcript",
      "generate_recap_failed": "[ta] Failed to generate recap"
    }
  },
  "portal": {
    "nav": {
      "home": "முகப்பு",
      "features": "அம்சங்கள்",
      "solutions": "தீர்வுகள்",
      "pricing": "விலை நிர்ணயம்",
      "demo": "நேரடி டெமோ",
      "contact": "தொடர்பு கொள்ளவும்",
      "getStarted": "தொடங்குங்கள்"
    },
    "hero": {
      "ctaExplore": "அம்சங்களை ஆராயுங்கள்",
      "ctaDemo": "டெமோவை கோருங்கள்"
    },
    "cta": {
      "title": "தொடங்க தயாரா?",
      "subtitle": "உங்கள் வணிகத்தை மாற்ற நாங்கள் எவ்வாறு உதவ முடியும் என்பது குறித்து பேசுவோம்",
      "button": "எங்களைத் தொடர்பு கொள்ளுங்கள்"
    },
    "contactPage": {
      "title": "தொடர்பில் இருங்கள்",
      "subtitle": "எங்கள் தீர்வுகளில் ஆர்வமா? பேசுவோம்",
      "formTitle": "எங்களுக்கு ஒரு செய்தி அனுப்புங்கள்",
      "infoTitle": "தொடர்பு தகவல்",
      "form": {
        "name": "முழு பெயர்",
        "email": "மின்னஞ்சல் முகவரி",
        "company": "நிறுவனத்தின் பெயர்",
        "phone": "தொலைபேசி எண்",
        "message": "உங்கள் செய்தி",
        "messagePlaceholder": "உங்கள் தேவைகளை எங்களுக்குத் தெரிவிக்கவும்..."
      },
      "submit": "செய்தி அனுப்பு",
      "sending": "அனுப்புகிறது...",
      "success": "செய்தி வெற்றிகரமாக அனுப்பப்பட்டது! நாங்கள் விரைவில் உங்களைத் தொடர்பு கொள்வோம்.",
      "error": "செய்தி அனுப்புவதில் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
      "scheduleTitle": "அழைப்பை திட்டமிட விரும்புகிறீர்களா?",
      "scheduleSubtitle": "எங்கள் குழுவுடன் தனிப்பயனாக்கப்பட்ட டெமோவை பதிவு செய்யுங்கள்",
      "scheduleCta": "டெமோ அழைப்பை திட்டமிடுங்கள்"
    },
    "pricingPage": {
      "title": "மலிவு",
      "titleHighlight": "விலை திட்டங்கள்",
      "subtitle": "உங்கள் தேவைகளுக்கு ஏற்ற திட்டத்தைத் தேர்ந்தெடுக்கவும்",
      "comparisonTitle": "அம்சங்களின் ஒப்பீடு",
      "faqTitle": "அடிக்கடி கேட்கப்படும் கேள்விகள்",
      "faq": {
        "q1": "விலை நிர்ணயம் எவ்வாறு கணக்கிடப்படுகிறது?",
        "a1": "விலை நிர்ணயம் உங்கள் குறிப்பிட்ட தேவைகள் மற்றும் பயன்பாட்டின் அடிப்படையில் அமைந்துள்ளது. தனிப்பயனாக்கப்பட்ட மேற்கோளுக்கு எங்களைத் தொடர்பு கொள்ளுங்கள்.",
        "q2": "நான் பிறகு என் திட்டத்தை மேம்படுத்தலாமா?",
        "a2": "ஆம், நீங்கள் எந்த நேரத்திலும் மேம்படுத்தலாம். உங்கள் தரவை தடையின்றி இடம்பெயர்த்த நாங்கள் உதவுவோம்.",
        "q3": "என்ன ஆதரவு சேர்க்கப்பட்டுள்ளது?",
        "a3": "அனைத்து திட்டங்களிலும் மின்னஞ்சல் ஆதரவு சேர்க்கப்பட்டுள்ளது. தொழில்முறை மற்றும் நிறுவன திட்டங்களில் பிரத்யேக கணக்கு மேலாளர்களுடன் முன்னுரிமை ஆதரவு சேர்க்கப்பட்டுள்ளது."
      },
      "professional": {
        "name": "தொழில்முறை",
        "price": "மேற்கோளுக்கு தொடர்பு கொள்ளவும்",
        "priceNote": "தனிப்பயன் விலை நிர்ணயம்",
        "description": "மேம்பட்ட தேவைகளுடன் வளரும் வணிகங்களுக்கு",
        "cta": "மேற்கோள் பெறுங்கள்"
      },
      "enterprise": {
        "name": "நிறுவனம்",
        "price": "தனிப்பயனாக்கப்பட்ட",
        "priceNote": "அளவு அடிப்படையிலான",
        "description": "பெரிய நிறுவனங்கள் மற்றும் நிறுவன வரிசைப்படுத்தல்களுக்கு",
        "cta": "விற்பனையைத் தொடர்பு கொள்ளவும்"
      },
      "ctaTitle": "தொடங்க தயாரா?",
      "ctaSubtitle": "உங்கள் தேவைகளைப் பற்றி பேசுவோம் மற்றும் சரியான திட்டத்தைக் கண்டறியவும்",
      "ctaButton": "விற்பனையைத் தொடர்பு கொள்ளவும்"
    },
    "featuresPage": {
      "title": "சக்திவாய்ந்த",
      "titleHighlight": "அம்சங்கள்",
      "subtitle": "வெற்றி பெற உங்களுக்குத் தேவையான அனைத்தும்",
      "techSpecsTitle": "தொழில்நுட்ப விவரக்குறிப்புகள்",
      "workflowTitle": "இது எவ்வாறு செயல்படுகிறது",
      "workflow": {
        "s1": {
          "title": "இறக்குமதி",
          "description": "உங்கள் உள்ளடக்கத்தைப் பதிவேற்றி ஒழுங்கமைக்கவும்"
        },
        "s2": {
          "title": "உள்ளமைக்கவும்",
          "description": "உங்கள் விருப்பத்தேர்வுகள் மற்றும் அமைப்புகளை அமைக்கவும்"
        },
        "s3": {
          "title": "வரிசைப்படுத்தவும்",
          "description": "உங்கள் தீர்வுடன் நேரடியாகச் செல்லுங்கள்"
        },
        "s4": {
          "title": "கண்காணிக்கவும்",
          "description": "செயல்திறனைக் கண்காணித்து உகந்ததாக்கவும்"
        }
      },
      "ctaTitle": "அம்சங்களை ஆராய தயாரா?",
      "ctaSubtitle": "தனிப்பயனாக்கப்பட்ட டெமோவுடன் அனைத்து அம்சங்களையும் செயல்பாட்டில் பார்க்கவும்",
      "ctaButton": "டெமோவை திட்டமிடுங்கள்"
    },
    "demoPage": {
      "title": "எங்களைப் பார்க்கவும்",
      "titleHighlight": "தளம்",
      "subtitle": "எங்கள் தீர்வின் வலிமையை அனுபவிக்கவும்",
      "scheduleCta": "நேரடி டெமோவை திட்டமிடுங்கள்",
      "stepsTitle": "இது எவ்வாறு செயல்படுகிறது",
      "steps": {
        "analyze": {
          "title": "பகுப்பாய்வு",
          "description": "செயல்திறனைக் கண்காணித்து மேம்படுத்தவும்"
        }
      },
      "featuresTitle": "தள சிறப்பம்சங்கள்",
      "platformsTitle": "இதில் கிடைக்கும்",
      "ctaTitle": "உங்கள் தனிப்பயன் டெமோவுக்குத் தயாரா?",
      "ctaSubtitle": "உங்கள் தேவைகளுக்கு ஏற்ற தனிப்பயனாக்கப்பட்ட விளக்கத்தை திட்டமிடுங்கள்",
      "ctaButton": "டெமோவை திட்டமிடுங்கள்"
    },
    "workflow": {
      "sectionTitle": "அறிவார்ந்த பணிப்பாய்வு",
      "sectionSubtitle": "4 படிகளில் நெறிப்படுத்தப்பட்ட செயல்முறை",
      "step1": {
        "title": "அமைவு",
        "description": "உங்கள் கணக்கு மற்றும் விருப்பத்தேர்வுகளை உள்ளமைக்கவும்"
      },
      "step2": {
        "title": "தனிப்பயனாக்கவும்",
        "description": "உங்கள் தேவைகளுக்கு அமைப்புகளை தனிப்பயனாக்கவும்"
      },
      "step3": {
        "title": "வரிசைப்படுத்தவும்",
        "description": "உங்கள் தீர்வைத் தொடங்கவும்"
      },
      "step4": {
        "title": "கண்காணிக்கவும்",
        "description": "செயல்திறனைக் கண்காணித்து உகந்ததாக்கவும்"
      }
    }
  },
  "trivia": {
    "didYouKnow": "உங்களுக்குத் தெரியுமா?",
    "dismissHint": "உண்மையை மூடவும்",
    "settings": {
      "displayLanguages": "காட்சி மொழிகள்",
      "languageHint": "ஒவ்வொரு உண்மைக்கும் 1-3 மொழிகளைத் தேர்ந்தெடுக்கவும்",
      "language": "மொழி",
      "selectLanguage": "இந்த மொழியைத் தேர்ந்தெடுக்கவும்",
      "deselectLanguage": "இந்த மொழியை நீக்கவும்",
      "enableDescription": "[ta] Show trivia questions while watching content.",
      "enableTrivia": "[ta] Enable Trivia",
      "title": "[ta] Trivia Settings"
    },
    "aiTrivia": "AI அறிவுத்திறன்",
    "tellMeMore": "மேலும் சொல்லுங்கள்",
    "more": "மேலும்",
    "follow_up": "தொடர்ந்து"
  },
  "auth": {
    "loginRequired": "[ta] Login Required",
    "loginToWatch": "[ta] Please sign in to watch {{title}}",
    "login": "[ta] Login",
    "signUp": "[ta] Sign Up",
    "biometricEnrollEnable": "[ta] Enable",
    "biometricEnrollMessage": "[ta] Use Face ID or fingerprint for faster sign-in next time.",
    "biometricEnrollSkip": "[ta] Skip",
    "biometricEnrollTitle": "[ta] Enable Biometric Sign-In",
    "biometricSignIn": "[ta] Sign in with Biometrics",
    "signOut": "[ta] Sign Out",
    "register": {
      "createAccount": "கணக்கை உருவாக்கு",
      "email": "மின்னஞ்சல்",
      "password": "கடவுச்சொல்",
      "confirmPassword": "கடவுச்சொல்லை உறுதிப்படுத்து",
      "register": "பதிவு செய்",
      "alreadyHaveAccount": "ஏற்கனவே கணக்கு உள்ளதா? உள்நுழையவும்",
      "passwordStrength": {
        "weak": "பலவீனமான",
        "medium": "நடுத்தரமான",
        "strong": "வலுவான"
      }
    }
  },
  "recording": {
    "stop": "பதிவை நிறுத்து",
    "start": "பதிவைத் தொடங்கு"
  },
  "discover": {
    "title": "[ta] Discover",
    "subtitle": "19 AI-சார்ந்த அம்சங்களை ஆராயுங்கள்",
    "description": "Bayit+ உங்கள் பார்வை, கேட்கும் மற்றும் கற்றல் அனுபவத்தை மேம்படுத்த AI பயன்படுத்துகிறது. உங்கள் தளத்தில் என்ன கிடைக்கிறது என்பதைக் கண்டறியுங்கள்.",
    "featureCount": "{{count}} அம்சங்கள்",
    "tryIt": "முயற்சி செய்க",
    "startWalkthrough": "வழிகாட்டுதலைத் தொடங்கு",
    "availableOn": "இதில் கிடைக்கும்",
    "prerequisites": "முன்தேவைகள்",
    "setup": "அமைக்கவும்",
    "error": {
      "fetchFailed": "Discover அம்சங்களை ஏற்றுவதில் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
      "unknownFeature": "அம்சம் கண்டறியப்படவில்லை.",
      "featureDisabled": "இந்த அம்சம் தற்போது முடக்கப்பட்டுள்ளது."
    },
    "availability": {
      "ready": "தயார்",
      "setupNeeded": "அமைப்பு தேவை",
      "premiumRequired": "பிரீமியம் தேவை",
      "notAvailable": "கிடைக்கவில்லை",
      "platformOnly": "மற்ற தளம்"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "திரைப்படங்கள் பார்க்கவும்",
      "watching_live_tv": "நேரடி தொலைக்காட்சி பார்க்கவும்",
      "learn_hebrew": "ஹீப்ரு கற்கவும்",
      "search_discovery": "தேடல் & கண்டுபிடிப்பு",
      "chat_assistants": "சாட் உதவியாளர்கள்"
    },
    "feature": {
      "pause_ask": {
        "name": "நிறுத்தி கேளுங்கள்",
        "tagline": "எந்த காட்சியையும் நிறுத்தி உங்கள் AI தோழரிடம் கேளுங்கள்",
        "description": "பார்க்கும்போது, வீடியோவை நிறுத்தி தற்போதைய காட்சியைப் பற்றி கேள்விகள் கேளுங்கள். உங்கள் AI கதாபாத்திரம் கலாச்சார குறிப்புகளை விளக்கும், உரையாடலை மொழிபெயர்க்கும் அல்லது கதைப்பகுதியை விவாதிக்கும்."
      },
      "interactive_subtitles": {
        "name": "ஊடாடும் வசனங்கள்",
        "tagline": "உடனடி மொழிபெயர்ப்பு மற்றும் சூழலுக்காக எந்த வசன வார்த்தையையும் தட்டுங்கள்",
        "description": "வசனங்களில் எந்த வார்த்தையிலும் கிளிக் செய்து அதன் மொழிபெயர்ப்பு பார்க்கவும், உச்சரிப்பு கேட்கவும் மற்றும் பயன்பாட்டு எடுத்துக்காட்டுகளைப் பெறவும். உங்கள் விருப்பமான நிகழ்ச்சிகள் பார்க்கும்போது சொல்வளம் உருவாக்குங்கள்."
      },
      "vocabulary": {
        "name": "சொல்வளம் கட்டுவோம்",
        "tagline": "நீங்கள் பார்க்கும் நிகழ்ச்சிகளிலிருந்து புதிய வார்த்தைகளைக் கற்கவும்",
        "description": "வசனங்களிலிருந்து தானாக புதிய ஹீப்ரு வார்த்தைகளை சேகரிக்கவும். ஃப்ளாஷ்கார்டுகளை மதிப்பாய்வு செய்யவும், முன்னேற்றத்தை கண்காணிக்கவும், நீங்கள் விரும்பும் உள்ளடக்கத்தின் மூலம் சொல்வளம் உருவாக்குங்கள்."
      },
      "vod_moments": {
        "name": "VOD தருணங்கள்",
        "tagline": "உங்கள் விருப்பமான உள்ளடக்கத்திலிருந்து AI-தேர்ந்தெடுத்த சிறந்த தருணங்கள்",
        "description": "திரைப்படங்கள் மற்றும் நிகழ்ச்சிகளிலிருந்து AI-உருவாக்கிய சிறந்த கிளிப்கள் மற்றும் முக்கிய தருணங்களைப் பெறுங்கள். நினைவில் நிற்கும் காட்சிகளை பகிரவும் மற்றும் சிறந்த பகுதிகளை மீண்டும் பார்க்கவும்."
      },
      "cultural_context": {
        "name": "கலாச்சார சூழல்",
        "tagline": "ஒவ்வொரு காட்சிக்கும் பின்னால் உள்ள கலாச்சார பின்னணியை புரிந்துகொள்ளுங்கள்",
        "description": "நீங்கள் பார்க்கும் உள்ளடக்கத்தில் தோன்றும் இஸ்ரேலி வழக்கங்கள், விழாக்கள், நகைச்சுவை மற்றும் சமூக நடைமுறைகளை விளக்கும் நிகழ்நேர கலாச்சார குறிப்புகளைப் பெறுங்கள்."
      },
      "bilingual_bridge": {
        "name": "இருமொழி பாலம்",
        "tagline": "பார்க்கும்போது ஹீப்ரு-தமிழில் பக்கவாட்டில் கற்கவும்",
        "description": "முன்னிலைப்படுத்தப்பட்ட சொல்வளத்துடன் இரட்டை மொழி வசனங்களைப் பாருங்கள். இயல்பாகவே புரிதலை வளர்க்க ஹீப்ருவுக்கும் உங்கள் தாய்மொழிக்கும் இடையில் மாறுங்கள்."
      },
      "ai_companion": {
        "name": "AI தோழர்",
        "tagline": "இஸ்ரேலி உள்ளடக்கத்தில் உங்கள் தனிப்பட்ட AI வழிகாட்டி",
        "description": "உங்களுடன் பார்க்கும் ஒரு AI கதாபாத்திரம், கருத்துரைகள் வழங்கி, கேள்விகளுக்கு பதில் அளித்து, இஸ்ரேலி ஊடகத்தின் நுணுக்கங்களை புரிந்துகொள்ள உதவுகிறது."
      },
      "live_dubbing": {
        "name": "நேரடி குரல் மாற்றம்",
        "tagline": "நேரடி இஸ்ரேலி தொலைக்காட்சி சேனல்களின் நிகழ்நேர AI குரல் மாற்றம்",
        "description": "உங்கள் விருப்பமான மொழியில் AI-இயக்கும் நிகழ்நேர குரல் மாற்றத்துடன் நேரடி இஸ்ரேலி தொலைக்காட்சி பாருங்கள். மொழி தடைகள் இல்லாமல் செய்திகள், பேச்சு நிகழ்ச்சிகள் மற்றும் பொழுதுபோக்கை அனுபவியுங்கள்."
      },
      "live_subtitles": {
        "name": "நேரடி வசனங்கள்",
        "tagline": "நேரடி ஒளிபரப்புகளுக்கு நிகழ்நேர AI வசனங்கள்",
        "description": "நேரடி இஸ்ரேலி தொலைக்காட்சி பார்க்கும்போது நிகழ்நேரத்தில் AI-உருவாக்கிய வசனங்களைப் பெறுங்கள். நேரடி உள்ளடக்கத்தை உடனடியாக மொழிபெயர்க்க உங்கள் விருப்பமான மொழியை தேர்ந்தெடுங்கள்."
      },
      "live_trivia": {
        "name": "நேரடி வினாட்டி",
        "tagline": "நேரடியில் ஒளிபரப்பாவதன் அடிப்படையில் வினாட்டி விளையாடுங்கள்",
        "description": "AI நேரடி ஒளிபரப்புகளிலிருந்து தலைப்புகளை கண்டறிந்து நிகழ்நேரத்தில் வினாட்டி கேள்விகளை உருவாக்குகிறது. நண்பர்களுடன் போட்டியிடுங்கள் மற்றும் தொலைக்காட்சி பார்க்கும்போது இஸ்ரேலி கலாச்சாரத்தைப் பற்றி அறியுங்கள்."
      },
      "catch_up": {
        "name": "தொடர்ந்து பார்க்கவும்",
        "tagline": "நேரடி தொலைக்காட்சியில் நீங்கள் தவறவிட்டதின் AI சுருக்கங்கள்",
        "description": "நேரடி ஒளிபரப்பின் ஒரு பகுதியை தவறவிட்டீர்களா? என்ன நடந்தது என்று உங்களுக்கு புரிய வைக்கும் AI-உருவாக்கிய சுருக்கங்களைப் பெறுங்கள், விரைவு மதிப்பாய்வுக்கு முக்கிய தருணங்கள் முன்னிலைப்படுத்தப்பட்டுள்ளன."
      },
      "scene_search": {
        "name": "காட்சி தேடல்",
        "tagline": "அனைத்து உள்ளடக்கங்களிலும் குறிப்பிட்ட காட்சிகளை தேடுங்கள்",
        "description": "நீங்கள் நினைவில் வைத்திருக்கும் ஒரு காட்சியை விவரிக்கவும், AI அதை அனைத்து கிடைக்கும் உள்ளடக்கங்களிலும் கண்டுபிடிக்கும். உரையாடல், காட்சி கூறுகள் அல்லது கதைப்பகுதி விவரணங்கள் மூலம் தேடுங்கள்."
      },
      "phonetic_mirror": {
        "name": "ஒலிப்பு கண்ணாடி",
        "tagline": "AI கருத்துரையுடன் ஹீப்ரு உச்சரிப்பை பயிற்சி செய்யுங்கள்",
        "description": "ஹீப்ரு பேசும்போது உங்களை பதிவு செய்து உச்சரிப்பில் உடனடி AI கருத்துரையைப் பெறுங்கள். உங்கள் பேச்சை தாய்மொழி பேசுவோரிடம் ஒப்பிட்டு காலப்போக்கில் முன்னேற்றத்தை கண்காணிக்கவும்."
      },
      "talk_back": {
        "name": "திரும்பி பேசுங்கள்",
        "tagline": "உங்கள் AI கதாபாத்திரத்துடன் ஹீப்ருவில் குரல் உரையாடல்கள் நடத்துங்கள்",
        "description": "உங்கள் AI கதாபாத்திரத்துடன் பேசி உரையாடல் ஹீப்ருவை பயிற்சி செய்யுங்கள். இயல்பான உரையாடலில் இலக்கணம், சொல்வளம் மற்றும் உச்சரிப்பில் நிகழ்நேர கருத்துரையைப் பெறுங்கள்."
      },
      "interactive_mission": {
        "name": "ஊடாடும் பணிகள்",
        "tagline": "AI வழிகாட்டுதலுடன் வேடிக்கையான ஹீப்ரு கற்றல் சவால்கள்",
        "description": "உள்ளடக்கம் பார்ப்பதை ஹீப்ரு கற்றல் பயிற்சிகளுடன் இணைக்கும் AI-வழிகாட்டப்பட்ட பணிகளை நிறைவு செய்யுங்கள். பரிசுகளை வெல்லுங்கள் மற்றும் உங்கள் மொழி பயணத்தை கண்காணிக்கவும்."
      },
      "glossary": {
        "name": "தனிப்பட்ட சொல்லகராதி",
        "tagline": "உள்ளடக்கத்திலிருந்து கட்டமைக்கப்பட்ட உங்கள் தனிப்பயன் ஹீப்ரு அகராதி",
        "description": "நீங்கள் சந்தித்த மற்றும் சேமித்த அனைத்து ஹீப்ரு வார்த்தைகளும், வகை, அதிர்வெண் மற்றும் தேர்ச்சி நிலையின்படி ஒழுங்கமைக்கப்பட்டுள்ளன. எந்த நேரத்திலும் மதிப்பாய்வு செய்யவும் பயிற்சி செய்யவும்."
      },
      "llm_search": {
        "name": "AI தேடல்",
        "tagline": "இயல்பு மொழி வினவல்களுடன் உள்ளடக்கம் கண்டுபிடியுங்கள்",
        "description": "இயல்பு மொழியைப் பயன்படுத்தி முழு Bayit+ நூலகத்தையும் தேடுங்கள். 'குடும்பத்தைப் பற்றிய வேடிக்கையான இஸ்ரேலி நகைச்சுவை' அல்லது 'தெல் அவீவ் பற்றிய ஆவணப்படங்கள்' கேளுங்கள் மற்றும் AI-தேர்ந்தெடுத்த முடிவுகளைப் பெறுங்கள்."
      },
      "proactive_voice": {
        "name": "செயலில் குரல்",
        "tagline": "உங்கள் தேவைகளை முன்கூட்டியே அறிந்து செயல்படும் குரல்-முதல் AI உதவியாளர்",
        "description": "நீங்கள் பார்ப்பதன் அடிப்படையில் தொடர்புடைய உள்ளடக்க பரிந்துரைகள், மொழிபெயர்ப்புகள் மற்றும் கற்றல் வாய்ப்புகளை முன்முயற்சியாக வழங்கும் AI உதவியாளர்."
      },
      "chatbot": {
        "name": "பயித் அரட்டை",
        "tagline": "இஸ்ரேலி உள்ளடக்கம் தொடர்பான எதையும் AI உடன் அரட்டையடியுங்கள்",
        "description": "இஸ்ரேலி கலாச்சாரத்தைப் பற்றி கேள்விகள் கேளுங்கள், உள்ளடக்க பரிந்துரைகள் பெறுங்கள், ஹீப்ரு பயிற்சி செய்யுங்கள், அல்லது நீங்கள் பார்த்தது பற்றி விவாதிக்கவும். உங்கள் AI தோழர் எப்போதும் கிடைக்கும்."
      }
    },
    "prereq": {
      "avatar": "உங்கள் AI கதாபாத்திரத்தை உருவாக்குங்கள்",
      "subscription": "பிரீமியம் சந்தா தேவை",
      "microphone": "மைக்ரோஃபோன் அணுகல் தேவை",
      "contentType": "உங்கள் உள்ளடக்க விருப்பங்களை தேர்ந்தெடுங்கள்",
      "preference": "உங்கள் மொழி விருப்பங்களை அமைக்கவும்",
      "voiceClone": "உங்கள் குரல் நகலை அமைக்கவும்"
    },
    "walkthrough": {
      "tryItNow": "[ta] Try it now",
      "watchDemo": "[ta] Watch demo",
      "skip": "[ta] Skip",
      "next": "[ta] Next",
      "done": "[ta] Done",
      "complete": "[ta] Walkthrough complete",
      "stepCounter": "[ta] {{current}} of {{total}}",
      "pause_ask": {
        "step1": "[ta] Navigate to a movie with interactive moments",
        "step2": "[ta] Pause the movie during a scene",
        "step3": "[ta] Tap the Ask a Character button",
        "step4": "[ta] Watch the character respond to you"
      },
      "interactive_subtitles": {
        "step1": "[ta] Start playing a movie with subtitles",
        "step2": "[ta] Tap the Interactive button in the control bar",
        "step3": "[ta] Select your subtitle language",
        "step4": "[ta] Tap any word in the subtitles to learn more"
      },
      "vocabulary": {
        "step1": "[ta] Open a movie with interactive subtitles enabled",
        "step2": "[ta] Tap a word you want to learn",
        "step3": "[ta] Tap Save to Vocabulary",
        "step4": "[ta] Review your saved words in the Vocabulary section"
      },
      "vod_moments": {
        "step1": "[ta] Start watching a movie with interactive moments",
        "step2": "[ta] Wait for an interactive prompt to appear",
        "step3": "[ta] See the AI-generated interaction"
      },
      "cultural_context": {
        "step1": "[ta] Play a movie with Hebrew dialogue",
        "step2": "[ta] Tap on a subtitle with cultural significance",
        "step3": "[ta] Read the AI-generated cultural explanation"
      },
      "bilingual_bridge": {
        "step1": "[ta] Open a movie with bilingual support",
        "step2": "[ta] Select the bilingual subtitle mode",
        "step3": "[ta] Tap a highlighted phrase to see the translation",
        "step4": "[ta] Watch both languages side by side"
      },
      "ai_companion": {
        "step1": "[ta] Start watching any movie",
        "step2": "[ta] Tap the AI Companion button",
        "step3": "[ta] Type a question about the movie",
        "step4": "[ta] Read the contextual AI response"
      },
      "live_dubbing": {
        "step1": "[ta] Navigate to a live TV channel",
        "step2": "[ta] Tap the dubbing button in the control bar",
        "step3": "[ta] Select your preferred language",
        "step4": "[ta] Listen to the real-time AI dubbing"
      },
      "live_subtitles": {
        "step1": "[ta] Navigate to a live TV channel",
        "step2": "[ta] Tap the subtitles button",
        "step3": "[ta] Select your subtitle language",
        "step4": "[ta] Watch the real-time subtitles appear"
      },
      "live_trivia": {
        "step1": "[ta] Navigate to a live TV channel",
        "step2": "[ta] Tap the trivia button",
        "step3": "[ta] Answer the AI-generated questions"
      },
      "catch_up": {
        "step1": "[ta] Navigate to a live broadcast",
        "step2": "[ta] Select the catch-up option",
        "step3": "[ta] Tap to generate an AI summary",
        "step4": "[ta] Read the summary of what you missed"
      },
      "scene_search": {
        "step1": "[ta] Navigate to a recorded broadcast",
        "step2": "[ta] Type what you are looking for",
        "step3": "[ta] Tap on the matching scene",
        "step4": "[ta] Watch the scene from that point"
      },
      "phonetic_mirror": {
        "step1": "[ta] Open the Phonetic Mirror in Zeh Ani",
        "step2": "[ta] Read the Hebrew phrase shown",
        "step3": "[ta] Speak the phrase into your microphone",
        "step4": "[ta] Review the AI pronunciation feedback"
      },
      "talk_back": {
        "step1": "[ta] Open Talk Back in Zeh Ani",
        "step2": "[ta] Listen to your avatar speak Hebrew",
        "step3": "[ta] Respond in Hebrew using your microphone",
        "step4": "[ta] Review the AI feedback on your response"
      },
      "interactive_mission": {
        "step1": "[ta] Open Interactive Missions",
        "step2": "[ta] Select a mission level",
        "step3": "[ta] Follow the AI-guided exercises",
        "step4": "[ta] Complete the mission and earn rewards"
      },
      "glossary": {
        "step1": "[ta] Open the Hebrew Glossary",
        "step2": "[ta] Search for a Hebrew word",
        "step3": "[ta] Listen to the pronunciation"
      },
      "llm_search": {
        "step1": "[ta] Open the Search tab",
        "step2": "[ta] Type a natural language query",
        "step3": "[ta] Browse the AI-curated results"
      },
      "proactive_voice": {
        "step1": "[ta] Open the Voice Suggestions feature",
        "step2": "[ta] Tap and hold to speak",
        "step3": "[ta] Hear the personalized recommendations"
      },
      "chatbot": {
        "step1": "[ta] Open the AI Assistant",
        "step2": "[ta] Type your question or request",
        "step3": "[ta] Read the AI response"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "[ta] Bring Your Own Content",
      "subtitle": "[ta] Connect your IPTV, Plex, or YouTube sources and enjoy Bayit+ AI features on your own content",
      "connectButton": "[ta] Connect Sources",
      "aiFeatures": {
        "dubbing": "[ta] AI Dubbing available",
        "subtitles": "[ta] Live Subtitles available"
      }
    },
    "pageSubtitle": "உங்கள் சொந்த உள்ளடக்கத்தை கொண்டு வாருங்கள் - IPTV மற்றும் ஸ்ட்ரீமிங் மூலங்களை சேர்க்கவும்",
    "addSource": "மூலத்தை சேர்க்கவும்",
    "sync": "ஒத்திசைவு",
    "remove": "அகற்று",
    "channelCount": "{{count}} சேனல்கள்",
    "empty": {
      "title": "எந்த மூலமும் சேர்க்கப்படவில்லை",
      "subtitle": "Bayit+ உடன் உங்கள் சொந்த உள்ளடக்கத்தை பார்க்க உங்கள் IPTV, Xtream அல்லது ஸ்ட்ரீமிங் மூலங்களை சேர்க்கவும்"
    },
    "source": {
      "iptv": "IPTV மூலம்",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "IPTV மூலத்தை சேர்க்கவும்",
      "subtitle": "M3U அல்லது M3U8 பிளேலிஸ்ட் கோப்பிற்கான URL ஐ உள்ளிடவும்",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "சரிபார்க்கவும்",
      "add": "மூலத்தை சேர்க்கவும்"
    },
    "addXtream": {
      "title": "Xtream Codes இணைக்கவும்",
      "subtitle": "உங்கள் Xtream Codes சர்வர் நற்சான்றிதழ்களை உள்ளிடவும்",
      "serverUrl": "சர்வர் URL",
      "username": "பயனர்பெயர்",
      "password": "கடவுச்சொல்",
      "connect": "இணைக்கவும்"
    },
    "preview": {
      "title": "முன்னோட்டம்",
      "channelCount": "{{count}} சேனல்கள் கண்டுபிடிக்கப்பட்டன"
    },
    "providers": {
      "title": "பிரபலமான வழங்குநர்கள்"
    },
    "wizard": {
      "step1": "மூலத்தை சேர்க்கவும்",
      "step2": "செயலாக்கம்",
      "step3": "மதிப்பாய்வு",
      "selectSource": "மூல வகையை தேர்ந்தெடுக்கவும்"
    },
    "normalization": {
      "title": "உங்கள் உள்ளடக்கம் செயலாக்கப்படுகிறது",
      "total": "மொத்தம் {{count}} சேனல்கள்",
      "matched": "{{count}} பொருந்தின",
      "stage": {
        "parsing": "பிளேலிஸ்ட் பகுப்பாய்வு செய்யப்படுகிறது...",
        "matching": "சேனல்கள் பொருத்தப்படுகின்றன...",
        "enriching": "மெட்டாடேட்டா செறிவூட்டப்படுகிறது...",
        "finalizing": "இறுதிப்படுத்தப்படுகிறது..."
      }
    },
    "review": {
      "title": "இறக்குமதி செய்யப்பட்ட உள்ளடக்கத்தை மதிப்பாய்வு செய்யவும்",
      "subtitle": "{{matched}} பொருந்தின, {{unmatched}} சேனல்கள் பொருந்தவில்லை",
      "matchedChannels": "பொருந்திய சேனல்கள்",
      "unmatchedChannels": "பொருந்தாத சேனல்கள்",
      "apply": "பயன்படுத்து மற்றும் இறக்குமதி செய்"
    },
    "error": {
      "urlRequired": "தயவுசெய்து URL ஐ உள்ளிடவும்",
      "noChannels": "இந்த பிளேலிஸ்டில் சேனல்கள் எதுவும் கண்டுபிடிக்கப்படவில்லை",
      "invalidUrl": "இந்த URL இலிருந்து பிளேலிஸ்டை ஏற்ற முடியவில்லை",
      "allFieldsRequired": "அனைத்து புலங்களும் தேவை",
      "enrichFailed": "மூலத்தை பகுப்பாய்வு செய்ய முடியவில்லை",
      "syncFailed": "மூலத்தை ஒத்திசைக்க முடியவில்லை",
      "normalizationFailed": "உள்ளடக்க செயலாக்கம் தோல்வியடைந்தது",
      "normalizationPollFailed": "செயலாக்கத்தின் போது இணைப்பு துண்டிக்கப்பட்டது"
    },
    "plex": {
      "connectPlex": "Plex இணைக்கவும்",
      "enterCodeAt": "இந்தக் குறியீட்டை உள்ளிடவும்",
      "waitingForAuth": "அங்கீகாரத்திற்காக காத்திருக்கிறது...",
      "selectServer": "Plex சர்வரைத் தேர்ந்தெடுக்கவும்",
      "connecting": "{{serverName}}-க்கு இணைக்கிறது...",
      "connected": "இணைக்கப்பட்டது",
      "label": "Plex"
    },
    "settings": {
      "title": "உங்கள் உள்ளடக்க ஆதாரங்கள்",
      "refresh": "புதுப்பி",
      "noSources": "உள்ளடக்க ஆதாரங்கள் எதுவும் இணைக்கப்படவில்லை",
      "noSourcesSubtitle": "உங்கள் Plex, YouTube, IPTV அல்லது Xtream வழங்குநரை இணைக்கவும்",
      "removeSource": "ஆதாரத்தை நீக்கு",
      "plexSubtitle": "உங்கள் Plex மீடியா சர்வரிலிருந்து ஸ்ட்ரீம் செய்யவும்",
      "youtubeSubtitle": "உங்கள் YouTube நூலகத்தை அணுகவும்",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "M3U பிளேலிஸ்ட் அல்லது Xtream குறியீடுகளைச் சேர்க்கவும்",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Bayit+-க்கு வரவேற்கிறோம்",
      "subtitle": "இஸ்ரேலிய உள்ளடக்கம், கலாச்சாரம் மற்றும் மொழி கற்றலுக்கான உங்கள் AI-இயங்கும் நுழைவாயில்",
      "getStarted": "தொடங்குங்கள்"
    },
    "highlight": {
      "dubbing": "நேரடி AI டப்பிங்",
      "subtitles": "ஊடாடும் வசனங்கள்",
      "ai": "AI தோழர்கள்",
      "learning": "ஹீப்ரு கற்றல்"
    },
    "voice": {
      "title": "குரல் அமைப்பு",
      "subtitle": "குரல் கட்டளைகள், ஹீப்ரு உச்சரிப்பு பயிற்சி மற்றும் கைகளில்லாத வழிசெலுத்தலுக்கு உங்கள் மைக்ரோஃபோனை இயக்குங்கள்",
      "enable": "மைக்ரோஃபோனை இயக்கு",
      "granted": "மைக்ரோஃபோன் வெற்றிகரமாக இயக்கப்பட்டது"
    },
    "tour": {
      "done": "முடிந்தது"
    },
    "demo": {
      "dubbing": {
        "title": "நேரடி AI டப்பிங்",
        "description": "உங்கள் விருப்பமான மொழியில் நிகழ்நேர AI டப்பிங்குடன் இஸ்ரேலிய தொலைக்காட்சி பாருங்கள்",
        "hebrew": "ஹீப்ரு",
        "english": "ஆங்கிலம்"
      },
      "subtitles": {
        "title": "ஊடாடும் வசனங்கள்",
        "description": "உடனடி மொழிபெயர்ப்பு மற்றும் உச்சரிப்புக்காக வசனங்களில் எந்த வார்த்தையையும் தட்டவும்",
        "sample": "குடும்பம் Shabbat இரவு உணவுக்காக கூடியது",
        "word": "ஷப்பாத்",
        "translation": "சபத் - வாராந்திர ஓய்வு நாள்"
      },
      "interaction": {
        "title": "AI கதாபாத்திர தொடர்பு",
        "description": "எந்த காட்சியையும் இடைநிறுத்தி கலாச்சார சூழல் பற்றி உங்கள் AI தோழரிடம் கேளுங்கள்",
        "userMsg": "அவர்கள் என்ன திருவிழா கொண்டாடுகிறார்கள்?",
        "aiMsg": "அவர்கள் Sukkot, கூடாரத் திருவிழா கொண்டாடுகிறார்கள். நீங்கள் பார்க்கும் தற்காலிக குடிசை sukkah என்று அழைக்கப்படுகிறது."
      },
      "trivia": {
        "title": "நேரடி ட்ரிவியா",
        "description": "AI நேரலையில் ஒளிபரப்பாகும் உள்ளடக்கத்திலிருந்து ட்ரிவியா கேள்விகள் உருவாக்குகிறது. போட்டியிடுங்கள் மற்றும் கற்றுக்கொள்ளுங்கள்!",
        "question": "இஸ்ரேலின் அதிகாரப்பூர்வ மொழி என்ன?",
        "optionA": "அரபிக்",
        "optionB": "ஹீப்ரு",
        "optionC": "ஆங்கிலம்"
      },
      "catchup": {
        "title": "ஸ்மார்ட் கேட்ச் அப்",
        "description": "நேரலை ஒளிபரப்பின் ஒரு பகுதியை தவறவிட்டீர்களா? AI தவறவிட்டதை சுருக்கமாக கூறுகிறது",
        "missed": "தவறவிட்டது",
        "summary": "AI சுருக்கம்",
        "live": "இப்போது நேரலை"
      },
      "byoc": {
        "title": "உங்கள் சொந்த உள்ளடக்கத்தை கொண்டு வாருங்கள்",
        "description": "உங்கள் IPTV மூலங்களை இறக்குமதி செய்து Bayit+ உள்ளடக்கத்துடன் பாருங்கள்",
        "step1": "மூலத்தை சேர்க்கவும்",
        "step2": "AI செறிவூட்டல்",
        "step3": "பாருங்கள்"
      },
      "zehAni": {
        "title": "உங்கள் AI கதாபாத்திரத்தை உருவாக்குங்கள்",
        "description": "உங்களுடன் கற்கும் தனிப்பயனாக்கப்பட்ட AI அவதாரை உருவாக்குங்கள்",
        "generated": "AI அவதார்"
      }
    }
  },
  "dm": {
    "title": "செய்திகள்",
    "conversations": "உரையாடல்கள்",
    "conversation": "உரையாடல்",
    "empty": {
      "title": "இன்னும் செய்திகள் இல்லை",
      "subtitle": "ஒரு நண்பருடன் உரையாடலை தொடங்குங்கள்"
    },
    "input": {
      "placeholder": "ஒரு செய்தி தட்டச்சு செய்யுங்கள்...",
      "send": "அனுப்பு"
    },
    "translate": "மொழிபெயர்",
    "react": "எதிர்வினை",
    "read": "படிக்கப்பட்டது",
    "sent": "அனுப்பப்பட்டது",
    "loadMore": "முந்தைய செய்திகளை ஏற்று",
    "startConversation": "உரையாடலை தொடங்க ஒரு செய்தி அனுப்புங்கள்",
    "reaction": {
      "like": "விரும்பு",
      "love": "காதல்",
      "laugh": "ஹாஹா",
      "surprise": "வாவ்",
      "sad": "சோகம்"
    },
    "error": {
      "fetchFailed": "செய்திகளை ஏற்றுவதில் தோல்வி",
      "sendFailed": "செய்தி அனுப்புவதில் தோல்வி"
    }
  },
  "household": {
    "empty": {
      "title": "இன்னும் ஒரு குடும்பம் இல்லை",
      "subtitle": "உங்கள் குடும்பத்தை நிர்வகிக்க ஒரு குடும்பத்தை உருவாக்குங்கள்"
    },
    "create": {
      "namePlaceholder": "குடும்ப பெயர்",
      "button": "குடும்பத்தை உருவாக்கு"
    },
    "members": "உறுப்பினர்",
    "role": {
      "owner": "உரிமையாளர்",
      "guardian": "பாதுகாவலர்",
      "child": "குழந்தை"
    },
    "invite": {
      "title": "உறுப்பினரை அழைக்குங்கள்",
      "emailPlaceholder": "மின்னஞ்சல் முகவரி",
      "send": "அழைப்பை அனுப்பு",
      "pending": "நிலுவிலுள்ள அழைப்புகள்"
    },
    "removeMember": "நீக்கு",
    "error": {
      "fetchFailed": "குடும்பத்தை ஏற்றமுடியவில்லை",
      "createFailed": "குடும்பத்தை உருவாக்கமுடியவில்லை",
      "updateFailed": "குடும்பத்தை பதிக்கமுடியவில்லை",
      "deleteFailed": "குடும்பத்தை நீக்கமுடியவில்லை",
      "inviteFailed": "அழைப்பை அனுப்பமுடியவில்லை",
      "removeFailed": "உறுப்பினரை நீக்கமுடியவில்லை"
    }
  },
  "aiChat": {
    "retryButton": "[ta] Retry",
    "sendButton": "[ta] Send",
    "title": "[ta] AI Chat",
    "voiceButton": "[ta] Voice"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "[ta] Back"
    },
    "completion": {
      "message": "[ta] You're all set! Start exploring AI features.",
      "title": "[ta] Setup Complete"
    },
    "permissions": {
      "description": "[ta] Grant permissions to enable AI features like voice and camera.",
      "title": "[ta] Permissions"
    },
    "personalization": {
      "description": "[ta] Tell us your preferences to personalize your AI experience.",
      "title": "[ta] Personalization"
    },
    "title": "[ta] AI Setup",
    "welcome": {
      "description": "[ta] Bayit+ uses AI to enhance your viewing experience with dubbing, subtitles, and more.",
      "title": "[ta] Welcome to Bayit+ AI"
    }
  },
  "auth_device_authorized": "[ta] Device authorized",
  "auth_device_code_expired": "[ta] Code expired",
  "auth_device_get_new_code": "[ta] Get new code",
  "auth_device_manual_login": "[ta] Sign in manually",
  "auth_device_visit_uri": "[ta] Visit the URL shown on your TV",
  "avatar": {
    "tapToSpeak": "[ta] Tap to speak",
    "title": "[ta] Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "[ta] Dubbed Audio",
      "originalAudio": "[ta] Original Audio",
      "title": "[ta] Audio Mixer"
    },
    "settings_title": "[ta] Dubbing Settings",
    "target_language": "[ta] Target Language",
    "voiceSelector": {
      "selected": "[ta] Selected",
      "subtitle": "[ta] Choose a voice for dubbing",
      "title": "[ta] Voice Selection"
    }
  },
  "go_back": "[ta] Go Back",
  "miniPlayer": {
    "closePlayer": "[ta] Close Player",
    "skipBackward": "[ta] Skip Backward",
    "skipForward": "[ta] Skip Forward"
  },
  "retry": "[ta] Retry",
  "search_hint": "[ta] Search channels, movies, shows...",
  "search_no_results": "[ta] No results found",
  "search_prompt": "[ta] What are you looking for?",
  "subscription_required": "[ta] Subscription Required",
  "subscription_upsell_tv": "[ta] Upgrade to watch on TV",
  "talkback": {
    "title": "[ta] Talkback"
  },
  "voiceAssistant": {
    "fabLabel": "[ta] Voice Assistant",
    "modal": {
      "cancel": "[ta] Cancel",
      "setupMessage": "[ta] Set up voice recognition to use the voice assistant.",
      "setupRequired": "[ta] Setup Required",
      "startSetup": "[ta] Start Setup",
      "title": "[ta] Voice Assistant"
    }
  },
  "voiceCommand": {
    "executing": "[ta] Executing...",
    "listening": "[ta] Listening...",
    "noMatch": "[ta] No match found",
    "recognized": "[ta] Recognized"
  },
  "voiceDecision": {
    "cancel": "[ta] Cancel",
    "confirm": "[ta] Confirm",
    "matched": "[ta] Matched"
  },
  "voiceSearch": {
    "listening": "[ta] Listening...",
    "noResults": "[ta] No results found",
    "tapToSpeak": "[ta] Tap to speak",
    "title": "[ta] Voice Search"
  },
  "voiceSettings": {
    "language": "[ta] Language",
    "speechRate": "[ta] Speech Rate",
    "title": "[ta] Voice Settings",
    "ttsProvider": "[ta] TTS Provider",
    "voiceMode": "[ta] Voice Mode",
    "voiceSelection": "[ta] Voice Selection",
    "wakeWord": "[ta] Wake Word"
  },
  "voiceWizard": {
    "buttons": {
      "back": "[ta] Back"
    },
    "calibration": {
      "description": "[ta] Speak normally to calibrate the microphone.",
      "listening": "[ta] Listening...",
      "micButton": "[ta] Start Recording",
      "resultTitle": "[ta] Calibration Result",
      "stopButton": "[ta] Stop Recording",
      "tapToStart": "[ta] Tap to start calibration",
      "title": "[ta] Microphone Calibration"
    },
    "complete": {
      "message": "[ta] Voice wizard setup is complete. You can now use voice features.",
      "title": "[ta] Setup Complete"
    },
    "language": {
      "description": "[ta] Select your preferred language for voice commands.",
      "title": "[ta] Voice Language"
    },
    "permission": {
      "description": "[ta] Microphone access is needed for voice features.",
      "granted": "[ta] Permission Granted",
      "requestButton": "[ta] Grant Permission",
      "title": "[ta] Microphone Permission"
    },
    "title": "[ta] Voice Wizard"
  },
  "watch_now": "[ta] Watch Now",
  "culture": {
    "title": "இஸ்ரேலிய கலாச்சாரம்",
    "description": "ஜெருசலேம், தெல் அவீவ் மற்றும் இஸ்ரேலிய பாரம்பரியம்",
    "shabbat": {
      "title": "ஷப்பாத் பயன்முறை",
      "enableShabbatMode": "ஷப்பாத் பயன்முறையை இயக்கு",
      "shabbatTimes": "ஷப்பாத் நேரங்கள்",
      "timesDescription": "மெழுகுவர்த்தி ஏற்றும் நேரம் மற்றும் ஹவ்தலா நேரங்கள் இங்கே காட்டப்படும்",
      "aboutTitle": "ஷப்பாத் பயன்முறை பற்றி",
      "aboutDescription": "இயக்கப்பட்டால், ஷப்பாத் பயன்முறை ஷப்பாத் நேரங்களில் அறிவிப்புகளை இடைநிறுத்தும், திரை பிரகாசத்தைக் குறைக்கும் மற்றும் எளிமையான இடைமுகத்தை இயக்கும்."
    },
    "judaism": {
      "holidaysAndTorah": "விடுமுறைகள் & தோரா",
      "parashaOfTheWeek": "வாரத்தின் பராஷா",
      "parashaDescription": "வாராந்திர தோரா வாசிப்பு மற்றும் விளக்கம்"
    },
    "morning": {
      "title": "காலை சடங்கு",
      "description": "நோக்கம் மற்றும் நன்றியுடன் உங்கள் நாளைத் தொடங்குங்கள்",
      "dailyInspiration": "தினசரி உத்வேகம்",
      "dailyInspirationDescription": "உங்கள் காலை நடைமுறைக்கான தொகுக்கப்பட்ட உள்ளடக்கம்",
      "modehAni": "மோதே அனி",
      "modehAniDescription": "காலை நன்றி பிரார்த்தனை",
      "netilatYadayim": "நெதிலாத் யாதயிம்",
      "netilatYadayimDescription": "சடங்கு கை கழுவுதல்",
      "shacharit": "ஷச்சரித்",
      "shacharitDescription": "காலை பிரார்த்தனை சேவை"
    },
    "glossary": {
      "termDetail": "சொல் விவரம்",
      "definition": "வரையறை",
      "pronunciation": "உச்சரிப்பு",
      "examples": "எடுத்துக்காட்டுகள்"
    },
    "jerusalem": {
      "title": "ஜெருசலேம்"
    },
    "telaviv": {
      "title": "தெல் அவீவ்"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "ஜே அனி",
      "biometricConsent": "பயோமெட்ரிக் ஒப்புதல்",
      "activeConsents": "{{count}} செயலில் உள்ள ஒப்புதல்கள்",
      "magicMirror": "மாயக் கண்ணாடி",
      "magicMirrorDescription": "தினசரி வாழ்த்துகள் மற்றும் முக அடையாளம்",
      "v2vPractice": "V2V பயிற்சி",
      "v2vPracticeDescription": "குரல்-க்கு-குரல் உச்சரிப்பு",
      "avatar3d": "3D அவதாரம்",
      "avatar3dDescription": "உங்கள் தனிப்பயனாக்கப்பட்ட அவதார மெஷ்",
      "movieInteractions": "திரைப்பட ஊடாடுதல்கள்",
      "movieInteractionsDescription": "திரைப்பட கதாபாத்திரங்களை உலாவி அவர்களுடன் பேசுங்கள்",
      "contacts": "தொடர்புகள்",
      "contactsDescription": "WhatsApp தொடர்புகளை பகிர்தல்",
      "feedback": "கருத்து",
      "feedbackDescription": "உங்கள் அனுபவத்தைப் பகிரவும்",
      "consent": "ஒப்புதல்",
      "consentDescription": "பயோமெட்ரிக் ஒப்புதல் மேலாண்மை",
      "chess": "செஸ்",
      "chessDescription": "நண்பர்கள் மற்றும் குடும்பத்தினருடன் செஸ் விளையாடுங்கள்"
    },
    "mirror": {
      "title": "மாயக் கண்ணாடி",
      "avatarContentDescription": "அவதாரம்",
      "wordOfTheDay": "இன்றைய சொல்",
      "playLipsync": "உதடு ஒத்திசைவை இயக்கு",
      "noAvatarYet": "இன்னும் அவதாரம் இல்லை",
      "noAvatarDescription": "கதையில் உங்களைப் பார்க்க 3D அவதாரம் உருவாக்குங்கள்",
      "createAvatar": "அவதாரம் உருவாக்கு"
    },
    "mode": {
      "title": "அவதார பயன்முறை",
      "enableAvatarMode": "அவதார பயன்முறையை இயக்கு",
      "enableDescription": "உள்ளடக்கத்திற்கு எதிர்வினையாற்றும் உங்கள் அவதாரத்தைக் காட்டு",
      "avatarPreview": "அவதார முன்னோட்டம்",
      "avatarPreviewContentDescription": "அவதார முன்னோட்டம்",
      "noAvatarConfigured": "அவதாரம் கட்டமைக்கப்படவில்லை",
      "reactionStyle": "எதிர்வினை நடை"
    },
    "wardrobe": {
      "title": "ஆடை அலமாரி",
      "equippedContentDescription": "அணிந்துள்ளது"
    },
    "settings": {
      "title": "அவதார அமைப்புகள்",
      "privacy": "தனியுரிமை",
      "privateAvatarMode": "தனிப்பட்ட அவதார பயன்முறை",
      "privateAvatarDescription": "உங்கள் அவதாரத்தை மற்ற பயனர்களிடமிருந்து மறை",
      "appearance": "தோற்றம்",
      "enableAnimations": "அசைவூட்டங்களை இயக்கு",
      "animationsDescription": "அவதார இயக்கங்கள் மற்றும் வெளிப்பாடுகளை அசைவூட்டு",
      "availableOutfits": "கிடைக்கும் ஆடைகள்"
    },
    "selfie": {
      "title": "வீடியோ செல்ஃபி",
      "camera": "கேமரா",
      "cameraPreview": "கேமரா முன்னோட்டம்",
      "startRecording": "பதிவைத் தொடங்கு",
      "stopRecording": "பதிவை நிறுத்து",
      "rec": "REC",
      "enterPin": "அவதாரம் உருவாக்க உங்கள் PIN ஐ உள்ளிடவும்",
      "pinLabel": "PIN",
      "retake": "மீண்டும் எடு",
      "creatingAvatar": "உங்கள் அவதாரம் உருவாக்கப்படுகிறது...",
      "avatarCreated": "அவதாரம் வெற்றிகரமாக உருவாக்கப்பட்டது",
      "avatarPreviewContentDescription": "அவதார முன்னோட்டம்",
      "createAnother": "மற்றொன்றை உருவாக்கு"
    },
    "mesh": {
      "title": "3D அவதாரம்",
      "meshViewer": "3D மெஷ் காட்சியாளர்",
      "meshViewerDescription": "3D மெஷ் காட்சியாளருக்கு WebView அல்லது GLSurfaceView ஒருங்கிணைப்பு தேவை",
      "skinTone": "சருமத் தொனி",
      "hairStyle": "சிகை அலங்காரம்",
      "accessories": "துணைக்கருவிகள்",
      "saveChanges": "மாற்றங்களைச் சேமி"
    },
    "v2v": {
      "title": "குரல் பயிற்சி",
      "nextPhrase": "அடுத்த சொற்றொடர்",
      "stop": "நிறுத்து",
      "record": "பதிவு செய்",
      "mic": "MIC",
      "viewProgress": "முன்னேற்றத்தைக் காண்",
      "analyzingPronunciation": "உச்சரிப்பை பகுப்பாய்வு செய்கிறது...",
      "pronunciationFeedback": "உச்சரிப்பு கருத்து",
      "similarity": "ஒற்றுமை: {{score}}%",
      "yourProgress": "உங்கள் முன்னேற்றம்",
      "transforms": "மாற்றங்கள்: {{count}}",
      "improvement": "முன்னேற்றம்: {{score}}%",
      "continuePracticing": "பயிற்சியைத் தொடரவும்"
    },
    "characters": {
      "title": "கதாபாத்திரங்கள்",
      "noCharactersFound": "இந்த திரைப்படத்திற்கு கதாபாத்திரங்கள் எதுவும் கிடைக்கவில்லை",
      "characterCount": "{{count}} கதாபாத்திரங்கள்"
    },
    "interactions": {
      "title": "திரைப்பட ஊடாடுதல்கள்",
      "noInteractableMovies": "ஊடாடக்கூடிய திரைப்படங்கள் எதுவும் கிடைக்கவில்லை"
    },
    "feedbackInbox": {
      "title": "கருத்து இன்பாக்ஸ்",
      "refreshContentDescription": "புதுப்பி",
      "noFeedbackYet": "இன்னும் கருத்து இல்லை",
      "feedbackAppearHere": "உங்கள் தொடர்புகளின் கருத்துகள் இங்கே தோன்றும்",
      "playVoiceMessage": "குரல் செய்தியை இயக்கு"
    },
    "addContact": {
      "title": "தொடர்பு சேர்",
      "nameLabel": "பெயர்",
      "phoneLabel": "தொலைபேசி",
      "relationship": "உறவு",
      "language": "மொழி"
    },
    "avatar3d": {
      "title": "3D அவதாரம்",
      "glbMeshViewer": "GLB மெஷ் காட்சியாளர்",
      "controls": "கட்டுப்பாடுகள்",
      "animate": "அசைவூட்டு",
      "vertices": "முனைகள்",
      "bones": "எலும்புகள்",
      "blendShapes": "கலவை வடிவங்கள்",
      "hasGlb": "GLB உள்ளது",
      "status": "நிலை: {{value}}"
    }
  }
}
